import { H5_PLAY_EVENT, VIDEO_STATE, KERNEL_NAME, LOG_TYPE, AD_TYPE, FullScreenMode, PLAY_EVENT, H5_EXT_EVENT, ErrorCode, getAdPlugin, H5_PAUSE_TYPE, Plugin, H5Player } from '@tencent/thumbplayer-h5';
import { __extends, __assign, __spreadArray } from 'tslib';
import { uaTool, END_STATE, Logger, commonTool, VIDEO_STATE as VIDEO_STATE$1, PLAY_EVENT as PLAY_EVENT$1, domTool, urlTool, lsTool, getEventTargetBinder, getEventEmitterBinder, PLAY_MODE } from '@tencent/thumbplayer-core';
import throttle from 'lodash.throttle';

var css_248z$1 = ".plugin_ctrl_txp_shadow{position:absolute;z-index:2;left:0;top:0;width:100%;height:100%}.plugin_ctrl_txp_shadow.txp_none{display:none}.plugin_ctrl_airplay_btn svg{-webkit-transform:scale(.9);transform:scale(.9)}.plugin_ctrl_center_btn{position:absolute;left:0;top:0;width:100%;height:100%;z-index:5;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;pointer-events:none}.plugin_ctrl_center_btn.txp_none{display:none}.plugin_ctrl_center_btn .txp_none{display:none!important}.plugin_ctrl_center_btn .btn_play{width:68px;height:68px;pointer-events:auto;cursor:pointer}.plugin_ctrl_center_btn .btn_play .icon_play{width:100%;height:100%}.plugin_ctrl_center_btn .btn_replay{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0 22px;line-height:40px;border-radius:99em;color:#fff;font-size:14px;background-color:rgba(59,59,59,.95);pointer-events:auto;cursor:pointer}.plugin_ctrl_center_btn .btn_replay .icon_replay{margin-right:4px;width:15px;height:15px;fill:#fff}.plugin_ctrl_txp_gradient_bottom{position:absolute;z-index:3;left:0;bottom:0;width:100%;height:120px;background-image:-webkit-gradient(linear,left bottom, left top,color-stop(0, rgba(0,0,0,.5)),to(transparent));background-image:linear-gradient(0deg,rgba(0,0,0,.5) 0,transparent);opacity:1;-webkit-transition:opacity .15s ease-out;transition:opacity .15s ease-out;pointer-events:none}.plugin_ctrl_txp_gradient_bottom.txp_none{display:none}.plugin_ctrl_fake_fullscreen{overflow:hidden}._mod_thumbplayer_container_:-webkit-full-screen{width:100%!important;height:100%!important}._mod_thumbplayer_container_.thumbplayer-fullscreen{width:100%!important;height:100%!important}@-webkit-keyframes txp_icon_scale{0%{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:center center;transform-origin:center center}50%{-webkit-transform:scale(1.2);transform:scale(1.2);-webkit-transform-origin:center center;transform-origin:center center}to{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:center center;transform-origin:center center}}@keyframes txp_icon_scale{0%{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:center center;transform-origin:center center}50%{-webkit-transform:scale(1.2);transform:scale(1.2);-webkit-transform-origin:center center;transform-origin:center center}to{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:center center;transform-origin:center center}}.plugin_ctrl_txp_bottom{position:absolute;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;z-index:6;bottom:0;left:0;width:100%;height:48px;line-height:1;max-width:100%;max-height:100%;overflow:initial;text-indent:0;text-align:left;white-space:normal;word-break:break-all;color:#fff;font-size:14px;font-family:PingFangSC-Regular,Helvetica Neue,Helvetica,Roboto,Microsoft Yahei,Arial,sans-serif;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-font-smoothing:antialiased;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-touch-callout:none}.plugin_ctrl_txp_bottom.txp_none{display:none}.plugin_ctrl_txp_bottom .txp_btn{position:relative;cursor:pointer;background:none;border:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;font-family:inherit}.plugin_ctrl_txp_bottom .txp_btn:hover .txp_icon{fill:#ff6022;cursor:pointer}.plugin_ctrl_txp_bottom .txp_btn_group{height:100%}.plugin_ctrl_txp_bottom .txp_icon_airplay .txp_icon_pip,.plugin_ctrl_txp_bottom .txp_icon_fake,.plugin_ctrl_txp_bottom .txp_icon_fullscreen,.plugin_ctrl_txp_bottom .txp_icon_volume,.plugin_ctrl_txp_bottom .txp_icon_volume_mute{stroke:#fff}.plugin_ctrl_txp_bottom .txp_btn:hover .txp_icon_airplay,.plugin_ctrl_txp_bottom .txp_btn:hover .txp_icon_fake,.plugin_ctrl_txp_bottom .txp_btn:hover .txp_icon_fullscreen,.plugin_ctrl_txp_bottom .txp_btn:hover .txp_icon_pip,.plugin_ctrl_txp_bottom .txp_btn:hover .txp_icon_volume,.plugin_ctrl_txp_bottom .txp_btn_fake[data-status=true] .txp_icon_fake{stroke:#ff6022}.plugin_ctrl_txp_bottom .txp_btn_pip[data-status=true] .txp_icon_pip{stroke:#ff6022;fill:#ff6022}.plugin_ctrl_txp_bottom .txp_controls{display:-webkit-box;display:-ms-flexbox;display:flex;position:absolute;bottom:0;left:0;width:100%;height:100%}.plugin_ctrl_txp_bottom *,.plugin_ctrl_txp_bottom :after,.plugin_ctrl_txp_bottom :before{margin:0;padding:0;-webkit-box-sizing:border-box;box-sizing:border-box;text-indent:0}.plugin_ctrl_txp_bottom a,.plugin_ctrl_txp_bottom a:hover,.plugin_ctrl_txp_bottom a:visited{color:#fff;text-decoration:none!important}.plugin_ctrl_txp_bottom :focus,.plugin_ctrl_txp_bottom a:active{outline:0 none}.plugin_ctrl_txp_bottom .txp_left_controls,.plugin_ctrl_txp_bottom .txp_right_controls{position:relative;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.plugin_ctrl_txp_bottom .txp_controls .txp_btn{height:100%;text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.plugin_ctrl_txp_bottom .txp_left_controls .txp_btn{margin-right:16px;text-align:center;-webkit-box-flex:0;-ms-flex:none;flex:none}.plugin_ctrl_txp_bottom .txp_left_controls .txp_btn:first-child{margin-left:16px}.plugin_ctrl_txp_bottom .txp_center_controls{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.plugin_ctrl_txp_bottom .txp_right_controls{z-index:8}.plugin_ctrl_txp_bottom .txp_right_controls .txp_btn{margin-right:16px}.plugin_ctrl_txp_bottom .txp_right_controls .txp_btn_definition,.plugin_ctrl_txp_bottom .txp_right_controls .txp_btn_language,.plugin_ctrl_txp_bottom .txp_right_controls .txp_btn_playrate{margin-right:24px}.plugin_ctrl_txp_bottom .txp_left_controls .txp_icon{display:block;margin:auto}.plugin_ctrl_txp_bottom .txp_left_controls .txp_icon_next{pointer-events:none}.plugin_ctrl_txp_bottom .txp_right_controls .txp_icon{display:block}.plugin_ctrl_txp_bottom .txp_controls .txp_tooltip{position:absolute;z-index:14;height:26px;border-radius:16px;font-size:12px;line-height:18px;display:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;top:-30px;padding:4px 12px;white-space:nowrap;background-color:rgba(0,0,0,.8);left:50%;-webkit-transform:translate(-50%);transform:translate(-50%)}.plugin_ctrl_txp_bottom .txp_controls .txp_btn_fake .txp_tooltip{left:-15px;-webkit-transform:translate(0);transform:translate(0)}.plugin_ctrl_txp_bottom .txp_controls .txp_btn_play .txp_tooltip{left:-6px;-webkit-transform:translate(0);transform:translate(0)}.plugin_ctrl_txp_bottom .txp_controls .txp_btn_next .txp_tooltip{left:-11px;-webkit-transform:translate(0);transform:translate(0)}.plugin_ctrl_txp_bottom .txp_controls .txp_btn_fullscreen .txp_tooltip{left:auto;right:-10px;-webkit-transform:translate(0);transform:translate(0)}.plugin_ctrl_txp_bottom .txp_btn_setting:hover .txp_icon_setting{-webkit-animation:txp_icon_rotate .3s ease both;animation:txp_icon_rotate .3s ease both}.plugin_ctrl_txp_bottom .txp_air_play:hover .txp_icon,.plugin_ctrl_txp_bottom .txp_btn_fake:hover .txp_icon,.plugin_ctrl_txp_bottom .txp_btn_fullscreen:hover .txp_icon,.plugin_ctrl_txp_bottom .txp_btn_pip:hover .txp_icon{-webkit-animation:txp_icon_scale .4s ease both;animation:txp_icon_scale .4s ease both}.plugin_ctrl_txp_bottom .txp_time_display{height:100%;margin-left:8px;white-space:nowrap;font-size:0;-webkit-box-flex:0;-ms-flex:none;flex:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.plugin_ctrl_txp_bottom .txp_time_display.reach_hour{margin-left:-8px}.plugin_ctrl_txp_bottom .txp_time_display.reach_hour .txp_time_current,.plugin_ctrl_txp_bottom .txp_time_display.reach_hour .txp_time_duration{width:50px}.plugin_ctrl_txp_bottom .txp_time_display.reach_hour .txp_time_current{text-align:right}.plugin_ctrl_txp_bottom .txp_time_display.reach_hour .txp_time_duration{text-align:left}.plugin_ctrl_txp_bottom .txp_time_display>div{display:inline;font-size:12px}.plugin_ctrl_txp_bottom .txp_time_display .txp_time_separator{margin:0 3px;color:hsla(0,0%,100%,.5)}.plugin_ctrl_txp_bottom .txp_time_display .txp_time_current,.plugin_ctrl_txp_bottom .txp_time_display .txp_time_duration{width:32px;text-align:center}.plugin_ctrl_txp_bottom .txp_time_display .txp_time_duration{color:hsla(0,0%,100%,.5)}.plugin_ctrl_txp_bottom .txp_time_display .txp_live_badge{position:relative;font-size:12px;display:inline;margin-top:-1px;line-height:40px;padding-left:10px;cursor:default}.plugin_ctrl_txp_bottom .txp_time_display .txp_live_badge:before{content:\"\";position:absolute;left:0;top:17px;display:inline-block;width:6px;height:6px;border-radius:100%;background-color:#ff7000}.plugin_ctrl_txp_bottom .txp_time_display .txp_live_badge_back:before{background-color:#bbb}.plugin_ctrl_txp_bottom .txp_time_display_live{margin-left:0}.plugin_ctrl_txp_bottom .txp_progress_bar_container{position:absolute;z-index:4;left:0;top:-8px;width:100%;height:8px;padding:0;vertical-align:top;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}.plugin_ctrl_txp_bottom .txp_progress_bar_container:after{content:\"\";display:block;width:100%;height:12px;position:absolute;bottom:-2px;z-index:-1}.plugin_ctrl_txp_bottom .txp_progress_bar_container:hover{z-index:9;cursor:pointer}.plugin_ctrl_txp_bottom .txp_progress_list{position:absolute;left:0;top:0;height:8px;width:100%}.plugin_ctrl_txp_bottom .txp_progress_list:after{content:\"\";position:absolute;left:0;top:0;width:100%;height:100%;background-color:hsla(0,0%,100%,.35);-webkit-transform:scaleY(.5);transform:scaleY(.5);-webkit-transition:all .15s ease;transition:all .15s ease;z-index:-1}.plugin_ctrl_txp_bottom .txp_progress_load,.plugin_ctrl_txp_bottom .txp_progress_play{position:absolute;left:0;top:0;height:100%;width:2px;background-color:#ff6429;-webkit-transform:scaleY(.5);transform:scaleY(.5);-webkit-transition:all .15s ease;transition:all .15s ease}.plugin_ctrl_txp_bottom .txp_progress_bar_container:hover .txp_progress_list:after,.plugin_ctrl_txp_bottom .txp_progress_bar_container:hover .txp_progress_load,.plugin_ctrl_txp_bottom .txp_progress_bar_container:hover .txp_progress_play,.plugin_ctrl_txp_bottom .txp_progress_bar_container:hover .txp_progress_role{-webkit-transform:scaleY(1);transform:scaleY(1)}.plugin_ctrl_txp_bottom .txp_progress_load{background-color:hsla(0,0%,100%,.5)}.plugin_ctrl_txp_bottom .txp_progress_role{position:absolute;left:0;top:0;height:100%;width:2px;background-color:rgba(178,250,77,.5);-webkit-transform:scaleY(.5);transform:scaleY(.5);-webkit-transition:all .15s ease;transition:all .15s ease}.plugin_ctrl_txp_bottom .txp_btn_scrubber{position:absolute;width:12px;height:12px;top:-2px;margin-left:-6px;cursor:pointer;-webkit-transform:scale(0);transform:scale(0);-webkit-transition:all .15s ease;transition:all .15s ease}.plugin_ctrl_txp_bottom .txp_scrubber_indicator{position:relative;width:12px;height:12px;border-radius:100%;background-color:#ff6429}.plugin_ctrl_txp_bottom .txp_scrubber_indicator:before{content:\"\";position:absolute;left:-4px;top:-4px;width:20px;height:20px;border-radius:100%;display:block;background-color:rgba(254,100,41,.3)}.plugin_ctrl_txp_bottom .txp_progress_bar_container:hover .txp_btn_scrubber{-webkit-transform:scale(1);transform:scale(1)}.plugin_ctrl_txp_bottom .txp_btn_scrubber:hover .txp_scrubber_indicator:before{width:24px;height:24px;left:-6px;top:-6px}.plugin_ctrl_txp_bottom .txp_btn_play .txp_svg_symbol{visibility:hidden;opacity:0}.plugin_ctrl_txp_bottom .txp_btn_play[data-status=pause] .txp_svg_pause,.plugin_ctrl_txp_bottom .txp_btn_play[data-status=play] .txp_svg_play,.plugin_ctrl_txp_bottom .txp_btn_play[data-status=replay] .txp_svg_replay,.plugin_ctrl_txp_bottom .txp_btn_play[data-status=stop] .txp_svg_stop{visibility:visible;opacity:1;-webkit-animation:none;animation:none}.plugin_ctrl_txp_bottom .txp_popup{position:absolute;bottom:34px;z-index:20;width:100%;padding-bottom:24px;color:#eee;cursor:default}.plugin_ctrl_txp_bottom .txp_popup_content{background-color:rgba(0,0,0,.8);border-radius:4px}.plugin_ctrl_txp_bottom .txp_popup_audio_track,.plugin_ctrl_txp_bottom .txp_popup_definition,.plugin_ctrl_txp_bottom .txp_popup_language,.plugin_ctrl_txp_bottom .txp_popup_mute_tips,.plugin_ctrl_txp_bottom .txp_popup_playrate{width:auto;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%);font-size:0}.plugin_ctrl_txp_bottom .txp_popup_audio_track .txp_popup_content,.plugin_ctrl_txp_bottom .txp_popup_definition .txp_popup_content,.plugin_ctrl_txp_bottom .txp_popup_language .txp_popup_content,.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_popup_content,.plugin_ctrl_txp_bottom .txp_popup_playrate .txp_popup_content{padding-top:10px}.plugin_ctrl_txp_bottom .txp_popup_audio_track .txp_menuitem,.plugin_ctrl_txp_bottom .txp_popup_definition .txp_menuitem,.plugin_ctrl_txp_bottom .txp_popup_language .txp_menuitem,.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_menuitem,.plugin_ctrl_txp_bottom .txp_popup_playrate .txp_menuitem{min-width:104px;position:relative;padding:10px 22px;font-size:14px;text-align:center;cursor:pointer;white-space:nowrap;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.plugin_ctrl_txp_bottom .txp_popup_audio_track .txp_menuitem:last-of-type,.plugin_ctrl_txp_bottom .txp_popup_definition .txp_menuitem:last-of-type,.plugin_ctrl_txp_bottom .txp_popup_language .txp_menuitem:last-of-type,.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_menuitem:last-of-type,.plugin_ctrl_txp_bottom .txp_popup_playrate .txp_menuitem:last-of-type{padding-bottom:20px}.plugin_ctrl_txp_bottom .txp_popup_audio_track .txp_menuitem:active,.plugin_ctrl_txp_bottom .txp_popup_audio_track .txp_menuitem:hover,.plugin_ctrl_txp_bottom .txp_popup_definition .txp_menuitem:active,.plugin_ctrl_txp_bottom .txp_popup_definition .txp_menuitem:hover,.plugin_ctrl_txp_bottom .txp_popup_language .txp_menuitem:active,.plugin_ctrl_txp_bottom .txp_popup_language .txp_menuitem:hover,.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_menuitem:active,.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_menuitem:hover,.plugin_ctrl_txp_bottom .txp_popup_playrate .txp_menuitem:active,.plugin_ctrl_txp_bottom .txp_popup_playrate .txp_menuitem:hover{color:#ff6429}.plugin_ctrl_txp_bottom .txp_popup_mute_tips{width:200px;-webkit-transform:translateX(-60%);transform:translateX(-60%)}.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_popup_content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:8px;font-size:13px}.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_popup_content .txp_text{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_popup_content svg{width:18px;height:18px;color:#fff;cursor:pointer}.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_popup_content svg:hover{color:#ff6429}.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_text_btn{color:#fe6429;cursor:pointer;-webkit-transition:color .3s;transition:color .3s}.plugin_ctrl_txp_bottom .txp_popup_mute_tips .txp_text_btn:hover{color:#fe9b75}.plugin_ctrl_txp_bottom .txp_btn .txp_label{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;padding:1px 4px;cursor:pointer;color:#ececec;white-space:nowrap;border:2px solid #fff;border-radius:4px;font-weight:700}.plugin_ctrl_txp_bottom .txp_btn .txp_label:hover{color:#ff6022;border-color:#ff6022}.plugin_ctrl_txp_bottom .txp_btn_definition{position:relative;height:100%;white-space:nowrap;text-align:center;-webkit-box-flex:0;-ms-flex:none;flex:none}.plugin_ctrl_txp_bottom .txp_volume{position:relative;display:table-cell;width:44px;height:45px;vertical-align:top;color:#fff}.plugin_ctrl_txp_bottom .txp_volume_text{padding-top:8px}.plugin_ctrl_txp_bottom .txp_btn_volume .txp_svg_symbol{display:none}.plugin_ctrl_txp_bottom .txp_btn_volume[data-status=mute] .txp_svg_volume_mute,.plugin_ctrl_txp_bottom .txp_btn_volume[data-status=normal] .txp_svg_volume{display:block}.plugin_ctrl_txp_bottom .txp_popup_volume{width:42px;-webkit-transform:translate(-50%);transform:translate(-50%);left:50%}.plugin_ctrl_txp_bottom .txp_popup_volume .txp_popup_content{overflow:hidden}.plugin_ctrl_txp_bottom .txp_volume_range{position:relative;margin:10px 19px;width:4px;height:90px;background-color:hsla(0,0%,65.1%,.5);border-radius:2px;cursor:pointer}.plugin_ctrl_txp_bottom .txp_volume_range:after{content:\"\";display:block;width:42px;height:90px;position:absolute;left:-19px;top:0}.plugin_ctrl_txp_bottom .txp_volume_range_current{position:absolute;left:0;bottom:0;width:100%;height:50%;background-color:#ff6429;border-radius:2px;z-index:1}.plugin_ctrl_txp_bottom .txp_volume_handle{position:absolute;top:-4px;left:-2px;width:8px;height:8px;background-color:#fff;border-radius:100%;cursor:pointer}.plugin_ctrl_txp_bottom .txp_volume_handle:before{content:\"\";display:block;position:absolute;left:-3px;top:-3px;width:14px;height:14px;opacity:0;-webkit-transform:scale(0);transform:scale(0);background-color:hsla(0,0%,100%,.2);border-radius:7px}.plugin_ctrl_txp_bottom .txp_volume_handle:after{content:\"\";width:32px;height:32px;display:block;position:absolute;left:-12px;top:-12px;z-index:-1;opacity:.5;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAADAUExURQAAAP+ZAP+RAP9/AP+aAP9/AP+OCP//AP9/AP+qAP+QDf+SDP+TDv+TCv+RCP+ZAP+TC/+TCP+QC/+RCv+SCf+SCv+QCv+RCv+TCf+PD/+PCP+RDP+RCf+RCv+PCf+RB/+RCv+RCf6RCv+ZEf+RC/+RCf+RC/+RC/6RCv+OB/+QC/+RC/+RCv+TC/+QC/+SC/+RC/+RCv+RCv+RCv+RC/6RCv6RCv6RCv6SCv6SCv2QC/+RCv+SCv+RC/+RCv2RCn+uAUwAAABAdFJOUwAFBwYIBAsBAgMNExEYOAoWHit4JUtXYhoQHCg1MT4gRmmHD1SlsbaUIi5BIy1DUltIb2VygY+Jm6KYrHyYuqzDURAFAAAB/klEQVQ4y6WVWZeiMBSEhQZmDAgJO7LIIrivuNv2/P9/NTdRp7VlTmfO1BMP36kKl5ui1XrQD9DPm+hzq1lXqn3TlW3mKCXLApMsU7aBpHaUehMlJvGNsq+mzE6mlKEwGZSVX0yZnSBKBkJFoIGCAiFDEgVm+oUDO4Q0FeMOCGNVQ+hq+kAyDuwCFfuE9ECE+FgNwJSRz5yCNMCmdmiCQnsKqIaURxKCKVeone4onMWRDoriWTgiHbWg5D0cDAXRQGqH2GasJ/N0tUrniR6bNpDIEIW7JQtGGnDjKEmdhQtaOGkSjYHU0Gc4GEoowF17rE+c/tKrs6z2ln1noo/tLg6QdLdsyzTYH5nRxHG9bGOBNpnnOpPIHPk0XG5fQUFSNEzCOHHcem1t8/0+31rr2nWSOCRYU6glBekJVX8609O+t37Pd8PTabjL39deP9VnU7CkL85A0SjghGC4zKx8eDiW5fEwzK1sCZZwygKyGSiISgDJ0Xzhbba7Q/mrqs7lYbfdeIt5BNmBAhNiIByx0zMhuQbD47kaDKrzESxryDZ7dELP4MrNrP2prAYfH4OqvOytzF39H/h9NO/LcI/nZeCXS/PAuT8h91Lc1ow0rRl5XDPuxeW+CtyXi/u68hfAn0pRnitFeakU7pJ6rj0E+lvt8RcpfzX/Q9l/8/v4DS6tX+XyhPN2AAAAAElFTkSuQmCC);background-size:32px 32px;pointer-events:none}.plugin_ctrl_txp_bottom .txp_volume_handle:hover:before{opacity:1;-webkit-transform:scale(1);transform:scale(1)}.plugin_ctrl_txp_bottom .txp_volume_handle:hover:after{opacity:1}.plugin_ctrl_txp_bottom .txp_right_controls .txp_btn_popup{width:24px}.plugin_ctrl_txp_bottom .txp_right_controls .txp_icon_popup{width:20px;height:20px;margin-top:0}.plugin_ctrl_txp_bottom .txp_btn_fake .txp_svg_symbol,.plugin_ctrl_txp_bottom .txp_btn_fullscreen .txp_svg_symbol{display:none}.plugin_ctrl_txp_bottom .txp_btn_fake[data-status=false] .txp_svg_fake,.plugin_ctrl_txp_bottom .txp_btn_fake[data-status=true] .txp_svg_fake_true,.plugin_ctrl_txp_bottom .txp_btn_fullscreen[data-status=false] .txp_svg_fullscreen,.plugin_ctrl_txp_bottom .txp_btn_fullscreen[data-status=true] .txp_svg_fullscreen_true{display:block}.plugin_ctrl_txp_bottom .txp_popup .txp_current{color:#ff6429}.plugin_ctrl_txp_bottom .txp_btn_loop .txp_svg_loop,.plugin_ctrl_txp_bottom .txp_btn_loop .txp_svg_loop_off{display:none}.plugin_ctrl_txp_bottom .txp_btn_loop[data-status=false] .txp_svg_loop_off,.plugin_ctrl_txp_bottom .txp_btn_loop[data-status=true] .txp_svg_loop,.plugin_ctrl_txp_bottom .txp_controls .txp_btn:hover .txp_tooltip{display:block}.plugin_ctrl_txp_bottom .txp_controls .txp_btn:visited .txp_tooltip{display:none}.plugin_ctrl_txp_bottom .txp_popup:hover{display:block}.plugin_ctrl_txp_bottom .txp_icon{position:relative;width:28px;height:28px;fill:#fff}.plugin_ctrl_txp_bottom .txp_icon:after,.plugin_ctrl_txp_bottom .txp_icon:before,.plugin_ctrl_txp_bottom .txp_icon_inner:after,.plugin_ctrl_txp_bottom .txp_icon_inner:before{content:\"\";position:absolute;-webkit-box-sizing:content-box;box-sizing:content-box}.plugin_ctrl_txp_bottom .txp_icon_inner{position:absolute;width:100%;height:100%}.plugin_ctrl_txp_bottom .txp_controls .txp_disabled{cursor:default;opacity:.5;pointer-events:none}.plugin_ctrl_txp_bottom .txp_gradient_top{display:none}.plugin_ctrl_txp_bottom .txp_btn_scrubber,.plugin_ctrl_txp_bottom .txp_progress_load,.plugin_ctrl_txp_bottom .txp_progress_play{-webkit-transition:-webkit-transform .15s ease;transition:-webkit-transform .15s ease;transition:transform .15s ease;transition:transform .15s ease, -webkit-transform .15s ease}.plugin_ctrl_txp_bottom .txp_none{display:none!important}.plugin_ctrl_txp_mode_fullscreen .txp_controls .txp_btn_fullscreen .txp_tooltip{left:auto;right:0;-webkit-transform:translate(0);transform:translate(0)}.plugin_ctrl_txp_mode_fullscreen .txp_controls .txp_btn_fake .txp_tooltip{left:-26px;-webkit-transform:translate(0);transform:translate(0)}.plugin_ctrl--large .plugin_ctrl_txp_gradient_bottom{height:100px}.plugin_ctrl--large .plugin_ctrl_txp_bottom{height:88px}.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_popup{bottom:64px}.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_left_controls .txp_btn,.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_right_controls .txp_btn{margin-right:24px}.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_left_controls .txp_btn .txp_label,.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_right_controls .txp_btn .txp_label{height:26px;font-size:16px}.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_left_controls .txp_icon,.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_right_controls .txp_icon{width:40px;height:40px}.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_left_controls .txp_time_display{margin-left:0}.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_left_controls .txp_btn:first-child{margin-left:32px}.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_right_controls .txp_btn_definition,.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_right_controls .txp_btn_language,.plugin_ctrl--large .plugin_ctrl_txp_bottom .txp_right_controls .txp_btn_playrate{margin-right:32px}.txp_interact_dot{position:absolute;top:2px;width:4px;height:4px;margin-left:-2px;border-radius:100%;background-color:#fff;-webkit-transition:all .1s;transition:all .1s}.txp_interact_dot:after{position:absolute;top:-4px;right:-4px;bottom:-4px;left:-4px;content:\"\"}.txp_interact_dot:hover{-webkit-transform:scale(2);transform:scale(2);-webkit-box-shadow:0 0 2px #ffb821;box-shadow:0 0 2px #ffb821}.txp_hotpoint_tip{color:#fff;position:relative;width:200px;bottom:60px;font-size:12px;line-height:24px;height:50px;padding:0 6px;background-color:rgba(0,0,0,.9);display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical;-webkit-line-clamp:2;word-wrap:break-word}.txp_hotpoint_tip .txp_hotpoint_tip_title{color:#bbb}.txp_hotpoint_tip .txp_hotpoint_tip_detail{max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}";

var css_248z = ".plugin_ctrl_txp_shadow{position:absolute;z-index:2;left:0;top:0;width:100%;height:100%}.plugin_ctrl_txp_shadow.txp_none{display:none}.plugin_ctrl_airplay_btn svg{-webkit-transform:scale(.9);transform:scale(.9)}.plugin_ctrl_center_btn{position:absolute;left:0;top:0;width:100%;height:100%;z-index:5;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;pointer-events:none}.plugin_ctrl_center_btn.txp_none{display:none}.plugin_ctrl_center_btn .txp_none{display:none!important}.plugin_ctrl_center_btn .btn_play{width:68px;height:68px;pointer-events:auto;cursor:pointer}.plugin_ctrl_center_btn .btn_play .icon_play{width:100%;height:100%}.plugin_ctrl_center_btn .btn_replay{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0 22px;line-height:40px;border-radius:99em;color:#fff;font-size:14px;background-color:rgba(59,59,59,.95);pointer-events:auto;cursor:pointer}.plugin_ctrl_center_btn .btn_replay .icon_replay{margin-right:4px;width:15px;height:15px;fill:#fff}.plugin_ctrl_txp_gradient_bottom{position:absolute;z-index:3;left:0;bottom:0;width:100%;height:120px;background-image:-webkit-gradient(linear,left bottom, left top,color-stop(0, rgba(0,0,0,.5)),to(transparent));background-image:linear-gradient(0deg,rgba(0,0,0,.5) 0,transparent);opacity:1;-webkit-transition:opacity .15s ease-out;transition:opacity .15s ease-out;pointer-events:none}.plugin_ctrl_txp_gradient_bottom.txp_none{display:none}.plugin_ctrl_fake_fullscreen{overflow:hidden}._mod_thumbplayer_container_:-webkit-full-screen{width:100%!important;height:100%!important}._mod_thumbplayer_container_.thumbplayer-fullscreen{width:100%!important;height:100%!important}.plugin_ctrl_mobile_txp_bottom{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:absolute;z-index:6;bottom:0;left:0;width:100%;height:40px;overflow:initial;line-height:1;max-width:100%;max-height:100%;color:#fff;font-size:14px;font-family:PingFangSC-Regular,Helvetica Neue,Helvetica,Roboto,sans-serif;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-font-smoothing:antialiased;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-touch-callout:none}.plugin_ctrl_mobile_txp_bottom.txp_none{display:none}.plugin_ctrl_mobile_txp_bottom .txp_disabled{opacity:.5;pointer-events:none}.plugin_ctrl_mobile_txp_bottom *,.plugin_ctrl_mobile_txp_bottom :after,.plugin_ctrl_mobile_txp_bottom :before{margin:0;padding:0;-webkit-box-sizing:border-box;box-sizing:border-box}.plugin_ctrl_mobile_txp_bottom a,.plugin_ctrl_mobile_txp_bottom a:hover,.plugin_ctrl_mobile_txp_bottom a:visited{color:#fff;text-decoration:none!important;pointer-events:auto}.plugin_ctrl_mobile_txp_bottom .txp_btn:active,.plugin_ctrl_mobile_txp_bottom .txp_btn:focus,.plugin_ctrl_mobile_txp_bottom a:focus{outline:0 none}.plugin_ctrl_mobile_txp_bottom .txp_icon{position:relative;display:inline-block;fill:#fff}.plugin_ctrl_mobile_txp_bottom .txp_icon:after,.plugin_ctrl_mobile_txp_bottom .txp_icon:before,.plugin_ctrl_mobile_txp_bottom .txp_icon_inner:after,.plugin_ctrl_mobile_txp_bottom .txp_icon_inner:before{content:\"\";position:absolute;-webkit-box-sizing:content-box;box-sizing:content-box}.plugin_ctrl_mobile_txp_bottom .txp_icon_inner{position:absolute;width:100%;height:100%}.plugin_ctrl_mobile_txp_bottom .txp_left_controls,.plugin_ctrl_mobile_txp_bottom .txp_right_controls{position:relative;float:left;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.plugin_ctrl_mobile_txp_bottom .txp_left_controls{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.plugin_ctrl_mobile_txp_bottom .txp_right_controls{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.plugin_ctrl_mobile_txp_bottom .txp_btn{position:relative;cursor:pointer;background:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;font-family:PingFangSC-Regular,Helvetica Neue,Helvetica,Roboto,Microsoft Yahei,Arial,sans-serif;border:none;text-align:center;-webkit-box-flex:0;-ms-flex:none;flex:none;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.plugin_ctrl_mobile_txp_bottom .txp_btn_play{width:60px;height:100%}.plugin_ctrl_mobile_txp_bottom .txp_btn_play .txp_icon_play{display:block;width:30px;height:30px;margin:auto;fill:#fff}.plugin_ctrl_mobile_txp_bottom .txp_btn_play use{display:none}.plugin_ctrl_mobile_txp_bottom .txp_btn_play.play_btn_pause .txp_svg_pause,.plugin_ctrl_mobile_txp_bottom .txp_btn_play.play_btn_play .txp_svg_play,.plugin_ctrl_mobile_txp_bottom .txp_btn_play.play_btn_replay .txp_svg_replay,.plugin_ctrl_mobile_txp_bottom .txp_btn_play.play_btn_stop .txp_svg_stop{display:block}.plugin_ctrl_mobile_txp_bottom .txp_time_display{height:100%;padding:4px 8px 0 0;white-space:nowrap;font-size:0;-webkit-box-flex:0;-ms-flex:none;flex:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.plugin_ctrl_mobile_txp_bottom .txp_time_display>div{display:inline;font-size:9px}.plugin_ctrl_mobile_txp_bottom .txp_time_display .txp_time_separator{margin:0 1px}.plugin_ctrl_mobile_txp_bottom .txp_btn_airplay,.plugin_ctrl_mobile_txp_bottom .txp_btn_fullscreen{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:45px;height:100%;-webkit-box-flex:0;-ms-flex:none;flex:none}.plugin_ctrl_mobile_txp_bottom .txp_icon_airplay,.plugin_ctrl_mobile_txp_bottom .txp_icon_fullscreen{display:block;width:30px;height:30px;margin:auto}.plugin_ctrl_mobile_txp_bottom .txp_icon_fullscreen use{display:none}.plugin_ctrl_mobile_txp_bottom .txp_btn_fullscreen[data-status=false] .txp_svg_fullscreen,.plugin_ctrl_mobile_txp_bottom .txp_btn_fullscreen[data-status=true] .txp_svg_fullscreen_true{display:block}.plugin_ctrl_mobile_txp_bottom .txp_unfullscreen .txp_btn_value{background-position:right 0}.plugin_ctrl_mobile_txp_bottom .txp_btn_fullsize{width:45px;height:100%;-webkit-box-flex:0;-ms-flex:none;flex:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.plugin_ctrl_mobile_txp_bottom .txp_btn_fullsize[data-status=false] .txp_svg_fullscreen,.plugin_ctrl_mobile_txp_bottom .txp_btn_fullsize[data-status=true] .txp_svg_fullscreen_true{display:block}.plugin_ctrl_mobile_txp_bottom .txp_unfullsize .txp_btn_value{background-position:right 0}.plugin_ctrl_mobile_txp_bottom .txp_progress_bar_container{position:relative;height:100%;padding:0;vertical-align:top;-webkit-box-flex:1000;-ms-flex:1000;flex:1000}.plugin_ctrl_mobile_txp_bottom .txp_progress_list{position:absolute;left:0;top:20px;width:100%;height:2px;background-color:rgba(31,31,31,.9);-webkit-transform:translateZ(0);transform:translateZ(0)}.plugin_ctrl_mobile_txp_bottom .txp_progress_play{position:absolute;left:0;top:0;height:100%;width:2px;background-color:#fd9000}.plugin_ctrl_mobile_txp_bottom .txp_btn_scrubber{position:absolute;width:30px;height:40px;margin-left:-10px;-webkit-transform:translateZ(0);transform:translateZ(0)}.plugin_ctrl_mobile_txp_bottom .txp_scrubber_indicator{position:absolute;top:16px;left:10px;width:10px;height:10px;border-radius:99em;background-color:#ff7000}.plugin_ctrl_mobile_txp_bottom .txp_scrubber_indicator:before{content:\"\";position:absolute;left:-4px;top:-4px;width:18px;height:18px;background-color:#ff7000;opacity:.4;border-radius:99em}.plugin_ctrl_mobile_txp_bottom .txp_btn_definition,.plugin_ctrl_mobile_txp_bottom .txp_btn_playrate{position:relative;padding:0 8px;height:44px;color:#fff;white-space:nowrap;text-align:center;-webkit-box-flex:0;-ms-flex:none;flex:none;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.plugin_ctrl_mobile_txp_bottom .txp_btn_definition .txp_label,.plugin_ctrl_mobile_txp_bottom .txp_btn_playrate .txp_label{margin:auto}.plugin_ctrl_mobile_txp_bottom .txp_btn .txp_tooltip{display:none!important}.plugin_ctrl_mobile_txp_bottom .txp_right_controls{min-width:15px}.plugin_ctrl_mobile_txp_bottom .txp_none{display:none}.plugin_ctrl_mobile_txp_bottom~video::-webkit-media-controls,.plugin_ctrl_mobile_txp_bottom~video::-webkit-media-controls-start-playback-button{display:none!important}.plugin_ctrl_mod_overlay_wrapper{position:static}.plugin_ctrl_mod_overlay_wrapper ol,.plugin_ctrl_mod_overlay_wrapper ul{list-style:none}.plugin_ctrl_mod_overlay_wrapper li{vertical-align:top}.plugin_ctrl_mod_overlay_wrapper *{-webkit-box-sizing:border-box;box-sizing:border-box}.plugin_ctrl_mod_overlay_wrapper .mod_overlay{position:absolute;background:rgba(0,0,0,.75);left:0;top:0;right:0;bottom:0;z-index:998;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;color:#fff}.plugin_ctrl_mod_overlay_wrapper .mod_overlay.overlay_flex{display:-webkit-box;display:-ms-flexbox;display:flex}.plugin_ctrl_mod_overlay_wrapper .mod_overlay.txp_none{display:none}.plugin_ctrl_mod_overlay_wrapper .mod_speed_select{width:100%;text-align:center}.plugin_ctrl_mod_overlay_wrapper .mod_speed_select .title{font-size:16px}.plugin_ctrl_mod_overlay_wrapper .mod_speed_select ul{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;font-size:18px;font-weight:700;padding:0 12px}.plugin_ctrl_mod_overlay_wrapper .mod_speed_select li{height:70px;margin-right:6px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:0 12px}.plugin_ctrl_mod_overlay_wrapper .mod_speed_select li div:last-child{margin-top:6px;font-size:14px;font-weight:500}.plugin_ctrl_mod_overlay_wrapper .mod_speed_select li.current{color:#ff6022}.plugin_ctrl_mod_overlay_wrapper .mod_speed_select li.current span{position:relative}.plugin_ctrl_mod_overlay_wrapper .mod_speed_select li.current span:after{content:\"\";width:100%;height:3px;background:#ff6022;position:absolute;bottom:-3px;left:0}.plugin_ctrl_mod_overlay_wrapper .txp_btn_playrate{position:relative;width:55px;height:44px;color:#fff;white-space:nowrap;text-align:center;-webkit-box-flex:0;-ms-flex:none;flex:none;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.plugin_ctrl_txp_mode_fullscreen .plugin_ctrl_mobile_txp_bottom{padding-bottom:env(safe-area-inset-bottom)}";

/**
 * 移动端广告插件适配逻辑
 */
function adaptMobileAdPlugin(ctrl, player) {
    if (!uaTool.mobile)
        return;
    // 广告起播时隐藏控制栏，并且不允许唤醒。避免进入全屏后seek广告
    player.on(H5_PLAY_EVENT.AD_PLAYING, function () { return ctrl.hide(true); });
    // 广告结束时激活控制栏
    player.on(H5_PLAY_EVENT.AD_END, function () { return ctrl.el.style.display = ''; });
}

/** ui组件基类 */
var Component = /** @class */ (function () {
    function Component(player, el, config) {
        this.player = player;
        this.config = config;
        /** 统一点击事件名为click，避免移动端出现点击穿透（伪全屏后元素会fixed在页面上） */
        this.CLICK_EVENT_NAME = 'click';
        this.eventMap = {};
        var container = player.container;
        this.el = container.querySelector(el);
        this.isMobile = config === null || config === void 0 ? void 0 : config.isMobile;
        this.isLive = this.config.mode === 'live';
        this.showEl();
    }
    Component.isEnabled = function (config) {
        return true;
    };
    Object.defineProperty(Component.prototype, "playtime", {
        get: function () {
            var offsetFn = this.config.timeOffset;
            var playtime = this.player.playtime;
            return offsetFn ? offsetFn(playtime, false) : playtime;
        },
        enumerable: false,
        configurable: true
    });
    Component.prototype.destroy = function () {
        var _a;
        if ((_a = this.el) === null || _a === void 0 ? void 0 : _a.parentNode)
            this.el.remove();
        this.setEvts(true);
        this.el = null;
        this.player = null;
    };
    Component.prototype.setEvts = function (isUnbind) {
        var _this = this;
        if (isUnbind === void 0) { isUnbind = false; }
        var method = isUnbind ? this.player.off : this.player.on;
        Object.keys(this.eventMap).forEach(function (evt) {
            method.call(_this.player, evt, _this.eventMap[evt]);
        });
    };
    Component.prototype.showEl = function (dom) {
        if (dom === void 0) { dom = this.el; }
        // 有的浮层可能未插入dom
        if (dom) {
            dom.classList.remove(Component.hideClassName);
        }
    };
    Component.prototype.hideEl = function (dom) {
        if (dom === void 0) { dom = this.el; }
        if (dom) {
            dom.classList.add(Component.hideClassName);
        }
    };
    /** 根元素选择器 */
    Component.sel = '';
    Component.disabledClassName = 'txp_disabled';
    Component.curClassName = 'txp_current';
    Component.hideClassName = 'txp_none';
    return Component;
}());

var hideCSS = 'txp_none';
var disableCSS = 'txp_disabled';
var shouldDisableState = [VIDEO_STATE.END, VIDEO_STATE.IDLE, VIDEO_STATE.LOAD_START];
/**
 * AirPlay 按钮
 */
var AirPlayBtn = /** @class */ (function (_super) {
    __extends(AirPlayBtn, _super);
    function AirPlayBtn(player, config, ctrlbar) {
        var _this = _super.call(this, player, AirPlayBtn.sel, config) || this;
        _this.config = config;
        _this.ctrlbar = ctrlbar;
        _this.handlePlayerCanPlay = function () {
            _this.hideDependOnKernel();
            _this.setBtnState(true);
        };
        _this.handleSetLevelEnd = function () {
            _this.hideDependOnKernel();
        };
        _this.handlePlayerSessionEnd = function () {
            _this.setBtnState(false);
        };
        _this.handleClick = function () {
            var _a, _b;
            (_b = (_a = _this.player.currentVideoElement) === null || _a === void 0 ? void 0 : _a.webkitShowPlaybackTargetPicker) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        var btnState = !shouldDisableState.includes(_this.player.state);
        _this.setupDOMEvents();
        _this.setupPlayerEvents(true);
        _this.show();
        _this.setBtnState(btnState);
        return _this;
    }
    AirPlayBtn.isEnabled = function (config) {
        var isMobile = config.isMobile, showAirplayOnIOS = config.showAirplayOnIOS;
        // iOS 下内核都是 webkit，是可以开启的，不过考虑到 iPhone 尺寸问题，只在指定情况下才开
        if (uaTool.os.ios && showAirplayOnIOS) {
            return true;
        }
        // 在 mac Safari 下才启用
        return uaTool.browser.safari && !isMobile;
    };
    AirPlayBtn.prototype.show = function () {
        this.el.classList.remove(hideCSS);
    };
    AirPlayBtn.prototype.hide = function () {
        this.el.classList.add(hideCSS);
    };
    AirPlayBtn.prototype.setBtnState = function (enable) {
        if (enable) {
            return this.el.classList.remove(disableCSS);
        }
        this.el.classList.add(disableCSS);
    };
    AirPlayBtn.prototype.destroy = function () {
        var _a;
        this.setupPlayerEvents(false);
        (_a = this.el) === null || _a === void 0 ? void 0 : _a.remove();
    };
    AirPlayBtn.prototype.setupPlayerEvents = function (isBind) {
        if (isBind === void 0) { isBind = true; }
        var binder = isBind ? this.player.on.bind(this.player) : this.player.off.bind(this.player);
        binder(H5_PLAY_EVENT.VIDEO_CANPLAY, this.handlePlayerCanPlay);
        binder(H5_PLAY_EVENT.PLAY_SESSION_END, this.handlePlayerSessionEnd);
        binder(H5_PLAY_EVENT.VIDEO_SETLEVEL_END, this.handleSetLevelEnd);
    };
    AirPlayBtn.prototype.setupDOMEvents = function () {
        this.el = this.player.container.querySelector(AirPlayBtn.sel);
        this.el.addEventListener('click', this.handleClick);
    };
    /**
     * 只有原生内核能使用 Airplay
     * MSE / WASM 都无法使用
     */
    AirPlayBtn.prototype.hideDependOnKernel = function () {
        if (this.player.kernelName !== KERNEL_NAME.ORIGIN) {
            this.hide();
        }
        else {
            this.show();
        }
    };
    AirPlayBtn.sel = '.txp_btn_airplay';
    AirPlayBtn.compName = 'AirPlayBtn';
    return AirPlayBtn;
}(Component));

/** 热点广播的事件 */
var HOTPOINT_EVENTS;
(function (HOTPOINT_EVENTS) {
    HOTPOINT_EVENTS["HOT_MOUSE_OVER"] = "ctrl:hotpoint-mouseover";
    HOTPOINT_EVENTS["HOT_MOUSE_MOVE"] = "ctrl:hotpoint-mousemove";
    HOTPOINT_EVENTS["HOT_MOUSE_OUT"] = "ctrl:hotpoint-mouseout";
})(HOTPOINT_EVENTS || (HOTPOINT_EVENTS = {}));
var CtrlbarPluginName = 'ctrlbar';
/** 控制栏插件上广播的事件 */
var CTRL_EVENTS = __assign(__assign({ 
    /** 全屏状态变化 */
    FULLSCREEN_CHANGE: 'windowFullscreenChange', 
    /** 进入/退出全屏错误 */
    FULLSCREEN_ERROR: 'fullscreenError', 
    /** 伪全屏全屏状态变化 */
    FAKE_FULLSCREEN_CHANGE: 'browserFullscreenChange', 
    /** 点击画中画按钮 */
    CLICK_PIPBTN: 'ctrl:click-pipbtn', 
    /** 点击下一集按钮 */
    CLICK_NEXTBTN: 'ctrl:click-nextbtn', 
    /** 点击播放按钮 */
    CLICK_PLAYBTN: 'ctrl:click-playbtn', 
    /** 点击重播 */
    CLICK_REPLAY: 'ctrl:click-replay', 
    /** 点击循环播放按钮 */
    CLICK_LOOP: 'ctrl:click-loop', 
    /** 点击多语言 */
    SET_LANGUAGE: 'ctrl:set-language', 
    /** 点击清晰度 */
    SET_LEVEL: 'ctrl:set-level', 
    /** 点击多音轨 */
    SET_AUDIO: 'ctrl:set-audio', 
    /** 点击倍速 */
    SET_PLAYRATE: 'ctrl:set-playrate', 
    /** 拖拽音量 */
    SET_VOLUME: 'ctrl:set-volume', 
    /** 移动端浮层切换显隐 */
    TOGGLE_OVERLAY: 'ctrl:toggle-overlay', 
    /** @deprecated 拼写有错误，建议使用 MOUSE_DOWN，后续将删除 */
    MOUSE_DONW: 'ctrl:progress-mousedown', 
    /** 进度条 mousedown */
    MOUSE_DOWN: 'ctrl:progress-mousedown', 
    /** 进度条mousemove */
    MOUSE_MOVE: 'ctrl:progress-mousemove', 
    /** 进度条mouseup */
    MOUSE_UP: 'ctrl:progress-mouseup', 
    /** 进度条展示 */
    SHOW: 'ctrl:show', 
    /** 进度条隐藏 */
    HIDE: 'ctrl:hide' }, HOTPOINT_EVENTS), { 
    /** @ignore 移动端点击时间彩蛋事件，仅内部使用 */
    TEST_EVENT: 'ctrl:inner-test-event', 
    /** 控制栏尺寸发生变化，在进入全屏/伪全屏时广播 */
    RESIZE: 'ctrl:resize', 
    /** 展示清晰度浮层 */
    SHOW_LEVELS: 'ctrl:show-levels', 
    /** 鼠标hover至进度条上 */
    HOVER_PROGRESS: 'ctrl:hover-progress' });
/** web控制栏根元素class名 */
var pcRootClassName = '.plugin_ctrl_txp_bottom';
/** mobile控制栏根元素class名 */
var mobileRootClassName = '.plugin_ctrl_mobile_txp_bottom';
/** 控制栏根元素class名 */
var getRootClassName = function (mobile) { return (mobile ? mobileRootClassName : pcRootClassName); };
var shadowClassName = '.plugin_ctrl_txp_shadow';
var gradientClassName = '.plugin_ctrl_txp_gradient_bottom';
var containerClassName = '_mod_thumbplayer_container_';
var largeSizeClassName = 'plugin_ctrl--large';
var bodyOverflowClassName = 'plugin_ctrl_fake_fullscreen';
var CTRL_SIZE;
(function (CTRL_SIZE) {
    CTRL_SIZE["LARGE"] = "large";
    CTRL_SIZE["NORMAL"] = "normal";
})(CTRL_SIZE || (CTRL_SIZE = {}));
var PlayBtnStatus;
(function (PlayBtnStatus) {
    PlayBtnStatus["PAUSE"] = "pause";
    PlayBtnStatus["PLAY"] = "play";
    PlayBtnStatus["REPLAY"] = "replay";
    PlayBtnStatus["STOP"] = "stop";
})(PlayBtnStatus || (PlayBtnStatus = {}));

/** 清晰度、倍速、多语言、多音轨 通用浮层 */
var Popup = /** @class */ (function (_super) {
    __extends(Popup, _super);
    function Popup(player, config, ctrlbar) {
        var _this = _super.call(this, player, config.selector, config) || this;
        _this.ctrlbar = ctrlbar;
        // 先隐藏btn，设置选项和值后再展示
        _this.hideEl();
        _this.popup = _this.isMobile
            ? _this.player.container.querySelector(config.modSelector)
            : _this.el.querySelector('.txp_popup');
        if (!_this.el)
            return _this;
        _this.label = _this.el.querySelector('.txp_label');
        if (!_this.isMobile) {
            // hover按钮展示浮层
            _this.label.addEventListener('mouseover', function () { return _this.showEl(_this.popup); });
            _this.el.addEventListener('mouseleave', function () {
                _this.hideEl(_this.popup);
            });
        }
        else {
            // 点击按钮展示浮层
            _this.label.addEventListener(_this.CLICK_EVENT_NAME, function () {
                var isShow = !_this.popup.classList.contains(Component.hideClassName);
                if (isShow) {
                    _this.hideEl(_this.popup);
                }
                else {
                    _this.showEl(_this.popup);
                    _this.popup.classList.add('overlay_flex');
                }
                _this.ctrlbar.emit(CTRL_EVENTS.TOGGLE_OVERLAY, true);
                _this.hideEl(_this.ctrlbar.el);
            });
        }
        _this.initItemClick();
        return _this;
    }
    Object.defineProperty(Popup.prototype, "curClass", {
        get: function () {
            return this.isMobile ? 'current' : Component.curClassName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Popup.prototype, "selected", {
        // 当前值
        get: function () {
            return this.selectedValue;
        },
        set: function (val) {
            var _a;
            var item = (_a = this.popupOptions) === null || _a === void 0 ? void 0 : _a.find(function (v) { return String(v.value) === String(val); });
            this.selectedValue = val;
            if (!item) {
                // 找不到选项中对应值时，清空label
                this.label.textContent = '';
                this.hideEl();
                return;
            }
            this.showEl();
            this.setCurrent(item);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Popup.prototype, "popupOptions", {
        // 选项列表
        get: function () {
            return this.allValue;
        },
        set: function (val) {
            var _this = this;
            var item = val.find(function (v) { return String(v.value) === String(_this.selectedValue); });
            if (item) {
                this.setCurrent(item);
                this.showEl();
            }
            else {
                // 找不到选项中对应值时，清空label
                this.label.textContent = '';
            }
            this.allValue = val;
            var tagName = this.isMobile ? 'li' : 'div';
            /** v.label传入html内容时，删除data-label的内容（已经没有意义了） */
            var htmlTagRegex = /(<([^>]+)>)/;
            var createTemplate = function (v) { return "<" + tagName + " \n      class=\"txp_menuitem " + (v.value === _this.selected ? _this.curClass : '') + "\" \n      data-label=\"" + (htmlTagRegex.test(v.label) ? '' : v.label) + "\"\n      data-value=\"" + v.value + "\" \n      data-payload=\"" + (v.payload || '') + "\">" + v.label + "</" + tagName + ">"; };
            this.popup.querySelector(this.isMobile ? '.select_list' : '.txp_popup_content').innerHTML = val.map(createTemplate).join('');
        },
        enumerable: false,
        configurable: true
    });
    /** 根据当前选择的值，设置label文案和options高亮 */
    Popup.prototype.setCurrent = function (item) {
        var _this = this;
        var _a;
        this.label.innerHTML = (_a = item === null || item === void 0 ? void 0 : item.btnLabel) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.label;
        this.popup.querySelectorAll('.txp_menuitem').forEach(function (node) {
            var dataValue = node.getAttribute('data-value');
            if (dataValue === String(item.value)) {
                node.classList.add(_this.curClass);
            }
            else {
                node.classList.remove(_this.curClass);
            }
        });
    };
    Popup.prototype.hookPlaySessionEnd = function () {
        if (!this.el)
            return;
        this.el.classList.add(Component.disabledClassName);
    };
    Popup.prototype.hookFlowNodeStart = function (_a) {
        var data = _a.data;
        if (data.name === 'VideoFlowNode') {
            this.el.classList.remove(Component.disabledClassName);
        }
    };
    /** 初始化选项点击 */
    Popup.prototype.initItemClick = function () {
        var _this = this;
        this.popup.addEventListener(this.CLICK_EVENT_NAME, function (evt) {
            var _a, _b;
            _this.player.setStateKv("ctrlbar:" + _this.popupName + ":" + _this.CLICK_EVENT_NAME, {
                type: LOG_TYPE.USER_ACTION,
            });
            /** 选项节点 */
            var menuItem = evt.target;
            while (menuItem) {
                if ((_a = menuItem.classList) === null || _a === void 0 ? void 0 : _a.contains('txp_menuitem'))
                    break;
                menuItem = menuItem.parentNode;
            }
            // 移动端点击关闭浮层
            if (_this.isMobile) {
                _this.hideEl(_this.popup);
                _this.popup.classList.remove('overlay_flex');
                _this.ctrlbar.emit(CTRL_EVENTS.TOGGLE_OVERLAY, false);
            }
            var dataset = menuItem === null || menuItem === void 0 ? void 0 : menuItem.dataset;
            if (!(dataset === null || dataset === void 0 ? void 0 : dataset.value) || dataset.value === String(_this.selected))
                return;
            (_b = _this.onSelect) === null || _b === void 0 ? void 0 : _b.call(_this, dataset);
            if (_this.config.hidePopupOnClick) {
                _this.hideEl(_this.popup);
            }
        });
    };
    Popup.compName = 'popup';
    return Popup;
}(Component));

var AudioTrackPopup = /** @class */ (function (_super) {
    __extends(AudioTrackPopup, _super);
    function AudioTrackPopup(player, config, ctrlbar) {
        var _this = _super.call(this, player, __assign(__assign({}, config), { selector: AudioTrackPopup.popupSelector }), ctrlbar) || this;
        _this.popupName = 'audiotrack';
        _this.onSelect = function (val) {
            _this.ctrlbar.emit(CTRL_EVENTS.SET_AUDIO, val);
        };
        return _this;
    }
    AudioTrackPopup.isEnabled = function (config) {
        return !(config.isMobile || config.disableAudioTrack);
    };
    AudioTrackPopup.compName = 'AudioTrackPopup';
    AudioTrackPopup.popupSelector = '.txp_right_controls .txp_btn_audio_track';
    return AudioTrackPopup;
}(Popup));

function onBtnClickPlay(player, ctrl) {
    if (ctrl.isInRequest) {
        player.triggerAutoplay().then(function () { return player.play(); });
    }
    else {
        player.play();
    }
}

var CenterBtn = /** @class */ (function (_super) {
    __extends(CenterBtn, _super);
    function CenterBtn(player, config, ctrlbar) {
        var _this = _super.call(this, player, CenterBtn.sel, config) || this;
        _this.config = config;
        _this.ctrlbar = ctrlbar;
        _this.prepareDOM();
        _this.initDOMEvents();
        _this.initPlayerEvents();
        return _this;
    }
    CenterBtn.isEnabled = function (config) {
        var showCenterPlayBtn = config.showCenterPlayBtn, showCenterReplayBtn = config.showCenterReplayBtn;
        return showCenterPlayBtn || showCenterReplayBtn;
    };
    CenterBtn.prototype.initDOMEvents = function () {
        var _this = this;
        this.playBtn.addEventListener('click', function () {
            // 点击后隐藏按钮，避免遮挡loading
            _this.hideEl(_this.playBtn);
            onBtnClickPlay(_this.player, _this.ctrlbar);
        });
        this.replayBtn.addEventListener('click', function () {
            _this.hideEl(_this.replayBtn);
            _this.player.replay();
        });
    };
    CenterBtn.prototype.initPlayerEvents = function () {
        var _this = this;
        var player = this.player;
        // play btn
        var showPlayBtn = function () {
            if (_this.config.showCenterPlayBtn) {
                _this.showEl(_this.playBtn);
            }
        };
        showPlayBtn();
        player.on(H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED, function (_a) {
            var data = _a.data;
            if (data.adType !== AD_TYPE.PRE)
                return;
            showPlayBtn();
        });
        player.on(H5_PLAY_EVENT.AD_PAUSE, function () {
            // 广告暂停展示播放按钮
            _this.showEl(_this.playBtn);
        });
        player.on(H5_PLAY_EVENT.AD_RESUME, function () {
            // 广告恢复播放隐藏按钮
            _this.hideEl(_this.playBtn);
        });
        player.on(H5_PLAY_EVENT.VIDEO_AUTOPLAY_BLOCKED, showPlayBtn);
        player.on(H5_PLAY_EVENT.AD_PLAYING, function () { return _this.hideEl(_this.playBtn); });
        player.on(H5_PLAY_EVENT.VIDEO_PLAYING, function (_a) {
            var data = _a.data;
            if (!data.isFirst)
                return;
            _this.hideEl(_this.playBtn);
        });
        // replay btn
        player.on(H5_PLAY_EVENT.PLAY_SESSION_END, function (_a) {
            var data = _a.data;
            _this.hideEl(_this.playBtn);
            if (!_this.config.showCenterReplayBtn || data.endState !== END_STATE.NORMAL)
                return;
            _this.showEl(_this.replayBtn);
        });
        player.on(H5_PLAY_EVENT.PLAY_SESSION_START, function () {
            _this.hideEl(_this.replayBtn);
        });
    };
    CenterBtn.prototype.prepareDOM = function () {
        var template = "<div class=\"" + ("" + CenterBtn.sel.slice(1)) + "\">\n      <div class=\"btn_play " + Component.hideClassName + "\">\n        <svg class=\"icon_play\" viewBox=\"0 0 100 100\">\n          <circle cx=\"50\" cy=\"50\" r=\"50\" style=\"fill:#222;fill-opacity:0.75\"></circle>\n          <path\n            transform=\"translate(36, 33)\"\n            d=\"M0.6,2C0.6,2,0,3.5,0,16.9C0,30.3,0.6,32,0.6,32c0,1.5,1.6,2.5,2.9,1.8c0,0,3-0.5,15.2-6.6c12.2-6.1,14.2-8.4,14.2-8.4c1.5-0.7,1.5-2.8,0-3.6c0,0-3.3-3.1-14.2-8.6C7.9,1.1,3.5,0.2,3.5,0.2C2.1-0.5,0.6,0.5,0.6,2z\"\n            style=\"fill:#fff;\"\n          />\n        </svg>\n      </div>\n\n      <div class=\"btn_replay " + Component.hideClassName + "\">\n        <svg class=\"icon_replay\" viewBox=\"0 0 30 30\">\n          <use xlink:href=\"#txp_svg_replay\"></use>\n        </svg>\n        <div>\u91CD\u65B0\u64AD\u653E</div>\n      </div>\n    </div>";
        this.ctrlbar.el.insertAdjacentHTML('beforebegin', template);
        this.el = this.player.container.querySelector(CenterBtn.sel);
        this.playBtn = this.el.querySelector('.btn_play');
        this.replayBtn = this.el.querySelector('.btn_replay');
    };
    CenterBtn.sel = '.plugin_ctrl_center_btn';
    CenterBtn.compName = 'CenterBtn';
    return CenterBtn;
}(Component));

var DefinitionPopup = /** @class */ (function (_super) {
    __extends(DefinitionPopup, _super);
    function DefinitionPopup(player, config, ctrlbar) {
        var _this = _super.call(this, player, __assign(__assign({}, config), { selector: DefinitionPopup.popupSelector, modSelector: DefinitionPopup.modSelector }), ctrlbar) || this;
        _this.popupName = 'definition';
        _this.onSelect = function (val) {
            _this.ctrlbar.emit(CTRL_EVENTS.SET_LEVEL, val);
        };
        _this.onShowLevel = function () {
            _this.ctrlbar.emit(CTRL_EVENTS.SHOW_LEVELS);
        };
        _this.label.addEventListener('mouseover', _this.onShowLevel);
        return _this;
    }
    DefinitionPopup.isEnabled = function () {
        return true;
    };
    DefinitionPopup.compName = 'DefinitionPopup';
    DefinitionPopup.popupSelector = '.txp_right_controls .txp_btn_definition';
    DefinitionPopup.modSelector = '.mod_overlay.definition';
    return DefinitionPopup;
}(Popup));

/** 伪全屏按钮 */
var FakeFullscreen = /** @class */ (function (_super) {
    __extends(FakeFullscreen, _super);
    function FakeFullscreen(player, config, ctrlbar) {
        var _this = _super.call(this, player, FakeFullscreen.sel, config) || this;
        _this.ctrlbar = ctrlbar;
        _this.tip = _this.el.querySelector('.txp_tooltip');
        // 初始化时展示DOM
        _this.el.classList.remove(Component.hideClassName);
        _this.setupDOMEvents();
        return _this;
    }
    FakeFullscreen.isEnabled = function (config) {
        var disableFakeFullscreen = config.disableFakeFullscreen, useH5FakeFullscreen = config.useH5FakeFullscreen, isMobile = config.isMobile;
        if (isMobile && typeof useH5FakeFullscreen !== 'undefined') {
            // 移动端下，如果外部指定使用伪全屏，则使用伪全屏
            return !!useH5FakeFullscreen;
        }
        if (typeof disableFakeFullscreen !== 'undefined') {
            return !disableFakeFullscreen;
        }
        if (!!uaTool.os.android || !isMobile) {
            // 安卓走伪全屏，桌面端默认开启伪全屏
            return true;
        }
        return false;
    };
    Object.defineProperty(FakeFullscreen.prototype, "isFullScreen", {
        get: function () {
            return this.player.fullscreenMode === FullScreenMode.FAKE_FULLSCREEN;
        },
        enumerable: false,
        configurable: true
    });
    FakeFullscreen.prototype.setTipStatus = function (val) {
        this.el.dataset.status = String(val);
        if (!this.isMobile)
            this.tip.innerText = val ? '退出网页全屏' : '网页全屏';
    };
    FakeFullscreen.prototype.requestFullScreen = function (mode) {
        if (mode === void 0) { mode = 'enter'; }
        var isEnter = mode === 'enter';
        this.player.requestFullScreen(isEnter, FullScreenMode.FAKE_FULLSCREEN);
    };
    FakeFullscreen.prototype.setupDOMEvents = function () {
        var _this = this;
        // 点击全屏
        this.el.addEventListener(this.CLICK_EVENT_NAME, function () {
            _this.player.setStateKv("ctrlbar:" + FakeFullscreen.compName + ":" + _this.CLICK_EVENT_NAME, {
                type: LOG_TYPE.USER_ACTION,
            });
            _this.requestFullScreen(_this.isFullScreen ? 'exit' : 'enter');
        });
        // pc端hover展示tip
        if (!this.isMobile) {
            this.el.addEventListener('mouseover', function () {
                _this.showEl(_this.tip);
            });
            this.el.addEventListener('mouseout', function () {
                _this.hideEl(_this.tip);
            });
        }
        this.player.on(PLAY_EVENT.FULLSCREEN_CHANGE, function (_a) {
            var data = _a.data;
            var mode = data.mode, isEnter = data.isEnter;
            if (mode !== FullScreenMode.FAKE_FULLSCREEN) {
                return;
            }
            var fullscreenEl = _this.player.config.fullscreenContainer || _this.player.container;
            _this.setTipStatus(isEnter);
            fullscreenEl.classList.toggle(FakeFullscreen.fullscreenClassName, isEnter);
            _this.ctrlbar.emit(CTRL_EVENTS.FAKE_FULLSCREEN_CHANGE, isEnter);
        });
    };
    FakeFullscreen.sel = '.txp_right_controls .txp_btn_fake';
    FakeFullscreen.fullscreenClassName = 'plugin_ctrl_txp_mode_fullscreen';
    FakeFullscreen.compName = 'FakeFullscreen';
    return FakeFullscreen;
}(Component));

var fullscreenClassName = 'thumbplayer-fullscreen';
/** 系统全屏按钮 */
var Fullscreen = /** @class */ (function (_super) {
    __extends(Fullscreen, _super);
    function Fullscreen(player, config, ctrlbar) {
        var _this = _super.call(this, player, Fullscreen.sel, config) || this;
        _this.ctrlbar = ctrlbar;
        _this.onFullscreenChange = function (_a) {
            var data = _a.data;
            var mode = data.mode, isEnter = data.isEnter;
            if (mode !== FullScreenMode.FULL_SCREEN)
                return;
            _this.setDOMStatus(isEnter ? FullscreenStatus.Exit : FullscreenStatus.Enter);
            _this.ctrlbar.emit(CTRL_EVENTS.FULLSCREEN_CHANGE, isEnter);
            var fullscreenEl = _this.player.config.fullscreenContainer || _this.player.container;
            fullscreenEl.classList.toggle(fullscreenClassName, isEnter);
        };
        /**
         * 特殊处理下 iOS，播放结束后就不让全屏了
         * 原因是 iOS 全屏使用的是系统的播控，可以向前 seek，
         * 使得即 SessionEnd，也可以 seek / 播放，导致播放器、控制栏状态异常
         */
        _this.onPlaySessionEnd = function () {
            if (uaTool.os.ios) {
                _this.el.classList.add(Component.disabledClassName);
            }
        };
        _this.onPlaySessionStart = function () {
            _this.el.classList.remove(Component.disabledClassName);
        };
        _this.tip = _this.el.querySelector('.txp_tooltip');
        _this.setupDOMEvents();
        // pc端双击切换全屏
        if (!_this.isMobile)
            _this.listenDblclick();
        return _this;
    }
    Fullscreen.isEnabled = function (config) {
        var isMobile = config.isMobile, useH5FakeFullscreen = config.useH5FakeFullscreen;
        if (isMobile && typeof useH5FakeFullscreen !== 'undefined') {
            // 移动端下，如果外部指定使用伪全屏，那就强行关闭系统全屏
            return !useH5FakeFullscreen;
        }
        if (!!uaTool.os.ios || !isMobile) {
            // ios走系统全屏，桌面端默认开启伪全屏
            return true;
        }
        return false;
    };
    Object.defineProperty(Fullscreen.prototype, "isFullScreen", {
        /** todo: 移动端判断全屏不准，此属性始终为false */
        get: function () {
            return this.player.fullscreenMode === FullScreenMode.FULL_SCREEN;
        },
        enumerable: false,
        configurable: true
    });
    Fullscreen.prototype.setDOMStatus = function (status) {
        this.el.dataset.status = status;
        if (!this.isMobile) {
            // 移动端没有tip
            this.tip.innerText = status === FullscreenStatus.Exit ? '退出全屏' : '全屏';
        }
    };
    Fullscreen.prototype.requestFullScreen = function (mode) {
        var _this = this;
        if (mode === void 0) { mode = 'enter'; }
        return this.player.requestFullScreen(mode === 'enter', FullScreenMode.FULL_SCREEN)
            .catch(function (err) {
            _this.ctrlbar.emit(CTRL_EVENTS.FULLSCREEN_ERROR, err);
        });
    };
    /** 双击切换全屏 */
    Fullscreen.prototype.listenDblclick = function () {
        var _this = this;
        this.player.container.querySelector(shadowClassName).addEventListener('dblclick', function () {
            var _a;
            // 处于伪全屏时，只退出伪全屏
            if ((_a = _this.ctrlbar.instances.FakeFullscreen) === null || _a === void 0 ? void 0 : _a.isFullScreen) {
                _this.ctrlbar.instances.FakeFullscreen.requestFullScreen('exit');
                return;
            }
            _this.requestFullScreen(_this.isFullScreen ? 'exit' : 'enter');
        });
    };
    /** 监听dom事件 */
    Fullscreen.prototype.setupDOMEvents = function () {
        var _this = this;
        // 点击切换全屏 touchstart有时会不允许进入全屏 所以强制使用click
        this.el.addEventListener('click', function () {
            // 如果按钮已经被禁用，则什么也不做
            if (_this.el.classList.contains(Component.disabledClassName))
                return;
            _this.player.setStateKv("ctrlbar:" + Fullscreen.compName + ":click", {
                type: LOG_TYPE.USER_ACTION,
                message: "fullscreen=" + _this.isFullScreen,
            });
            _this.requestFullScreen(_this.isFullScreen ? 'exit' : 'enter');
        });
        // hover展示tip
        if (!this.isMobile) {
            this.el.addEventListener('mouseover', function () { return _this.showEl(_this.tip); });
            this.el.addEventListener('mouseout', function () { return _this.hideEl(_this.tip); });
        }
        this.player.on(PLAY_EVENT.FULLSCREEN_CHANGE, this.onFullscreenChange);
        this.player.on(H5_PLAY_EVENT.PLAY_SESSION_END, this.onPlaySessionEnd);
        this.player.on(H5_PLAY_EVENT.PLAY_SESSION_START, this.onPlaySessionStart);
    };
    Fullscreen.sel = '.txp_right_controls .txp_btn_fullscreen';
    Fullscreen.compName = 'Fullscreen';
    return Fullscreen;
}(Component));
var FullscreenStatus;
(function (FullscreenStatus) {
    FullscreenStatus["Enter"] = "false";
    FullscreenStatus["Exit"] = "true";
})(FullscreenStatus || (FullscreenStatus = {}));

/** 热点文案tip类型 */
var HOTPOINT_TIP_TYPE;
(function (HOTPOINT_TIP_TYPE) {
    /** 默认模式：未传入节点时显示默认样式，传入自定义节点时显示自定义 */
    HOTPOINT_TIP_TYPE["DEFAULT"] = "default";
    /** 文案插入至ui-preview的进度条缩略图节点 */
    HOTPOINT_TIP_TYPE["WITH_PREVIEW"] = "with-preview";
    /** 不显示热点文案 */
    HOTPOINT_TIP_TYPE["NONE"] = "none";
})(HOTPOINT_TIP_TYPE || (HOTPOINT_TIP_TYPE = {}));
/** 节流时间 */
var THROTTLE_WAIT = 16.6;
/** mouseEvent对应的事件 */
var mouseEvtMap = {
    // mouseenter/leave不冒泡，做事件代理的时候需要用mouseover/out
    mouseover: HOTPOINT_EVENTS.HOT_MOUSE_OVER,
    mousemove: HOTPOINT_EVENTS.HOT_MOUSE_MOVE,
    mouseout: HOTPOINT_EVENTS.HOT_MOUSE_OUT,
};
var HotPoint = /** @class */ (function (_super) {
    __extends(HotPoint, _super);
    function HotPoint(player, config, ctrlbar) {
        var _a;
        var _this = _super.call(this, player, HotPoint.sel, config) || this;
        _this.ctrlbar = ctrlbar;
        /** 储存全部节点的map */
        _this.hotPointMap = {};
        _this.isReady = false;
        /** CANPLAY后，才能够获取 duration 计算渲染百分比，此时设置 ready 状态并开始渲染 */
        _this.onVideoCanPlay = function () {
            // 如果已经触发过设置过一次，则什么都不需要做：seek 会产生 VIDEO_CANPLAY 事件
            if (_this.isReady)
                return;
            _this.isReady = true;
            // 渲染 DOM 节点
            _this.renderDom();
        };
        /** 播放结束后触发,销毁全部的热点元素和监听 */
        _this.onPlaySessionEnd = function () {
            _this.isReady = false;
            _this.tipEl.classList.add(HotPoint.hideClassName);
            _this.clearHotPoints();
        };
        if (!_this.config.hotPointTipType)
            _this.config.hotPointTipType = HOTPOINT_TIP_TYPE.DEFAULT;
        // 绑定事件handle，监听播放器事件
        _this.mouseEvtHandler = _this.mouseEvtHandler.bind(_this);
        // 事件处理函数
        _this.mouseEvtFuncMap = {
            mouseover: _this.onMouseOver.bind(_this),
            mousemove: throttle(_this.onMouseMove.bind(_this), THROTTLE_WAIT, { trailing: false }),
            mouseout: _this.onMouseOut.bind(_this),
        };
        // 绑定播放器事件
        _this.eventMap = (_a = {},
            _a[H5_PLAY_EVENT.VIDEO_CANPLAY] = _this.onVideoCanPlay,
            _a[H5_PLAY_EVENT.PLAY_SESSION_END] = _this.onPlaySessionEnd,
            _a);
        // 仅在default模式下生成tip元素
        if (_this.config.hotPointTipType === HOTPOINT_TIP_TYPE.DEFAULT)
            _this.setupTip();
        _this.setEvts(false);
        _this.logger = new Logger(_this.player.config.instanceId, 'Ctrl:HotPoints');
        return _this;
    }
    HotPoint.isEnabled = function (config) {
        var isMobile = config.isMobile;
        return !isMobile;
    };
    /**
     * 清理全部的热点元素和监听
     * @memberof HotPoint
     */
    HotPoint.prototype.clearHotPoints = function () {
        // 清空根结点数据
        Object.values(this.hotPointMap)
            .forEach(function (_a) {
            var el = _a.el;
            if (el instanceof HTMLElement)
                el.remove();
        });
        this.hotPointMap = {};
    };
    /**
     * 在进度条添加新的打点
     * @param {Array<IHotPoint>} points 添加的热点数据
     * @return {Array<IHotPoint>} 加上uuid后的传入热点的数据
     * @memberof HotPoint
     */
    HotPoint.prototype.addHotPoints = function (points) {
        var _this = this;
        if (!(points === null || points === void 0 ? void 0 : points.length))
            return;
        var hotPoints = points.map(function (point) {
            var hotPoint = __assign({}, point);
            hotPoint.uuid = commonTool.createGUID();
            _this.hotPointMap[hotPoint.uuid] = hotPoint;
            return hotPoint;
        });
        if (this.isReady) {
            this.renderDom();
        }
        return hotPoints;
    };
    /**
     * 根据传入的uuid删除对应的标记点
     * @param {string[]} uuids
     * @memberof HotPoint
     */
    HotPoint.prototype.deleteHotPoints = function (uuids) {
        var _this = this;
        uuids.forEach(function (uuid) {
            var _a;
            var point = _this.hotPointMap[uuid];
            if (!point)
                return;
            // 有可能在 render 前就执行 delete，el 需要 optional
            (_a = point.el) === null || _a === void 0 ? void 0 : _a.remove();
            delete _this.hotPointMap[uuid];
        });
    };
    HotPoint.prototype.setEvts = function (isUnbind) {
        var _this = this;
        if (isUnbind === void 0) { isUnbind = false; }
        var elBinder = isUnbind ? this.el.removeEventListener : this.el.addEventListener;
        // 节点生成后，创建事件监听
        Object.keys(mouseEvtMap)
            .forEach(function (evtType) {
            elBinder.call(_this.el, evtType, _this.mouseEvtHandler, false);
        });
        _super.prototype.setEvts.call(this, isUnbind);
    };
    HotPoint.prototype.isValidHotPoint = function (point) {
        return point.timing <= this.player.duration;
    };
    /**
     * 把热点map渲染为dom
     * @memberof HotPoint
     */
    HotPoint.prototype.renderDom = function () {
        var _this = this;
        // 遍历点数据，对未渲染的点进行渲染操作
        Object.entries(this.hotPointMap)
            .forEach(function (_a) {
            var key = _a[0], point = _a[1];
            // 已经生成元素的不做处理
            if (point.el instanceof HTMLElement)
                return;
            var el = _this.createPointElement(point);
            if (!el)
                return;
            _this.el.insertAdjacentElement('beforeend', el);
            // 渲染后，更新 EL
            _this.hotPointMap[key] = __assign(__assign({}, point), { el: el });
        });
    };
    /**
     * 创建单个热点元素
     * @private
     * @param {IHotPoint} point
     * @memberof HotPoint
     */
    HotPoint.prototype.createPointElement = function (point) {
        // 当传入数据的timing大于视频长度时，不会生成有效标记元素
        if (!this.isValidHotPoint(point)) {
            this.logger.warn('ctrlbar: hotpoint 入值非法，已忽略', point);
            return;
        }
        // 计算位置
        var ele = document.createElement('div');
        // 这里以 ctrl.duration 来计算，一般情况下为 player.duration，假显时以假显值为准
        var pos = (point.timing / this.ctrlbar.duration) * 100;
        ele.classList.add(HotPoint.defaultPointClass);
        ele.style.left = pos + "%";
        // 绑定数据信息至元素
        ele.dataset.info = JSON.stringify(point);
        return ele;
    };
    /**
     * 初始化热点文案元素
     * @private
     * @memberof HotPoint
     */
    HotPoint.prototype.setupTip = function () {
        var tipEl;
        // 当存在调用方自定义文案元素时，使用自定义元素
        if (this.config.hotPointCustomTipEl) {
            tipEl = this.config.hotPointCustomTipEl;
        }
        else {
            // 反之使用默认文案元素
            tipEl = document.createElement('div');
            tipEl.classList.add(HotPoint.defaultTipClass);
        }
        // 先隐藏元素
        tipEl.classList.add(HotPoint.hideClassName);
        this.el.insertAdjacentElement('beforeend', tipEl);
        this.tipEl = tipEl;
    };
    Object.defineProperty(HotPoint.prototype, "offsetLeft", {
        get: function () {
            return this.player.container.getBoundingClientRect().left;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 鼠标事件代理
     * @private
     * @param {MouseEvent} mouseEvent
     * @memberof HotPoint
     */
    HotPoint.prototype.mouseEvtHandler = function (mouseEvent) {
        var dataset = mouseEvent.target.dataset;
        if (!dataset.info)
            return;
        var hotPointTipType = this.config.hotPointTipType;
        // 从dataset中获取元素信息
        var point = JSON.parse(dataset.info);
        if (hotPointTipType === HOTPOINT_TIP_TYPE.DEFAULT) {
            // 当tip模式为default时,调用默认的事件处理逻辑
            this.mouseEvtFuncMap[mouseEvent.type]({ point: point, mouseEvent: mouseEvent });
        }
        // 其他情况不处理事件，仅通过控制栏实例进行广播
        this.ctrlbar.emit(mouseEvtMap[mouseEvent.type], { point: point, mouseEvent: mouseEvent, hotPointTipType: hotPointTipType });
    };
    /**
     * 鼠标移入事件
     * @private
     * @memberof HotPoint
     */
    HotPoint.prototype.onMouseOver = function (e) {
        var point = e.point;
        if (!this.tipEl || !point.text)
            return;
        this.tipEl.textContent = point.text;
        this.tipEl.classList.remove(HotPoint.hideClassName);
    };
    /**
     * 鼠标移动事件
     * @private
     * @memberof HotPoint
     */
    HotPoint.prototype.onMouseMove = function (e) {
        if (!this.tipEl)
            return;
        var mouseEvent = e.mouseEvent;
        var container = this.player.container;
        var curPreviewWidth = this.tipEl.getBoundingClientRect().width;
        // 计算右边界
        var left = (mouseEvent.clientX - this.offsetLeft) - (curPreviewWidth / 2);
        if (left < 0)
            left = 0;
        if (left > container.clientWidth - curPreviewWidth)
            left = container.clientWidth - curPreviewWidth;
        this.tipEl.style.transform = "translateX(" + left + "px)";
    };
    /**
     * 鼠标移出事件
     * @private
     * @memberof HotPoint
     */
    HotPoint.prototype.onMouseOut = function () {
        if (!this.tipEl)
            return;
        this.tipEl.classList.add(HotPoint.hideClassName);
    };
    HotPoint.sel = '.txp_hotpoint';
    HotPoint.compName = 'HotPoint';
    // 热点样式
    HotPoint.defaultPointClass = 'txp_interact_dot';
    // 热点文案样式
    HotPoint.defaultTipClass = 'txp_hotpoint_tip';
    return HotPoint;
}(Component));

var LanguagePopup = /** @class */ (function (_super) {
    __extends(LanguagePopup, _super);
    function LanguagePopup(player, config, ctrlbar) {
        var _this = _super.call(this, player, __assign(__assign({}, config), { selector: LanguagePopup.popupSelector, modSelector: LanguagePopup.modSelector }), ctrlbar) || this;
        _this.popupName = 'language';
        _this.onSelect = function (val) {
            _this.ctrlbar.emit(CTRL_EVENTS.SET_LANGUAGE, val);
        };
        return _this;
    }
    LanguagePopup.isEnabled = function (config) {
        return !(config.isMobile || config.disableLang);
    };
    LanguagePopup.compName = 'LanguagePopup';
    LanguagePopup.modSelector = '.mod_overlay.language';
    LanguagePopup.popupSelector = '.txp_right_controls .txp_btn_language';
    return LanguagePopup;
}(Popup));

/** 进度条 */
var Progress = /** @class */ (function (_super) {
    __extends(Progress, _super);
    function Progress(player, config, ctrlbar) {
        var _a;
        var _this = _super.call(this, player, Progress.sel, config) || this;
        _this.ctrlbar = ctrlbar;
        _this.isMouseDown = false;
        /** 进度条百分比最大值，范围 0 ~ 1 */
        _this.maxPercent = 1;
        _this.isActive = true;
        _this.shouldHideHoverTime = false;
        _this.onMouseMove = function (evt) {
            evt.preventDefault();
            if (!_this.isMouseDown)
                return;
            var percent = Math.min(_this.getPercentByClientX(evt), _this.maxPercent);
            _this.updateProgress(percent);
            _this.ctrlbar.emit(CTRL_EVENTS.MOUSE_MOVE, percent);
            // 阻止系统手势
            evt.preventDefault();
        };
        _this.onMouseUp = function (evt) {
            evt.preventDefault();
            // 滑动操作结束后，移除事件监听
            document.removeEventListener('touchmove', _this.onMouseMove);
            document.removeEventListener('mousemove', _this.onMouseMove);
            document.removeEventListener('touchend', _this.onMouseUp);
            document.removeEventListener('mouseup', _this.onMouseUp);
            if (!_this.isMouseDown)
                return;
            _this.player.setStateKv("ctrlbar:" + Progress.compName + ":" + (_this.isMobile ? 'touchend' : 'mouseup'), {
                type: LOG_TYPE.USER_ACTION,
                eventId: _this.evtId,
            });
            _this.isMouseDown = false;
            var percent = parseFloat(_this.progressPlayed.style.width) / 100;
            _this.doSeek(percent);
            _this.ctrlbar.emit(CTRL_EVENTS.MOUSE_UP, percent);
        };
        _this.onMouseDown = function (evt) {
            // 防止 mouseDown 后还去触发 touch 事件
            evt.preventDefault();
            // 当鼠标按下后，开始监听滑动事件
            document.addEventListener('touchend', _this.onMouseUp);
            document.addEventListener('mouseup', _this.onMouseUp);
            document.addEventListener('touchmove', _this.onMouseMove, { passive: false });
            document.addEventListener('mousemove', _this.onMouseMove, { passive: false });
            _this.evtId = _this.player.dataset.generateEvtId();
            _this.player.setStateKv("ctrlbar:" + Progress.compName + ":" + (_this.isMobile ? 'touchstart' : 'mousedown'), {
                type: LOG_TYPE.USER_ACTION,
                eventId: _this.evtId,
            });
            if (_this.player.state === VIDEO_STATE$1.IDLE)
                return;
            _this.beforeSeek();
            _this.isMouseDown = true;
            var percent = Math.min(_this.getPercentByClientX(evt), _this.maxPercent);
            _this.updateProgress(percent);
            _this.ctrlbar.emit(CTRL_EVENTS.MOUSE_DOWN, percent);
        };
        _this.eventMap = (_a = {},
            _a[PLAY_EVENT$1.TIME_UPDATE] = _this.onTimeUpdate.bind(_this),
            _a[PLAY_EVENT$1.STATE_CHANGE] = _this.onStateChange.bind(_this),
            _a[PLAY_EVENT$1.VIDEO_BUFFER_CHANGE] = function () { return _this.updateBufferedBar(); },
            _a);
        _this.setEvts();
        _this.progressLoaded = _this.el.querySelector('.txp_progress_load');
        _this.progressPlayed = _this.el.querySelector('.txp_progress_play');
        _this.scrubber = _this.el.querySelector('.txp_btn_scrubber');
        _this.tooltip = _this.el.querySelector('.txp_tooltip');
        var tooltipWidth = 45;
        _this.tooltipPosLimit = (tooltipWidth / _this.player.container.clientWidth / 2 * 100) + 0.5;
        // h5 dom差异
        if (_this.isMobile) {
            _this.el.appendChild(_this.scrubber);
        }
        // 监听 touch + mouse 事件，保证 ipad 这类移动端设备使用桌面端 UI 时候，能够正常拖拽进度条
        _this.el.addEventListener('touchstart', _this.onMouseDown);
        _this.el.addEventListener('mousedown', _this.onMouseDown);
        /** 设置进度条时间tip */
        if (!_this.isMobile) {
            _this.setTooltipOnHover();
            _this.el.addEventListener('mouseover', function () {
                ctrlbar.emit(CTRL_EVENTS.HOVER_PROGRESS);
            });
        }
        _this.listenReqInfoEnd();
        return _this;
    }
    Object.defineProperty(Progress.prototype, "offsetLeft", {
        /** 进度条距离窗口左边界值 */
        get: function () {
            return this.el.getBoundingClientRect().left;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Progress.prototype, "bufferedTime", {
        get: function () {
            var _this = this;
            var videoBuffered = this.player.videoBuffered;
            var len = videoBuffered.length;
            if (len === 1)
                return videoBuffered[0].end;
            var time = 0;
            videoBuffered.forEach(function (buffer, i) {
                var start = buffer.start, end = buffer.end;
                var playtime = _this.playtime;
                if (playtime >= start && playtime <= end) {
                    // 检测连续多个buffer段
                    if (len > i + 1) {
                        for (var j = i + 1; j < len; j++) {
                            var nextBuf = videoBuffered[j].start - videoBuffered[j - 1].end;
                            if (0 <= nextBuf && nextBuf <= 0.2) {
                                time = videoBuffered[j].end;
                            }
                            else {
                                time = videoBuffered[j - 1].end;
                                break;
                            }
                        }
                    }
                    else {
                        time = buffer.end;
                    }
                }
            });
            return time;
        },
        enumerable: false,
        configurable: true
    });
    Progress.prototype.destroy = function () {
        this.el.removeEventListener('touchstart', this.onMouseDown);
        this.el.removeEventListener('mousedown', this.onMouseDown);
        document.removeEventListener('touchmove', this.onMouseMove);
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('touchend', this.onMouseUp);
        document.removeEventListener('mouseup', this.onMouseUp);
        _super.prototype.destroy.call(this);
    };
    /**
     * 设置进度条是否为激活状态，如果未激活，无播放器事件监听，ui隐藏。激活状态反之。
     * @param value 是否激活
     */
    Progress.prototype.setActive = function (value) {
        if (this.isActive === value) {
            return;
        }
        this.isActive = value;
        this.setEvts(!this.isActive);
        if (this.isActive) {
            this.showEl();
        }
        else {
            this.hideEl();
        }
    };
    Progress.prototype.setTooltip = function (percent) {
        var _a = this, tooltip = _a.tooltip, tooltipPosLimit = _a.tooltipPosLimit;
        tooltip.innerText = commonTool.formatPlayTime(percent * this.ctrlbar.duration);
        var left = Math.max(tooltipPosLimit, Math.min(percent * 100, 100 - tooltipPosLimit));
        tooltip.style.left = left + "%";
    };
    Progress.prototype.updateBufferedBar = function (time) {
        if (time === void 0) { time = this.bufferedTime; }
        if (time === 0) {
            // 视频结束时期望强制归0
            this.progressLoaded.style.width = '0';
            return;
        }
        if (!this.ctrlbar.duration || typeof time !== 'number')
            return;
        var per = Math.min(Math.round(time * 100 / this.ctrlbar.duration), this.maxPercent * 100);
        if (per >= 99)
            per = 100;
        this.progressLoaded.style.width = per + "%";
    };
    /**
     * 更新进度条时间点
     * @param val 百分比，范围0~1
     */
    Progress.prototype.updateProgress = function (val) {
        if (Number.isNaN(val))
            return;
        var percent = val * 100;
        this.progressPlayed.style.width = percent + "%";
        this.scrubber.style.left = percent + "%";
    };
    /** 返回当前鼠标位置在进度条上的百分比 0-1 */
    Progress.prototype.getPercentByClientX = function (evt) {
        var clientX = ('touches' in evt ? evt.touches[0] : evt).clientX;
        var evtWidth = clientX - this.offsetLeft;
        if (Math.abs(evtWidth - this.el.clientWidth) <= 1) {
            // 鼠标事件的clientX是永远达不到进度条宽度的（永远差1px，例如进度条宽度1000，那clientX最多到999），那么非常接近进度条宽度时需要将
            // 1px误差修正
            evtWidth = this.el.clientWidth;
        }
        var percent = evtWidth / this.el.clientWidth;
        percent = Math.max(0, Math.min(1, percent));
        return percent;
    };
    Progress.prototype.onTimeUpdate = function () {
        if (this.isMouseDown)
            return;
        var percent = this.playtime / this.ctrlbar.duration;
        this.updateProgress(percent);
        this.updateBufferedBar();
    };
    Progress.prototype.onStateChange = function (_a) {
        var data = _a.data;
        if ([VIDEO_STATE$1.IDLE, VIDEO_STATE$1.END].indexOf(data.new) !== -1) {
            this.updateProgress(0);
            this.updateBufferedBar(0);
        }
    };
    Progress.prototype.setTooltipOnHover = function () {
        var _this = this;
        this.el.addEventListener('mouseover', function (evt) {
            // 传入 hideHoverTime=true 时不展示tips
            if (_this.config.hideHoverTime)
                return;
            // 未传入 hideHoverTime 并且根据 getInfo 返回判断应该隐藏时，也不展示
            if (_this.config.hideHoverTime === undefined && _this.shouldHideHoverTime)
                return;
            var percent = _this.getPercentByClientX(evt);
            _this.setTooltip(percent);
            _this.showEl(_this.tooltip);
            // tooltip默认隐藏 这里要额外设置下display
            _this.tooltip.style.display = 'flex';
        });
        this.el.addEventListener('mouseout', function () { return _this.hideEl(_this.tooltip); });
        this.el.addEventListener('mousemove', function (evt) {
            var percent = _this.getPercentByClientX(evt);
            _this.setTooltip(percent);
        });
    };
    Progress.prototype.beforeSeek = function () {
        var _this = this;
        var pauseDelay = 300;
        this.pauseTimer = window.setTimeout(function () { return _this.player.pause(); }, pauseDelay);
    };
    Progress.prototype.doSeek = function (percent) {
        var timeOffset = this.config.timeOffset;
        var time = percent * this.ctrlbar.duration;
        this.player.seek(timeOffset ? timeOffset(time, true) : time);
        if (this.pauseTimer) {
            window.clearTimeout(this.pauseTimer);
            this.pauseTimer = null;
        }
        if (this.player.state === VIDEO_STATE$1.PAUSE && !this.player.config.remainPauseStateAfterSeek) {
            // remainPauseStateAfterSeek指定要保留暂停状态！修改是满足“智影”这种编辑视频的场景，需要在pause状态下不断seek。
            this.player.play();
        }
    };
    /** 根据 getInfo 返回值判断是否展示tips */
    Progress.prototype.listenReqInfoEnd = function () {
        var _this = this;
        this.player.pluginMsg.on(H5_EXT_EVENT.GETINFO_OVER, function (_a) {
            var _b, _c, _d;
            var data = _a.data;
            var plugins = _this.player.plugins;
            var previewPluginName = 'ui-preview';
            var previewListPluginName = 'ui-preview-list';
            var isPreviewPluginExist = plugins[previewPluginName] || plugins[previewListPluginName];
            var isVideoPreview = ((_b = data.parseData) === null || _b === void 0 ? void 0 : _b.preview) > 0;
            // 非试看并且有预览图时，隐藏进度条上的时间tips
            _this.shouldHideHoverTime = !!(isPreviewPluginExist && !isVideoPreview && ((_d = (_c = data.parseData) === null || _c === void 0 ? void 0 : _c.previewList) === null || _d === void 0 ? void 0 : _d.length));
        });
    };
    Progress.sel = '.txp_progress_bar_container';
    Progress.compName = 'Progress';
    return Progress;
}(Component));

// 一、如果是流播放时间大于等于最大回看时长：
/** 时间更新粒度 */
var TIME_UPDATE_GAP_MS = 200;
var PLAY_BACK_STATE;
(function (PLAY_BACK_STATE) {
    /** 进入直播的初始状态 */
    PLAY_BACK_STATE["IDLE"] = "idle";
    /** 回看中 */
    PLAY_BACK_STATE["BACK_PLAYING"] = "backPlaying";
    /** 直播中 */
    PLAY_BACK_STATE["LIVE_PLAYING"] = "livePlaying";
})(PLAY_BACK_STATE || (PLAY_BACK_STATE = {}));
/**
 * 直播回看的进度条，seek操作，tips等逻辑和点播有差异。
 */
var LiveProgress = /** @class */ (function (_super) {
    __extends(LiveProgress, _super);
    function LiveProgress(player, config, ctrlbar, extra) {
        var _this = _super.call(this, player, config, ctrlbar) || this;
        _this.ctrlbar = ctrlbar;
        _this.timeupdateTimerID = 0;
        _this.playbackStateInner = PLAY_BACK_STATE.IDLE;
        /** 最大回看时长是否已经超过直播已经开始的时长 */
        _this.maxBackDurationOverflow = false;
        /** 当前回看状态下的回退时长，为固定值，只有seek操作才会修改，单位毫秒 */
        _this.curBackDurationMS = 0;
        _this.liveStateTimeStr = '';
        _this.isSwitchBackOp = false;
        _this.playerApiForPlugins = extra === null || extra === void 0 ? void 0 : extra.api;
        _this.logger = new Logger(_this.player.config.instanceId, 'LiveProgress');
        _this.addReturnLiveBtn();
        _this.addLiveTimeDisplay();
        // 直播的进度条默认不激活
        _this.setActive(false);
        _this.addPlayerEvts();
        return _this;
    }
    LiveProgress.isEnabled = function (config) {
        var isMobile = config.isMobile;
        return !isMobile;
    };
    LiveProgress.prototype.destroy = function () {
        var _a, _b;
        if ((_a = this.liveTimeDisplayDom) === null || _a === void 0 ? void 0 : _a.parentNode) {
            this.liveTimeDisplayDom.remove();
            this.liveTimeDisplayDom = null;
        }
        if ((_b = this.returnLiveBtn) === null || _b === void 0 ? void 0 : _b.parentNode) {
            this.returnLiveBtn.remove();
            this.returnLiveBtn = null;
        }
        this.playerApiForPlugins = null;
        this.setTimeupdateTimer(false);
        _super.prototype.destroy.call(this);
    };
    LiveProgress.prototype.setActive = function (value) {
        _super.prototype.setActive.call(this, value);
        this.liveTimeDisplayDom.style.display = value ? 'flex' : 'none';
        this.hideEl(this.returnLiveBtn);
    };
    LiveProgress.prototype.setTooltip = function (percent) {
        var _a = this, tooltip = _a.tooltip, tooltipPosLimit = _a.tooltipPosLimit;
        var left = Math.max(tooltipPosLimit, Math.min(percent * 100, 100 - tooltipPosLimit));
        var timeTipStr = this.getTimeTip(percent);
        tooltip.style.left = left + "%";
        tooltip.innerText = timeTipStr;
    };
    LiveProgress.prototype.updateBufferedBar = function (time) {
        if (time === void 0) { time = this.bufferedTime; }
        // 更新缓冲进度的这个函数写先重写为空方法，按点播的计算方法是错的，因此这里重写为空方法。
    };
    LiveProgress.prototype.onTimeUpdate = function () {
        // 直播回看时的播放进度点驱动不靠video标签的timeupdate事件驱动，因此这里重写为空方法。
    };
    LiveProgress.prototype.onStateChange = function () {
        // 状态变化不需要影响进度条显影
    };
    LiveProgress.prototype.beforeSeek = function () {
        // 回看在seek时候不能暂停，因此这里重写为空方法。
    };
    LiveProgress.prototype.doSeek = function (percent) {
        this.seek(percent);
    };
    LiveProgress.prototype.addLiveTimeDisplay = function () {
        var container = this.ctrlbar.el.querySelector('.txp_left_controls');
        // 回看时间默认是隐藏状态，设置为display:none
        var tmp = "<txpdiv class=\"txp_time_display txp_time_display_live\" style=\"display: none;\">\n      <txpdiv class=\"txp_live_badge\" style=\"display: block\">\u76F4\u64AD\u4E2D</txpdiv>\n    </txpdiv>";
        this.liveTimeDisplayDom = domTool.creatDom(tmp);
        this.liveBadgeDom = this.liveTimeDisplayDom.querySelector('.txp_live_badge');
        container.append(this.liveTimeDisplayDom);
    };
    LiveProgress.prototype.addReturnLiveBtn = function () {
        var _this = this;
        var container = this.ctrlbar.el.querySelector('.txp_left_controls');
        var tmp = "<txpdiv class=\"txp_btn txp_btn_return txp_none\">\n      <txpdiv class=\"txp_label\">\u8FD4\u56DE\u76F4\u64AD</txpdiv>\n    </txpdiv>";
        this.returnLiveBtn = domTool.creatDom(tmp);
        container.append(this.returnLiveBtn);
        this.returnLiveBtn.addEventListener('click', function () {
            // 基类实现的进度条拖动，回调的位置为0~1。如果是走到进度条最右边，相当于返回直播，传值为1。
            _this.seek(1);
        });
    };
    LiveProgress.prototype.updateLiveTime = function (prefix, timeStr) {
        if (timeStr === void 0) { timeStr = ''; }
        domTool.text(this.liveBadgeDom, prefix + " " + timeStr);
    };
    /**
     * 设置是否是回看状态中的界面
     * @param value 是否回看状态
     */
    LiveProgress.prototype.setPlayBackState = function (value) {
        if (value) {
            // 设置“直播时间”和“返回直播按钮”的显隐
            domTool.addClass(this.liveBadgeDom, 'txp_live_badge_back');
            this.showEl(this.returnLiveBtn);
        }
        else {
            domTool.removeClass(this.liveBadgeDom, 'txp_live_badge_back');
            this.hideEl(this.returnLiveBtn);
        }
    };
    LiveProgress.prototype.addPlayerEvts = function () {
        var _this = this;
        // 开始监听getinfo结果变化，根据getinfo返回的结果来决定是否激活进度条
        this.player.on(H5_PLAY_EVENT.VIDEO_REQ_INFO_END, function (_a) {
            var _b;
            var data = _a.data;
            var getinfoData = data.data;
            if (!getinfoData || getinfoData.error) {
                // 请求出错，不需要做什么
                return;
            }
            var resData = (getinfoData || {}).resData;
            // 拿到服务器时间后，马上记录本地时间
            _this.clientStartTimeMS = Date.now();
            _this.playbackData = (_b = resData) === null || _b === void 0 ? void 0 : _b.playback;
            if (!_this.playbackData) {
                // 后台给到playback字段为空，说明此直播无回看能力
                _this.setPlayBackEnabled(false);
                return;
            }
            if (_this.playbackState === PLAY_BACK_STATE.IDLE) {
                // 如果前一次状态是idle才会设置，其他状态什么也不做
                _this.setPlayBackEnabled(true);
                if (_this.player.loadParam.videoReqInfoParam.playbacktime > 0) {
                    _this.enterState(PLAY_BACK_STATE.BACK_PLAYING);
                }
                else {
                    _this.enterState(PLAY_BACK_STATE.LIVE_PLAYING);
                }
            }
        });
        this.player.on(H5_PLAY_EVENT.PLAY_SESSION_END, function () {
            if (_this.isSwitchBackOp) {
                _this.isSwitchBackOp = false;
                return;
            }
            // 不是切换回看、回看seek操作，则重置状态。
            _this.enterState(PLAY_BACK_STATE.IDLE);
        });
        this.player.on(H5_PLAY_EVENT.VIDEO_PLAYING, function () {
            _this.isSwitchBackOp = false;
        });
    };
    /**
     * 设置当前是否有回看能力，如果没有，隐藏回看进度条等。
     */
    LiveProgress.prototype.setPlayBackEnabled = function (value) {
        this.setActive(value);
        this.setTimeupdateTimer(value);
    };
    /**
     * 在有回看能力时，进入回看状态还是直播状态。
     * @param state 进入的状态
     * @param data.backDurationMS 回退时长
     */
    LiveProgress.prototype.enterState = function (state, data) {
        var _this = this;
        if (!this.playbackData) {
            // 无回看能力
            return;
        }
        if (this.playbackState === state) {
            return;
        }
        var oldState = this.playbackState;
        this.logger.log("enterState from " + oldState + " to " + state);
        if (oldState === PLAY_BACK_STATE.IDLE && state === PLAY_BACK_STATE.LIVE_PLAYING) {
            this.playbackState = state;
        }
        else if (oldState === PLAY_BACK_STATE.LIVE_PLAYING && state === PLAY_BACK_STATE.BACK_PLAYING) {
            // 从前置的直播中状态切换到回看中状态，相当于用户主动进入回看中，需要设置回看的界面，并且根据用户回看位置开始请求新的视频地址。
            var backDurationMS_1 = data.backDurationMS;
            var backAbsoluteTimeS = this.calcBackAbsoluteTimeS(Date.now(), backDurationMS_1);
            this.switchPlay(backAbsoluteTimeS, function () {
                _this.curBackDurationMS = backDurationMS_1;
                _this.playbackState = state;
            }, function (err) {
                // 回看失败，回退到直播
                _this.playbackState = PLAY_BACK_STATE.LIVE_PLAYING;
                var _a = err || {}, code = _a.code, message = _a.message, data = _a.data;
                if (code === null || code === void 0 ? void 0 : code.startsWith(ErrorCode.GETINFO_LIVE_SERVER_CODE_PREFIX)) {
                    _this.emitPlayerEvts('playbackFailed', __assign({ code: code, message: message }, data));
                }
                var tips = _this.player.plugins.tips;
                if (typeof (tips === null || tips === void 0 ? void 0 : tips.show) === 'function') {
                    tips.show('抱歉，进入回看失败...');
                }
                _this.logger.warn("enter playback failed, code=" + code + ", message=" + message);
            });
        }
        else if (oldState === PLAY_BACK_STATE.BACK_PLAYING && state === PLAY_BACK_STATE.LIVE_PLAYING) {
            // 从前置的回看中状态切换到直播状态，相当于用户退出回看中状态回到直播，需要设置直播中的界面，并且重新请求最新的直播流
            this.switchPlay(0, function () {
                _this.playbackState = state;
            });
        }
        else if (state === PLAY_BACK_STATE.IDLE) {
            this.playbackState = state;
        }
    };
    Object.defineProperty(LiveProgress.prototype, "playbackState", {
        get: function () {
            return this.playbackStateInner;
        },
        set: function (value) {
            this.playbackStateInner = value;
            this.onPlaybackStateChange(value);
            this.emitPlayerEvts('playbackStateChange', { state: this.playbackState });
        },
        enumerable: false,
        configurable: true
    });
    LiveProgress.prototype.onPlaybackStateChange = function (value) {
        switch (value) {
            case PLAY_BACK_STATE.LIVE_PLAYING:
                this.exitBackPlaying();
                break;
            case PLAY_BACK_STATE.BACK_PLAYING:
                this.enterBackPlaying();
                break;
            case PLAY_BACK_STATE.IDLE:
                // 任何前置状态进入idle状态，都相当于直播停止了
                this.exitBackPlaying();
                this.setPlayBackEnabled(false);
                break;
        }
    };
    LiveProgress.prototype.emitPlayerEvts = function (evtName) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        (_a = this.player).emit.apply(_a, __spreadArray([evtName], args, false));
    };
    LiveProgress.prototype.switchPlay = function (playbacktime, succCallback, failCallback) {
        var _a;
        this.isSwitchBackOp = true;
        if ((_a = this.playerApiForPlugins) === null || _a === void 0 ? void 0 : _a.replayInCurFlowNode) {
            this.playerApiForPlugins.replayInCurFlowNode(this.player.vid, {
                videoReqInfoParam: {
                    // 传给getinfo回看时间
                    playbacktime: playbacktime,
                },
            })
                .then(function () {
                succCallback === null || succCallback === void 0 ? void 0 : succCallback();
            })
                .catch(function (err) {
                failCallback === null || failCallback === void 0 ? void 0 : failCallback(err);
            });
        }
    };
    /**
     * 在回看状态下的seek操作，不请求getinfo，仅修改当前正在播放的url的参数，并重新请求流
     */
    LiveProgress.prototype.seekInBackState = function (data) {
        var _a;
        var backDurationMS = data.backDurationMS;
        var backAbsoluteTimeS = this.calcBackAbsoluteTimeS(Date.now(), backDurationMS);
        var playingUrl = this.player.currentVideoInfo.loadingUrl;
        var seekUrl = urlTool.updateUrlParam(playingUrl, 'wsStreamTimeABS', "" + backAbsoluteTimeS);
        this.curBackDurationMS = backDurationMS;
        this.isSwitchBackOp = true;
        if ((_a = this.playerApiForPlugins) === null || _a === void 0 ? void 0 : _a.replayInCurFlowNode) {
            this.playerApiForPlugins.replayInCurFlowNode({
                url: seekUrl,
            });
        }
    };
    /**
     * 进入回看状态
     */
    LiveProgress.prototype.enterBackPlaying = function () {
        this.setPlayBackState(true);
        this.updateLiveTime('回看中');
    };
    /**
     * 退出回看状态
     */
    LiveProgress.prototype.exitBackPlaying = function () {
        // 直播状态下，进度条一直是1（最新时间在最右）
        this.updateProgress(1);
        this.setPlayBackState(false);
        this.curBackDurationMS = 0;
        this.updatePlaybackTime(0);
        this.updateLiveTime('直播中');
    };
    LiveProgress.prototype.updatePlaybackTime = function (backAbsoluteTimeS) {
        var _a, _b;
        this.player.loadParam.videoReqInfoParam.playbacktime = backAbsoluteTimeS;
        // TODO：播放器updateReqInfo接口暂无，需要播放器发版本以后去掉as any
        (_b = (_a = this.player).updateReqInfo) === null || _b === void 0 ? void 0 : _b.call(_a, {
            videoReqInfoParam: { playbacktime: backAbsoluteTimeS },
        });
    };
    LiveProgress.prototype.setTimeupdateTimer = function (value) {
        if (value) {
            if (this.timeupdateTimerID === 0) {
                this.timeupdateTimerID = window.setInterval(this.onTimeupdate.bind(this), TIME_UPDATE_GAP_MS);
            }
        }
        else {
            if (this.timeupdateTimerID > 0) {
                window.clearInterval(this.timeupdateTimerID);
                this.timeupdateTimerID = 0;
            }
        }
    };
    /**
     * 获取可以回退的最大时长，单位秒。分两种情况：
     * 1. 如果当前直播时长小于服务器提供的回看时长，则返回当前直播时长（此时会不断更新），
     * 2. 如果当前直播时长大于或等于服务器回看时长，则始终返回服务器回看时长
     */
    LiveProgress.prototype.calcMaxBackDurationS = function (nowTime) {
        var playbacktime = this.playbackData.playbacktime;
        if (this.maxBackDurationOverflow) {
            return playbacktime;
        }
        var liveDur = this.calcStreamAbsoluteDurationMS(nowTime) / 1000;
        if (liveDur < playbacktime) {
            this.maxBackDurationOverflow = false;
            return liveDur;
        }
        this.maxBackDurationOverflow = true;
        return playbacktime;
    };
    /**
     * 当前绝对时间，单位毫秒
     */
    LiveProgress.prototype.calcAbsoluteTimeMS = function (nowTime) {
        // 拿到的服务器绝对时间，加上本地时间偏移
        return this.playbackData.svrtick * 1000 + (nowTime - this.clientStartTimeMS);
    };
    /**
     * 当前直播流相对于流发布时间已经播放过的时长，单位毫秒
     */
    LiveProgress.prototype.calcStreamAbsoluteDurationMS = function (nowTime) {
        // 当前绝对时间，减去直播流开始的绝对时间
        return this.calcAbsoluteTimeMS(nowTime) - this.playbackData.playbackstart * 1000;
    };
    /**
     * 计算正在回看的时间点（相对1970的绝对时间，跟着直播时间不断更新），单位秒
     * @param nowTime 当前客户端时间
     * @param backDurationMS 回退的时长
     */
    LiveProgress.prototype.calcBackAbsoluteTimeS = function (nowTime, backDurationMS) {
        return Math.round((this.calcAbsoluteTimeMS(nowTime) - backDurationMS) / 1000);
    };
    LiveProgress.prototype.onTimeupdate = function () {
        if (this.isMouseDown)
            return;
        if (this.player.state !== VIDEO_STATE$1.PLAYING) {
            return;
        }
        var liveStateTimeStr = '';
        var liveStatePrefix = '';
        var nowTime = Date.now();
        var streamAbsoluteDurationMS = this.calcStreamAbsoluteDurationMS(nowTime);
        if (this.playbackState === PLAY_BACK_STATE.BACK_PLAYING) {
            var maxBackDurationS = this.calcMaxBackDurationS(nowTime);
            var streamPlayingTimeS = (streamAbsoluteDurationMS - this.curBackDurationMS) / 1000;
            var backAbsoluteTimeS = this.calcBackAbsoluteTimeS(nowTime, this.curBackDurationMS);
            // 1. 在回看过程中可能会发生cgi重试，如果有重试的话，需要在请求后台时带上更新的回看时间点。因此回看的播放过程中，不断更新这个时间
            // 2. 可能出现切换清晰度，这时候也要带上最新的回看时间
            this.updatePlaybackTime(backAbsoluteTimeS);
            liveStatePrefix = '回看中';
            liveStateTimeStr = "" + commonTool.formatPlayTime(streamPlayingTimeS);
            // 直播时长还没有超过最大回看时长，这时如果是回看状态下，需要更新进度条上的白点
            if (!this.maxBackDurationOverflow) {
                var precent = (maxBackDurationS - this.curBackDurationMS / 1000) / maxBackDurationS;
                this.updateProgress(precent);
            }
        }
        else {
            liveStatePrefix = '直播中';
            liveStateTimeStr = "" + commonTool.formatPlayTime(streamAbsoluteDurationMS / 1000);
        }
        if (this.liveStateTimeStr !== liveStateTimeStr) {
            this.liveStateTimeStr = liveStateTimeStr;
            this.updateLiveTime(liveStatePrefix, liveStateTimeStr);
        }
    };
    /**
     * 根据进度条百分比位置换算成回退时长，返回值单位秒
     * @param percent 范围0～1
     */
    LiveProgress.prototype.calcPercent2BackTimeS = function (percent) {
        var maxBackDurationS = this.calcMaxBackDurationS(Date.now());
        var backDurationS = (1 - percent) * maxBackDurationS;
        return backDurationS;
    };
    LiveProgress.prototype.getTimeTip = function (percent) {
        var backDuration = this.calcPercent2BackTimeS(percent);
        var timeTipStr = commonTool.formatPlayTime(backDuration);
        return "\u56DE\u9000" + timeTipStr;
    };
    /**
     * 回看功能的seek操作。分两种情况：
     * 1. 如果是直播状态->回看状态，重新请求getinfo拿新的流（带上回看的目标时间点，绝地时间）
     * 2. 如果是回看状态中，修改url中的`wsStreamTimeABS`参数，重新请求url
     */
    LiveProgress.prototype.seek = function (percent) {
        if (percent === 1) {
            this.logger.log('percent===1, return to live');
            // 相当于返回直播
            this.enterState(PLAY_BACK_STATE.LIVE_PLAYING);
            return;
        }
        var backDurationMS = this.calcPercent2BackTimeS(percent) * 1000;
        if (this.playbackState === PLAY_BACK_STATE.LIVE_PLAYING) {
            this.logger.log('live to playback');
            // 从直播状态进入回看状态
            this.enterState(PLAY_BACK_STATE.BACK_PLAYING, { backDurationMS: backDurationMS });
        }
        else if (this.playbackState === PLAY_BACK_STATE.BACK_PLAYING) {
            this.logger.log('seek in playback');
            // 在回看状态下，修改url参数并重新播放
            this.seekInBackState({ backDurationMS: backDurationMS });
        }
    };
    return LiveProgress;
}(Progress));

var LoopStatus;
(function (LoopStatus) {
    LoopStatus["Loop"] = "true";
    LoopStatus["NotLoop"] = "false";
})(LoopStatus || (LoopStatus = {}));
var LocalLoopConfigKey = 'thumbplayer-h5-loop';
/** 循环播放按钮 */
var Loop = /** @class */ (function (_super) {
    __extends(Loop, _super);
    function Loop(player, config, ctrlbar) {
        var _this = _super.call(this, player, Loop.sel, config) || this;
        _this.ctrlbar = ctrlbar;
        _this.tip = _this.el.querySelector('.txp_tooltip');
        _this.setupDOMEvents();
        _this.initLoopConfig();
        return _this;
    }
    Loop.isEnabled = function (config) {
        var enableLoop = config.enableLoop, isMobile = config.isMobile;
        return enableLoop && !isMobile;
    };
    Object.defineProperty(Loop.prototype, "isLoopMode", {
        /** 从dataset中获取当前状态 */
        get: function () {
            // dom节点的dataset的默认值为false
            return this.el.dataset.status === LoopStatus.Loop;
        },
        /** 设置dataset状态并缓存 */
        set: function (val) {
            this.player.config.loop = val;
            this.el.dataset.status = String(val);
            this.tip.innerText = val ? '关闭循环播放' : '打开循环播放';
        },
        enumerable: false,
        configurable: true
    });
    Loop.prototype.setupDOMEvents = function () {
        var _this = this;
        this.el.addEventListener(this.CLICK_EVENT_NAME, function () {
            _this.isLoopMode = !_this.isLoopMode;
            lsTool.setData(LocalLoopConfigKey, _this.isLoopMode ? LoopStatus.Loop : LoopStatus.NotLoop);
            _this.ctrlbar.emit(CTRL_EVENTS.CLICK_LOOP, { loop: _this.isLoopMode });
        });
    };
    /** 读取用户初始化配置和本地缓存，更新到组件内 */
    Loop.prototype.initLoopConfig = function () {
        // 优先读取用户传入的配置
        var loop = this.player.config.loop;
        if (typeof loop !== 'undefined') {
            this.isLoopMode = !!loop;
            return;
        }
        // 如果用户没有传入配置，则读取本地缓存
        var localConfig = lsTool.getData(LocalLoopConfigKey);
        if (localConfig) {
            this.isLoopMode = localConfig === LoopStatus.Loop;
        }
    };
    Loop.compName = 'Loop';
    Loop.sel = '.txp_left_controls .txp_btn_loop';
    return Loop;
}(Component));

var DEFAULT_AUTO_HIDE_TIMEOUT = 10 * 1000;
var MuteTips = /** @class */ (function (_super) {
    __extends(MuteTips, _super);
    function MuteTips(player, config, ctrlbar) {
        var _this = _super.call(this, player, MuteTips.sel, config) || this;
        _this.ctrlbar = ctrlbar;
        _this.onUnmuteBtnClick = function () {
            _this.player.muted = false;
            _this.hideEl();
        };
        _this.onCloseBtnClick = function () {
            _this.hideEl();
        };
        _this.onRootMouseEnter = function () {
            // 当鼠标 enter 后，重新刷新隐藏 tips 的定时器
            _this.hide(_this.hideTimeout);
        };
        _this.onAutoplayInMuted = function () {
            _this.show(_this.hideTimeout);
        };
        _this.setDOM();
        _this.bindEvents(true);
        _this.hideEl();
        return _this;
    }
    MuteTips.isEnabled = function (config) {
        var isMobile = config.isMobile;
        return !isMobile;
    };
    Object.defineProperty(MuteTips.prototype, "isShow", {
        get: function () {
            return this.el.classList.contains('txp_none');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MuteTips.prototype, "hideTimeout", {
        get: function () {
            var _a;
            return (_a = this.config.muteTipsHideTimeout) !== null && _a !== void 0 ? _a : DEFAULT_AUTO_HIDE_TIMEOUT;
        },
        enumerable: false,
        configurable: true
    });
    MuteTips.prototype.destroy = function () {
        this.bindEvents(false);
        clearTimeout(this.autoHideTimer);
    };
    MuteTips.prototype.hide = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = 300; }
        clearTimeout(this.autoHideTimer);
        if (timeout > 0) {
            this.autoHideTimer = setTimeout(function () {
                _this.hideEl();
            }, timeout);
        }
    };
    MuteTips.prototype.setDOM = function () {
        this.unmuteBtn = this.el.querySelector('.txp_btn_unmuted');
        this.closeBtn = this.el.querySelector('.txp_tips_close_btn');
    };
    MuteTips.prototype.bindEvents = function (isBind) {
        if (isBind === void 0) { isBind = false; }
        var rootElBinder = getEventTargetBinder(this.el, isBind);
        var closeBtnBinder = getEventTargetBinder(this.closeBtn, isBind);
        var unmuteBtnBinder = getEventTargetBinder(this.unmuteBtn, isBind);
        var pluginMsgBinder = getEventEmitterBinder(this.player.pluginMsg, isBind);
        rootElBinder('mouseenter', this.onRootMouseEnter);
        closeBtnBinder('click', this.onCloseBtnClick);
        unmuteBtnBinder('click', this.onUnmuteBtnClick);
        pluginMsgBinder(H5_EXT_EVENT.AUTOPLAY_IN_MUTED, this.onAutoplayInMuted);
    };
    /**
     * 展示 tips ，并在 5000 ms 后隐藏
     * 如果 timeout < 0，则不自动隐藏
     */
    MuteTips.prototype.show = function (timeout) {
        this.showEl();
        this.hide(timeout);
    };
    MuteTips.compName = 'MuteTips';
    MuteTips.sel = '.txp_popup_mute_tips';
    return MuteTips;
}(Component));

/** 下一集按钮 */
var NextBtn = /** @class */ (function (_super) {
    __extends(NextBtn, _super);
    function NextBtn(player, config, ctrlbar) {
        var _a;
        var _this = _super.call(this, player, NextBtn.sel, config) || this;
        _this.ctrlbar = ctrlbar;
        var showNextBtnUIOnly = config.showNextBtnUIOnly;
        if (!showNextBtnUIOnly) {
            _this.onVideoNodeChange = _this.onVideoNodeChange.bind(_this);
            _this.eventMap = (_a = {},
                _a[PLAY_EVENT.VIDEONODE_CHANGE] = _this.onVideoNodeChange,
                _a[PLAY_EVENT.LIST_CHANGE] = _this.onVideoNodeChange,
                _a);
            _this.setEvts();
        }
        else {
            _this.el.classList.remove(Component.disabledClassName);
        }
        _this.el.addEventListener(_this.CLICK_EVENT_NAME, function () {
            _this.player.setStateKv("ctrlbar:" + NextBtn.compName + ":" + _this.CLICK_EVENT_NAME, {
                type: LOG_TYPE.USER_ACTION,
            });
            _this.ctrlbar.emit(CTRL_EVENTS.CLICK_NEXTBTN);
            if (showNextBtnUIOnly)
                return;
            var idx = _this.player.currentVideoInfoIdx;
            if (idx === -1 || idx >= _this.player.totalVideoInfoCount - 1)
                return;
            _this.player.playNext();
        });
        return _this;
    }
    NextBtn.isEnabled = function (config) {
        var isMobile = config.isMobile, disableNextBtn = config.disableNextBtn, showNextBtnUIOnly = config.showNextBtnUIOnly;
        return !(isMobile || (disableNextBtn && !showNextBtnUIOnly));
    };
    NextBtn.prototype.onVideoNodeChange = function () {
        var idx = this.player.currentVideoInfoIdx;
        if (idx !== -1 && (idx + 1 < this.player.totalVideoInfoCount)) {
            this.el.classList.remove(Component.disabledClassName);
        }
        else {
            this.el.classList.add(Component.disabledClassName);
        }
    };
    NextBtn.sel = '.txp_left_controls .txp_btn_next';
    NextBtn.compName = 'NextBtn';
    return NextBtn;
}(Component));

var PictureInPicture = /** @class */ (function (_super) {
    __extends(PictureInPicture, _super);
    function PictureInPicture(player, config, ctrlbar) {
        var _this = _super.call(this, player, PictureInPicture.sel, config) || this;
        _this.ctrlbar = ctrlbar;
        _this.isPiP = false;
        _this.onEnterPiP = function () {
            _this.isPiP = true;
            _this.setDOMStatus(false);
        };
        _this.onLeavePiP = function () {
            _this.isPiP = false;
            _this.setDOMStatus(true);
        };
        // 不支持画中画时隐藏dom
        if (typeof HTMLVideoElement.prototype.requestPictureInPicture === 'undefined') {
            _this.el.classList.add(Component.hideClassName);
            return _this;
        }
        _this.setupDOMEvents();
        _this.setupPlayerEvents();
        _this.tooltip = _this.el.querySelector('.txp_tooltip');
        return _this;
    }
    PictureInPicture.isEnabled = function (config) {
        var isMobile = config.isMobile;
        return !isMobile;
    };
    /** 进入画中画模式 */
    PictureInPicture.prototype.enterPicInPic = function () {
        var currentVideoElement = this.player.currentVideoElement;
        if (!currentVideoElement)
            return;
        currentVideoElement.requestPictureInPicture();
        this.setDOMStatus(false);
    };
    /** 离开画中画模式 */
    PictureInPicture.prototype.leavePicInPic = function () {
        var _a, _b;
        try {
            (_b = (_a = document.exitPictureInPicture()) === null || _a === void 0 ? void 0 : _a.catch) === null || _b === void 0 ? void 0 : _b.call(_a, function () { });
        }
        catch (e) { }
        this.setDOMStatus(true);
    };
    PictureInPicture.prototype.destroy = function () {
        this.setupVideoListener(false);
        this.leavePicInPic();
        _super.prototype.destroy.call(this);
    };
    PictureInPicture.prototype.setupDOMEvents = function () {
        var _this = this;
        this.el.addEventListener('click', function () {
            if (_this.isPiP) {
                _this.leavePicInPic();
                _this.isPiP = false;
            }
            else {
                _this.enterPicInPic();
                _this.isPiP = true;
            }
            _this.ctrlbar.emit(CTRL_EVENTS.CLICK_PIPBTN, _this.isPiP);
        });
    };
    PictureInPicture.prototype.setupPlayerEvents = function () {
        var _this = this;
        this.player.on(H5_PLAY_EVENT.VIDEO_PLAYING, function (_a) {
            var data = _a.data;
            if (!data.isFirst)
                return;
            // 每当第一次开播以后，检查当前内核是否支持画中画
            _this.setPipSupportStatus(_this.isKernelSupport());
        });
        this.player.on(H5_PLAY_EVENT.VIDEO_SETLEVEL_END, function (_a) {
            var data = _a.data;
            if (data.code !== ErrorCode.SUC)
                return;
            // 切清晰度完成后，检查内核对画中画的支持情况
            _this.setPipSupportStatus(_this.isKernelSupport());
        });
    };
    /**
     * 设置内核对画中画的支持情况，显隐按钮并在不支持时退出画中画
     */
    PictureInPicture.prototype.setPipSupportStatus = function (status) {
        if (status) {
            this.el.classList.remove(Component.hideClassName);
            this.setVideoPip();
        }
        else {
            // 如果不支持 pip，则先把上次的 pip 状态退出
            this.leavePicInPic();
            // 再去隐藏按钮
            this.el.classList.add(Component.hideClassName);
        }
    };
    /**
     * 检查内核是否支持画中画
     * 画中画由浏览器 Video 原生实现，WASM 内核无法支持
     * @returns true -> 内核支持画中画
     */
    PictureInPicture.prototype.isKernelSupport = function () {
        var currentVideoElement = this.player.currentVideoElement;
        return currentVideoElement instanceof HTMLVideoElement
            && typeof currentVideoElement.requestPictureInPicture === 'function';
    };
    PictureInPicture.prototype.setVideoPip = function () {
        // 判断上次结束时是否画中画状态，是的话新视频也要进入画中画
        if (this.isPiP) {
            this.enterPicInPic();
        }
        // 复用video时可能重复监听事件，所以先解绑一次
        this.setupVideoListener(false);
        this.setupVideoListener(true);
    };
    PictureInPicture.prototype.setupVideoListener = function (isBind) {
        if (isBind === void 0) { isBind = true; }
        // 将插件的状态属性绑定至video元素的实际事件, 防止通过其他方式切换小窗时状态状态错误
        var currentVideoElement = this.player.currentVideoElement;
        if (!currentVideoElement)
            return;
        var func = isBind ? currentVideoElement.addEventListener : currentVideoElement.removeEventListener;
        func.call(currentVideoElement, 'enterpictureinpicture', this.onEnterPiP);
        func.call(currentVideoElement, 'leavepictureinpicture', this.onLeavePiP);
    };
    PictureInPicture.prototype.setDOMStatus = function (isEnter) {
        if (!this.el)
            return;
        if (this.tooltip)
            this.tooltip.innerText = isEnter ? '画中画' : '退出画中画';
        this.el.dataset.status = String(!isEnter);
    };
    PictureInPicture.sel = '.txp_right_controls .txp_btn_pip';
    PictureInPicture.compName = 'PictureInPicture';
    return PictureInPicture;
}(Component));

/** 调用tips插件 */
function showTips(player, text) {
    var tips = player.plugins.tips;
    if (typeof (tips === null || tips === void 0 ? void 0 : tips.show) !== 'function')
        return;
    tips.show(text);
}
function hideTips(player) {
    var tips = player.plugins.tips;
    if (typeof (tips === null || tips === void 0 ? void 0 : tips.hide) !== 'function')
        return;
    tips.hide();
}
/** 当前是否处于广告流程中。load后会停留在第一个节点 */
function getIsInAd(player) {
    var _a = player, flowManager = _a.flowManager, videoNode = _a.videoNode;
    var adPlugin = getAdPlugin(player.config.instanceId);
    // 存在 video 节点并且非当前节点
    return !!(adPlugin && videoNode && videoNode !== flowManager.currentFlowNode);
}

/** 播放按钮组件 */
var PlayBtn = /** @class */ (function (_super) {
    __extends(PlayBtn, _super);
    function PlayBtn(player, config, ctrlbar) {
        var _a;
        var _this = _super.call(this, player, PlayBtn.sel, config) || this;
        _this.ctrlbar = ctrlbar;
        /** 开始播放时，重置按钮状态 */
        _this.onPlaySessionStart = function () {
            _this.setPlayStatus(PlayBtnStatus.PLAY);
            _this.tooltip.innerText = '播放';
        };
        /** 结束播放时，展示重播状态 */
        _this.onPlaySessionEnd = function () {
            // 直播没有重播按钮
            _this.setPlayStatus(_this.isLive ? PlayBtnStatus.PLAY : PlayBtnStatus.REPLAY);
            _this.tooltip.innerText = '播放';
        };
        _this.eventMap = (_a = {},
            _a[PLAY_EVENT$1.STATE_CHANGE] = _this.onPlayerStateChange.bind(_this),
            _a[H5_PLAY_EVENT.PLAY_SESSION_START] = _this.onPlaySessionStart,
            _a[H5_PLAY_EVENT.PLAY_SESSION_END] = _this.onPlaySessionEnd,
            _a);
        // 创建时，先展示播放图标，后续再进行设置
        _this.setPlayStatus(PlayBtnStatus.PLAY);
        _this.setEvts();
        _this.tooltip = _this.el.querySelector('.txp_tooltip');
        _this.addEventListener();
        return _this;
    }
    PlayBtn.prototype.setPlayStatus = function (status) {
        this.el.dataset.status = status;
        this.el.className = "txp_btn txp_btn_play play_btn_" + status;
    };
    PlayBtn.prototype.addEventListener = function () {
        var _this = this;
        var player = this.player;
        // 播放按钮强制监听click事件，避免影响自动播放逻辑
        this.el.addEventListener('click', function () {
            player.setStateKv("ctrlbar:" + PlayBtn.compName + ":" + _this.CLICK_EVENT_NAME, {
                type: LOG_TYPE.USER_ACTION,
            });
            // 禁用状态不响应点击
            if (_this.el.classList.contains(Component.disabledClassName))
                return;
            _this.ctrlbar.emit(CTRL_EVENTS.CLICK_PLAYBTN, _this.el.dataset);
            var status = _this.el.dataset.status;
            switch (status) {
                case PlayBtnStatus.PAUSE:
                    player.pause(H5_PAUSE_TYPE.USER_CLICK);
                    break;
                case PlayBtnStatus.STOP:
                    player.stop();
                    break;
                case PlayBtnStatus.PLAY:
                    // 点播调用play
                    if (!_this.isLive)
                        return onBtnClickPlay(player, _this.ctrlbar);
                    // 直播调用replay
                    _this.replay();
                    break;
                case PlayBtnStatus.REPLAY:
                    _this.ctrlbar.emit(CTRL_EVENTS.CLICK_REPLAY);
                    _this.replay();
                    break;
            }
        });
    };
    /** 重播 */
    PlayBtn.prototype.replay = function () {
        var player = this.player;
        // 如果是播放vid，因为有异步请求的存在，所以需要先调用triggerAutoplay接口再调用播放
        if (player.vid) {
            player.triggerAutoplay().then(function () { return player.replay(); });
        }
        else {
            player.replay();
        }
    };
    PlayBtn.prototype.onVodPlaying = function () {
        var tooltip = this.tooltip;
        this.setPlayStatus(PlayBtnStatus.PAUSE);
        tooltip.innerText = '暂停';
    };
    PlayBtn.prototype.onLivePlaying = function () {
        var _this = this;
        var tooltip = this.tooltip;
        var setBtnStopStatus = function () {
            _this.setPlayStatus(PlayBtnStatus.STOP);
            tooltip.innerText = '停止';
        };
        if (getIsInAd(this.player)) {
            // 直播广告中预播正片时，等广告结束后再改变按钮状态
            this.player.once(H5_PLAY_EVENT.AD_END, setBtnStopStatus);
        }
        else {
            setBtnStopStatus();
        }
    };
    PlayBtn.prototype.onPlayerStateChange = function (_a) {
        var _this = this;
        var data = _a.data;
        var state = data.new;
        var tooltip = this.tooltip;
        switch (state) {
            case VIDEO_STATE$1.PLAYING:
                if (this.isLive) {
                    this.onLivePlaying();
                }
                else {
                    this.onVodPlaying();
                }
                break;
            case VIDEO_STATE$1.PAUSE:
            case VIDEO_STATE$1.CANPLAY: {
                var setBtnPlayStatus = function () {
                    _this.setPlayStatus(PlayBtnStatus.PLAY);
                    tooltip.innerText = '播放';
                };
                if (getIsInAd(this.player)) {
                    // 等广告结束后再改变按钮状态
                    this.player.once(H5_PLAY_EVENT.AD_END, setBtnPlayStatus);
                }
                else {
                    setBtnPlayStatus();
                }
                break;
            }
        }
    };
    PlayBtn.sel = '.txp_left_controls .txp_btn_play';
    PlayBtn.compName = 'PlayBtn';
    return PlayBtn;
}(Component));

var PlayratePopup = /** @class */ (function (_super) {
    __extends(PlayratePopup, _super);
    function PlayratePopup(player, config, ctrlbar) {
        var _this = _super.call(this, player, __assign(__assign({}, config), { selector: PlayratePopup.popupSelector, modSelector: PlayratePopup.modSelector }), ctrlbar) || this;
        _this.popupName = 'playrate';
        _this.onSelect = function (val) {
            var _a = _this, player = _a.player, ctrlbar = _a.ctrlbar;
            ctrlbar.emit(CTRL_EVENTS.SET_PLAYRATE, val);
            var value = Number(val.value);
            if (player.playbackRate === value)
                return;
            player.playbackRate = value;
            // 设置dom
            _this.selected = value;
            showTips(_this.player, "\u6B63\u5728<em>" + value + "</em>\u500D\u901F\u5EA6\u64AD\u653E");
        };
        _this.onPlayRestart = function () {
            _this.el.classList.toggle(Component.hideClassName, !_this.player.supportPlaybackRate);
        };
        _this.popupOptions = [
            { label: '0.5X', value: 0.5 },
            { label: '0.75X', value: 0.75 },
            { label: '1.0X', value: 1, btnLabel: '倍速' },
            { label: '1.25X', value: 1.25 },
            { label: '1.5X', value: 1.5 },
            { label: '1.75X', value: 1.75 },
            { label: '2.0X', value: 2 },
        ];
        _this.selected = 1;
        _this.bindEvts(true);
        return _this;
    }
    PlayratePopup.isEnabled = function (config) {
        var isMobile = config.isMobile, enablePlayrate = config.enablePlayrate;
        // PC 端启用，或者是在移动端下 + enablePlayrate = true 启用
        return !isMobile || (isMobile && enablePlayrate);
    };
    PlayratePopup.prototype.destroy = function () {
        this.bindEvts(false);
        _super.prototype.destroy.call(this);
    };
    PlayratePopup.prototype.bindEvts = function (isBind) {
        var binder = isBind ? this.player.on.bind(this.player) : this.player.off.bind(this.player);
        binder(PLAY_EVENT.RESTART, this.onPlayRestart);
    };
    PlayratePopup.compName = 'PlayratePopup';
    PlayratePopup.popupSelector = '.txp_right_controls .txp_btn_playrate';
    PlayratePopup.modSelector = '.mod_overlay.playrate';
    return PlayratePopup;
}(Popup));

/** 当前播放时间 & 总时长 */
var TimeArea = /** @class */ (function (_super) {
    __extends(TimeArea, _super);
    function TimeArea(player, config, ctrlbar) {
        var _a;
        var _this = _super.call(this, player, TimeArea.sel, config) || this;
        _this.ctrlbar = ctrlbar;
        _this.clickCount = 0;
        _this.clickTimer = 0;
        _this.onMouseup = function () {
            _this.isMouseDown = false;
        };
        _this.onMousemove = function (_a) {
            var data = _a.data;
            _this.timeCur.innerText = commonTool.formatPlayTime(data * _this.ctrlbar.duration);
        };
        _this.onMousedown = function (_a) {
            var data = _a.data;
            _this.isMouseDown = true;
            _this.timeCur.innerText = commonTool.formatPlayTime(data * _this.ctrlbar.duration);
        };
        var MOUSE_DOWN = CTRL_EVENTS.MOUSE_DOWN, MOUSE_MOVE = CTRL_EVENTS.MOUSE_MOVE, MOUSE_UP = CTRL_EVENTS.MOUSE_UP;
        _this.eventMap = (_a = {},
            _a[PLAY_EVENT$1.DURATION_CHANGE] = _this.onDurationChange.bind(_this),
            _a[PLAY_EVENT$1.TIME_UPDATE] = _this.onTimeUpdate.bind(_this),
            _a[PLAY_EVENT$1.STATE_CHANGE] = _this.onPlayerStateChange.bind(_this),
            _a);
        _this.setEvts();
        ctrlbar.on(MOUSE_DOWN, _this.onMousedown);
        ctrlbar.on(MOUSE_MOVE, _this.onMousemove);
        ctrlbar.on(MOUSE_UP, _this.onMouseup);
        _this.timeCur = _this.el.querySelector('.txp_time_current');
        _this.timeDur = _this.el.querySelector('.txp_time_duration');
        if (!config.disableTestEvent)
            _this.bindClickOnMobile();
        return _this;
    }
    /** 移动端点击5次时间区域，展示信息面板 */
    TimeArea.prototype.bindClickOnMobile = function () {
        var _this = this;
        if (!this.isMobile)
            return;
        var clickMaxTime = 5;
        var clickDelay = 300;
        this.el.addEventListener('click', function () {
            _this.clickCount += 1;
            if (_this.clickCount >= clickMaxTime) {
                _this.clickCount = 0;
                _this.ctrlbar.emit(CTRL_EVENTS.TEST_EVENT);
            }
            if (_this.clickTimer)
                clearTimeout(_this.clickTimer);
            _this.clickTimer = window.setTimeout(function () {
                _this.clickCount = 0;
            }, clickDelay);
        });
    };
    TimeArea.prototype.onPlayerStateChange = function (_a) {
        var data = _a.data;
        var state = data.new;
        if (state === VIDEO_STATE$1.IDLE) {
            this.timeCur.innerText = '00:00';
        }
    };
    TimeArea.prototype.onDurationChange = function () {
        var duration = this.ctrlbar.duration;
        this.timeDur.innerText = commonTool.formatPlayTime(duration);
        // 播放时长超过1小时，则增大dom宽度 反之减小
        this.el.classList.toggle('reach_hour', duration >= 3600);
    };
    TimeArea.prototype.onTimeUpdate = function () {
        // 拖拽时不更新时间，使用拖拽进度更新
        if (this.isMouseDown)
            return;
        var time = commonTool.formatPlayTime(this.playtime);
        if (this.timeCur.innerText !== time) {
            this.timeCur.innerText = time;
        }
    };
    TimeArea.sel = '.txp_left_controls .txp_time_display';
    TimeArea.compName = 'TimeArea';
    return TimeArea;
}(Component));

var VolumeStatus;
(function (VolumeStatus) {
    VolumeStatus["Mute"] = "mute";
    VolumeStatus["Normal"] = "normal";
})(VolumeStatus || (VolumeStatus = {}));
var LOCAL_KEY = {
    VOLUME: 'thumbplayer-h5-volume',
    MUTED: 'thumbplayer-h5-volume:muted',
};
var MutedStatus;
(function (MutedStatus) {
    MutedStatus["muted"] = "true";
    MutedStatus["unmuted"] = "false";
})(MutedStatus || (MutedStatus = {}));
var initDragVolume = -1;
/** 音量按钮 & 浮层 */
var Volume = /** @class */ (function (_super) {
    __extends(Volume, _super);
    function Volume(player, config, ctrlbar) {
        var _a;
        var _this = _super.call(this, player, Volume.sel, config) || this;
        _this.ctrlbar = ctrlbar;
        /** 静音前的音量 */
        _this.lastVolume = 0.5;
        /** 拖拽时的音量 */
        _this.dragVolume = initDragVolume;
        /** 如果是静音起播，由于没有volume_change事件,这里需要手动同步一下muted状态 */
        _this.onVideoPlaying = function (param) {
            if (!param.data.isFirst)
                return;
            // 直播广告中正片在后台播放，所以不响应正片音量变化
            if (_this.isInLiveAd())
                return;
            if (_this.player.muted) {
                _this.setUi(0);
            }
        };
        _this.onVolumeChange = function () {
            if (_this.isInLiveAd())
                return;
            var vol = _this.player.volume;
            var muted = _this.player.muted;
            if (muted)
                vol = 0;
            _this.setUi(vol);
        };
        _this.onAdVolumeChange = function (_a) {
            var data = _a.data;
            if (getIsInAd(_this.player))
                _this.setUi(data.volume);
        };
        if (_this.isMobile)
            return _this;
        _this.eventMap = (_a = {},
            _a[H5_PLAY_EVENT.VIDEO_VOLUME_CHANGE] = _this.onVolumeChange,
            _a[H5_PLAY_EVENT.AD_VOLUME_CHANGE] = _this.onAdVolumeChange,
            _a[H5_PLAY_EVENT.VIDEO_PLAYING] = _this.onVideoPlaying,
            _a);
        _this.setEvts();
        _this.popup = _this.el.querySelector('.txp_popup_volume');
        _this.volumeSvg = _this.el.querySelector('.txp_icon_volume');
        _this.volumeValue = _this.el.querySelector('.txp_volume_range_current');
        _this.volumeRange = _this.el.querySelector('.txp_volume_range');
        _this.volumeText = _this.el.querySelector('.txp_volume_text');
        _this.initDOMEvents();
        if (!_this.config.disableCacheVolume) {
            _this.setVolumeByCache();
        }
        return _this;
    }
    Volume.isEnabled = function (config) {
        var isMobile = config.isMobile;
        return !isMobile;
    };
    Object.defineProperty(Volume.prototype, "muteTips", {
        get: function () {
            return this.ctrlbar.instances.MuteTips;
        },
        enumerable: false,
        configurable: true
    });
    /** 从本地读取音量值 */
    Volume.prototype.setVolumeByCache = function () {
        var historyVol = Number(lsTool.getData(LOCAL_KEY.VOLUME));
        var historyMuted = lsTool.getData(LOCAL_KEY.MUTED);
        if (Number.isNaN(historyVol) || historyVol > 1) {
            historyVol = 1;
            lsTool.setData(LOCAL_KEY.VOLUME, '1');
        }
        if (historyVol)
            this.lastVolume = historyVol;
        if (historyMuted === MutedStatus.muted)
            historyVol = 0;
        this.setVolume(historyVol);
        // 发现第一次没有触发播放器的事件 所以手动设置下Ui
        this.setUi();
    };
    /** 设置按钮状态,range条高度 和 顶部文案 */
    Volume.prototype.setUi = function (volume) {
        if (volume === void 0) { volume = this.getCurrentNodeVolume(); }
        this.el.dataset.status = volume === 0 ? VolumeStatus.Mute : VolumeStatus.Normal;
        this.volumeValue.style.height = volume * 100 + "%";
        this.volumeText.innerText = String(Math.round(volume * 100));
    };
    /** 当前播放节点的音量 */
    Volume.prototype.getCurrentNodeVolume = function () {
        var _a, _b;
        var player = this.player;
        if (getIsInAd(player)) {
            // load后会停留在广告节点，如果没有广告的话正片已经预加载了。此时 getAdVolume 返回 undefined，所以返回 player.volume 兜底
            return (_b = (_a = getAdPlugin(player.config.instanceId)) === null || _a === void 0 ? void 0 : _a.getAdVolume()) !== null && _b !== void 0 ? _b : player.volume;
        }
        return player.volume;
    };
    /** 当前是否处于直播广告中 */
    Volume.prototype.isInLiveAd = function () {
        return this.isLive && getIsInAd(this.player);
    };
    /** 拖拽和点击音量浮层后设置音量和UI */
    Volume.prototype.setPercent = function (evt, isClick) {
        var clientY = evt.clientY;
        // 实时获取range位置和高度
        this.clientY = this.volumeRange.getBoundingClientRect().top;
        this.clientHeight = this.volumeRange.clientHeight;
        var percent = (clientY - this.clientY) / this.clientHeight;
        percent = Math.floor((1 - percent) * 100);
        // 0-100
        percent = Math.max(Math.min(percent, 100), 0);
        var volSetToPlayer = percent / 100;
        if (this.player.volume !== volSetToPlayer) {
            this.ctrlbar.emit(CTRL_EVENTS.SET_VOLUME, volSetToPlayer);
            this.dragVolume = percent;
        }
        // 实时设置音量
        this.setVolume(volSetToPlayer);
        this.setUi();
        // 点击时记录到本地
        if (isClick) {
            lsTool.setData(LOCAL_KEY.VOLUME, volSetToPlayer);
            // 解除静音
            lsTool.setData(LOCAL_KEY.MUTED, false);
        }
    };
    Volume.prototype.setVolume = function (val) {
        var _a;
        if (this.isInLiveAd()) {
            // 直播广告时由于正片在后台静音播放，只调节广告音量
            (_a = getAdPlugin(this.player.config.instanceId)) === null || _a === void 0 ? void 0 : _a.setAdVolume(val);
        }
        else {
            // 播放器设置 volume 时会自动设置广告音量
            this.player.volume = val;
        }
    };
    Volume.prototype.initDOMEvents = function () {
        // 按钮移入移出事件
        this.setupBtnMouseEvents();
        // 音量按钮点击
        this.setupVolumeClick();
        // 音量浮层拖拽
        this.setupVolumeRangeMouseEvents();
    };
    Volume.prototype.showVolumeTips = function () {
        var _this = this;
        // 判断是否有拖拽行为
        if (this.dragVolume === initDragVolume)
            return;
        this.clearTipsTimer();
        // 拖拽音量时，在音量浮层消失后0.5秒出现tips
        var tipsShowDelay = 500;
        this.volumeTipsTimer = window.setTimeout(function () {
            showTips(_this.player, "\u5F53\u524D\u97F3\u91CF: <em>" + _this.dragVolume.toFixed(0) + "</em>");
        }, tipsShowDelay);
    };
    Volume.prototype.clearTipsTimer = function () {
        if (this.volumeTipsTimer) {
            window.clearTimeout(this.volumeTipsTimer);
            this.volumeTipsTimer = 0;
        }
    };
    Volume.prototype.setupBtnMouseEvents = function () {
        var _this = this;
        // 移入按钮展示浮层，并清空拖拽tip定时器
        this.el.addEventListener('mouseenter', function (evt) {
            var _a;
            (_a = _this.muteTips) === null || _a === void 0 ? void 0 : _a.hide();
            _this.showEl(_this.popup);
            _this.dragVolume = initDragVolume;
            _this.clearTipsTimer();
        });
        // 移出按钮隐藏浮层，并判断是否展示拖拽后的tips
        this.el.addEventListener('mouseleave', function () {
            if (_this.isMouseDown)
                return;
            _this.hideEl(_this.popup);
            _this.showVolumeTips();
        });
    };
    /** 点击/拖拽音量浮层调节音量 */
    Volume.prototype.setupVolumeRangeMouseEvents = function () {
        var _this = this;
        var _a = this, volumeRange = _a.volumeRange, player = _a.player;
        // 浮层拖拽
        volumeRange.addEventListener('mousedown', function () {
            _this.isMouseDown = true;
        });
        volumeRange.addEventListener('mousemove', function (evt) {
            if (!_this.isMouseDown)
                return;
            _this.setPercent(evt);
        });
        player.container.addEventListener('mousemove', function (evt) {
            if (!_this.isMouseDown)
                return;
            _this.setPercent(evt);
        });
        // 拖拽完成后释放鼠标
        volumeRange.addEventListener('mouseup', function (evt) {
            _this.isMouseDown = false;
            _this.setPercent(evt, true);
        });
        player.container.addEventListener('mouseup', function (evt) {
            if (!_this.isMouseDown)
                return;
            _this.isMouseDown = false;
            _this.setPercent(evt, true);
            _this.hideEl(_this.popup);
            _this.showVolumeTips();
        });
    };
    /** 点击音量按钮静音/取消静音 */
    Volume.prototype.setupVolumeClick = function () {
        var _this = this;
        this.volumeSvg.addEventListener(this.CLICK_EVENT_NAME, function () {
            var status = _this.el.dataset.status;
            if (status === VolumeStatus.Mute) {
                _this.el.dataset.status = VolumeStatus.Normal;
                _this.setVolume(_this.lastVolume);
                lsTool.setData(LOCAL_KEY.MUTED, MutedStatus.unmuted);
                // 记录恢复后的音量，下次复用
                lsTool.setData(LOCAL_KEY.VOLUME, _this.lastVolume);
            }
            else {
                _this.lastVolume = _this.getCurrentNodeVolume();
                _this.el.dataset.status = VolumeStatus.Mute;
                _this.setVolume(0);
                lsTool.setData(LOCAL_KEY.MUTED, MutedStatus.muted);
            }
            // 开播前没有video不会触发volumeChange事件，所以需要手动更新UI
            // 播放结束也不会触发
            if (!_this.player.played || [VIDEO_STATE.END, VIDEO_STATE.IDLE].indexOf(_this.player.state) !== -1) {
                _this.setUi();
            }
        });
    };
    Volume.compName = 'Volume';
    Volume.sel = '.txp_btn_volume';
    return Volume;
}(Component));

/* eslint-disable max-len */
var THUMBPLAYER_PREFIX = 'thumbplayer';
var svgSpriteClassName = 'txp_svg_sprite';
var ctrlBarClassName = 'txp_controls';
var svgSpriteSelector = "." + THUMBPLAYER_PREFIX + "." + svgSpriteClassName;
var ctrlBarSelector = "." + THUMBPLAYER_PREFIX + "." + ctrlBarClassName;
var pcViewBox = '0 0 28 28';
/** svg雪碧图 */
var svgSprite = /* html */ "\n<svg class=\"" + THUMBPLAYER_PREFIX + " " + svgSpriteClassName + "\" display=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <symbol id=\"txp_svg_play\" viewBox=\"" + pcViewBox + "\">\n        <path d=\"M6.308 6.057S6 6.857 6 13.964c0 7.108.308 7.978.308 7.978 0 .788.827 1.299 1.526.943 0 0 1.603-.25 8.057-3.493 6.455-3.244 7.534-4.45 7.534-4.45.767-.39.767-1.493 0-1.884 0 0-1.768-1.617-7.531-4.553-5.7-2.904-8.06-3.39-8.06-3.39a1.051 1.051 0 0 0-1.526.942\" fill-rule=\"evenodd\"/>\n    </symbol>\n    <symbol id=\"txp_svg_replay\" viewBox=\"" + pcViewBox + "\">\n        <path d=\"M14 4a9.994 9.994 0 0 1 8.5 4.731V6a1 1 0 0 1 2 0v5a1 1 0 0 1-.883.993L23.5 12h-5a1 1 0 0 1 0-2h2.43a8 8 0 1 0 .816 6.01 1 1 0 0 1 1.936.5A10.003 10.003 0 0 1 14 24C8.477 24 4 19.523 4 14S8.477 4 14 4Z\" fill-rule=\"evenodd\"/>\n    </symbol>\n    <symbol id=\"txp_svg_pause\" viewBox=\"" + pcViewBox + "\">\n        <path d=\"M9 5a1.5 1.5 0 0 1 1.5 1.5v15A1.5 1.5 0 0 1 9 23h-.5A1.5 1.5 0 0 1 7 21.5v-15A1.5 1.5 0 0 1 8.5 5H9Zm10.5 0A1.5 1.5 0 0 1 21 6.5v15a1.5 1.5 0 0 1-1.5 1.5H19a1.5 1.5 0 0 1-1.5-1.5v-15A1.5 1.5 0 0 1 19 5h.5Z\" fill-rule=\"evenodd\"/>\n    </symbol>\n    <symbol id=\"txp_svg_stop\" viewBox=\"" + pcViewBox + "\">\n      <rect x=\"5\" y=\"5\" width=\"18\" height=\"18\" rx=\"4\" fill-rule=\"evenodd\"/>\n    </symbol>\n\n    <symbol id=\"txp_svg_fake\" viewBox=\"" + pcViewBox + "\">\n        <rect fill=\"none\" stroke-width=\"1.75\" transform=\"translate(0 3.5)\" x=\"5.25\" y=\"3.5\" width=\"17.5\" height=\"14\" rx=\"2.042\"/>\n    </symbol>\n\n    <symbol id=\"txp_svg_loop_off\" viewBox=\"" + pcViewBox + "\">\n        <g fill-rule=\"evenodd\"><path d=\"M16.859 14.22c2.738 0 4.958 2.164 4.958 4.834 0 2.67-2.22 4.834-4.958 4.834-2.739 0-4.959-2.164-4.959-4.834 0-2.67 2.22-4.835 4.959-4.835Zm0 .966c-2.19 0-3.967 1.732-3.967 3.868s1.776 3.867 3.967 3.867c2.19 0 3.967-1.731 3.967-3.867s-1.776-3.868-3.967-3.868Zm-1.206 2.02.069.056 2.975 2.9a.475.475 0 0 1 0 .684.506.506 0 0 1-.633.056l-.068-.056-2.975-2.9a.475.475 0 0 1 0-.684.506.506 0 0 1 .632-.056ZM12.591 4.9a.69.69 0 0 1 .456.171l3.812 3.346H11.9v-.001H8.925c-1.584 0-2.88 1.208-2.97 2.731l-.005.17v3.868c0 1.545 1.239 2.808 2.8 2.896l.175.005.992-.001v1.934h-.992c-2.664 0-4.838-2.048-4.953-4.619l-.005-.215v-3.868c0-2.597 2.101-4.717 4.737-4.83l.221-.004H11.9v-.892c0-.382.31-.691.691-.691Zm7.243 1.68c2.19.433 3.856 2.274 3.961 4.512l.006.225v3.868c0 .432-.058.85-.167 1.248l-1.817-2.215v-2.9c0-1.263-.827-2.338-1.982-2.736V6.581Z\" fill-rule=\"nonzero\"/></g>\n    </symbol>\n    <symbol id=\"txp_svg_loop\" viewBox=\"" + pcViewBox + "\">\n        <g fill-rule=\"evenodd\"><path d=\"M9 8.877a3 3 0 0 0-2.995 2.824L6 11.877v4a3 3 0 0 0 2.824 2.995l.176.005a1 1 0 1 1 0 2 5 5 0 0 1-4.995-4.783L4 15.877v-4a5 5 0 0 1 4.783-4.995L9 6.877h3V5.5a.5.5 0 0 1 .834-.372L17 8.878H9Zm11 10a3 3 0 0 0 2.995-2.823l.005-.177v-4a3 3 0 0 0-2.824-2.995L20 8.877a1 1 0 0 1 0-2 5 5 0 0 1 4.995 4.783l.005.217v4a5 5 0 0 1-4.783 4.996l-.217.004h-3v1.378a.5.5 0 0 1-.834.371L12 18.877h8Z\" fill-rule=\"nonzero\"/></g>\n    </symbol>\n\n    <symbol id=\"txp_svg_next\" viewBox=\"" + pcViewBox + "\">\n        <path d=\"M21.5 7A1.5 1.5 0 0 1 23 8.5v11a1.5 1.5 0 0 1-3 0v-11A1.5 1.5 0 0 1 21.5 7Zm-16.261.822a.817.817 0 0 1 1.186-.732s1.835.378 6.266 2.636c4.481 2.282 5.855 3.54 5.855 3.54a.825.825 0 0 1 0 1.467s-.839.936-5.857 3.46c-5.017 2.522-6.264 2.715-6.264 2.715a.817.817 0 0 1-1.186-.732S5 19.498 5 13.97v-.326c.01-5.226.239-5.823.239-5.823Z\" fill-rule=\"evenodd\"/>\n    </symbol>\n\n    <symbol id=\"txp_svg_fullscreen\" viewBox=\"" + pcViewBox + "\">   \n        <path d=\"M7.438 17.063v2.625c0 .483.391.875.875.875h2.624m0-13.125H8.312a.875.875 0 0 0-.875.875v2.624h0m13.126 6.126v2.625a.875.875 0 0 1-.875.875h-2.625 0m0-13.125h2.625c.483 0 .875.391.875.874v2.625h0\" stroke-width=\"2.188\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    </symbol>\n    <symbol id=\"txp_svg_fullscreen_true\" viewBox=\"" + pcViewBox + "\">\n        <g stroke-width=\"2.188\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.938 20.563v-2.625a.875.875 0 0 0-.875-.875H7.438h0M7.438 10.938h2.625a.875.875 0 0 0 .874-.876V7.438h0M17.063 20.562v-2.625c0-.483.391-.875.875-.875h2.625M20.563 10.938h-2.625a.875.875 0 0 1-.875-.876V7.438h0\"/></g>\n    </symbol>\n\n    <symbol id=\"txp_svg_volume_mute\" viewBox=\"" + pcViewBox + "\">\n        <g stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.75 10.041H5.749c-.828 0-1.499.671-1.499 1.499v4.92c0 .828.671 1.499 1.499 1.499H8.75l4.143 4.143a.502.502 0 0 0 .857-.355V6.253a.502.502 0 0 0-.857-.355L8.75 10.041ZM17.5 11l6 6M23.5 11l-6 6\"/></g>\n    </symbol>\n    <symbol id=\"txp_svg_volume\" viewBox=\"" + pcViewBox + "\">\n        <g stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.75 10.041H5.749c-.828 0-1.499.671-1.499 1.499v4.92c0 .828.671 1.499 1.499 1.499H8.75l4.143 4.143a.502.502 0 0 0 .857-.355V6.253a.502.502 0 0 0-.857-.355L8.75 10.041ZM20.786 7a9.717 9.717 0 0 1 2.964 7 9.717 9.717 0 0 1-2.964 7M17.75 9.477c1.235 1.154 2 2.753 2 4.522 0 1.746-.747 3.328-1.955 4.478\"/></g>\n    </symbol>\n\n    <symbol id=\"txp_svg_pip\" viewBox=\"" + pcViewBox + "\">\n        <path d=\"M23.625 15.75c.966 0 1.75.784 1.75 1.75v4.375a1.75 1.75 0 0 1-1.75 1.75H17.5a1.75 1.75 0 0 1-1.75-1.75V17.5c0-.966.784-1.75 1.75-1.75h6.125ZM21 5.25a2.625 2.625 0 0 1 2.62 2.47l.005.155v5.25a.875.875 0 0 1-1.744.102l-.006-.102v-5.25a.875.875 0 0 0-.773-.87L21 7H7a.875.875 0 0 0-.87.773l-.005.102V19.25c0 .449.338.819.773.87l.102.005h6.125a.875.875 0 0 1 .102 1.744l-.102.006H7a2.625 2.625 0 0 1-2.62-2.47l-.005-.155V7.875a2.625 2.625 0 0 1 2.47-2.62L7 5.25h14Z\" stroke-width=\".5\" fill-rule=\"evenodd\"/>\n    </symbol>\n\n    <symbol id=\"txp_air_play\" viewBox=\"0 0 1024 1024\">\n        <path d=\"M547.413333 573.866667a42.666667 42.666667 0 0 0-70.826666 0l-170.666667 256a42.666667 42.666667 0 0 0 0 42.666666A42.666667 42.666667 0 0 0 341.333333 896h341.333334a42.666667 42.666667 0 0 0 37.546666-22.613333 42.666667 42.666667 0 0 0-2.133333-42.666667zM421.12 810.666667L512 674.133333l90.88 136.533334zM810.666667 128H213.333333a128 128 0 0 0-128 128v384a128 128 0 0 0 128 128h36.266667a42.666667 42.666667 0 1 0 0-85.333333H213.333333a42.666667 42.666667 0 0 1-42.666666-42.666667V256a42.666667 42.666667 0 0 1 42.666666-42.666667h597.333334a42.666667 42.666667 0 0 1 42.666666 42.666667v384a42.666667 42.666667 0 0 1-42.666666 42.666667h-36.266667a42.666667 42.666667 0 0 0 0 85.333333H810.666667a128 128 0 0 0 128-128V256a128 128 0 0 0-128-128z\"/>\n    </symbol>\n    <symbol id=\"txp_close_btn\" viewBox=\"0 0 24 24\">\n        <path d=\"M6.5 6.5L17.5 17.5\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n        <path d=\"M6.5 17.5L17.5 6.5\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    </symbol>\n</svg>\n";
/** h5 svg雪碧图 */
var h5SvgSprite = /* html */ "\n<svg class=\"" + THUMBPLAYER_PREFIX + " " + svgSpriteClassName + "\" display=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n\t<symbol id=\"txp_svg_play\" viewBox=\"0 0 56 56\">\n\t\t<path d=\"M14.569 13.867s-.563 1.42-.563 14.059.563 14.188.563 14.188a1.925 1.925 0 0 0 2.8 1.677s2.938-.442 14.763-6.211 13.8-7.914 13.8-7.914a1.859 1.859 0 0 0 0-3.352s-3.24-2.875-13.8-8.095c-10.444-5.165-14.767-6.029-14.767-6.029a1.924 1.924 0 0 0-2.796 1.677z\" style=\"fill:#fff\" />\n\t</symbol>\n    <symbol id=\"txp_svg_replay\" viewBox=\"0 0 32 32\">\n      <path d=\"M18 30a13.956 13.956 0 0 1-9.9-4.1l2.121-2.121A11 11 0 1 0 7 16h4.006L5.5 22 0 16h4a14 14 0 1 1 14 14z\">\n      </path>\n    </symbol>\n    <symbol id=\"txp_svg_pause\" viewBox=\"0 0 56 56\">\n      <path d=\"M39 49a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4 4 4 0 0 1 4 4v34a4 4 0 0 1-4 4zm-22 0a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4 4 4 0 0 1 4 4v34a4 4 0 0 1-4 4z\">\n      </path>\n    </symbol>\n    <symbol id=\"txp_svg_stop\" viewBox=\"0 0 32 32\">\n      <path d=\"M24 26H12c-1.1 0-2-0.9-2-2V12c0-1.1 0.9-2 2-2h12c1.1 0 2 0.9 2 2v12C26 25.1 25.1 26 24 26z\"></path>\n    </symbol>\n\n\t<symbol id=\"txp_svg_fullscreen\" viewBox=\"0 0 48 48\">\n\t\t<path d=\"M9.5 37h10a1.5 1.5 0 0 1 0 3h-10a1.5 1.5 0 0 1 0-3zm0-10a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1-3 0v-10A1.5 1.5 0 0 1 9.5 27zM8.43 37.353L19.353 26.43a1.545 1.545 0 1 1 2.185 2.184L10.614 39.538a1.545 1.545 0 1 1-2.184-2.185zM28.5 8h10a1.5 1.5 0 0 1 0 3h-10a1.5 1.5 0 0 1 0-3zm10 0A1.5 1.5 0 0 1 40 9.5v10a1.5 1.5 0 0 1-3 0v-10A1.5 1.5 0 0 1 38.5 8zM26.43 19.354L37.353 8.43a1.545 1.545 0 0 1 2.185 2.184L28.614 21.538a1.545 1.545 0 0 1-2.184-2.184z\"/>\n\t</symbol>\n\t<symbol id=\"txp_svg_fullscreen_true\" viewBox=\"0 0 48 48\">\n\t\t<path d=\"M39.538 10.615L31.153 19H37.5a1.5 1.5 0 0 1 0 3h-10a1.5 1.5 0 0 1-1.386-.937 1.52 1.52 0 0 1-.114-.735V10.5a1.5 1.5 0 0 1 3 0v6.283l8.353-8.353a1.545 1.545 0 1 1 2.185 2.185zM20.5 39a1.5 1.5 0 0 1-1.5-1.5v-6.347l-8.386 8.385a1.545 1.545 0 1 1-2.184-2.184L16.783 29H10.5a1.5 1.5 0 0 1 0-3h9.828a1.518 1.518 0 0 1 .733.113A1.5 1.5 0 0 1 22 27.5v10a1.5 1.5 0 0 1-1.5 1.5z\"/>\n\t</symbol>\n\t<symbol id=\"txp_svg_pause\" viewBox=\"0 0 56 56\">\n\t\t<path d=\"M39 49a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4 4 4 0 0 1 4 4v34a4 4 0 0 1-4 4zm-22 0a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4 4 4 0 0 1 4 4v34a4 4 0 0 1-4 4z\"/>\n\t</symbol>\n\t<symbol id=\"txp_svg_replay\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M18 30a13.956 13.956 0 0 1-9.9-4.1l2.121-2.121A11 11 0 1 0 7 16h4.006L5.5 22 0 16h4a14 14 0 1 1 14 14z\"/>\n\t</symbol>\n\t<symbol id=\"txp_svg_next\" viewBox=\"0 0 60 60\">\n\t\t<path d=\"M47.13825,15.0141429 C45.3628929,15.0141429 43.9239643,16.4530714 43.9239643,18.2284286 L43.9239643,41.7998571 C43.9239643,43.5752143 45.3628929,45.0141429 47.13825,45.0141429 C48.9136071,45.0141429 50.3525357,43.5752143 50.3525357,41.7998571 L50.3525357,18.2284286 C50.3525357,16.4530714 48.9136071,15.0141429 47.13825,15.0141429 M39.7389643,28.4327143 C39.7389643,28.4327143 36.7936071,25.737 27.1946786,20.8437857 C17.6986071,16.002 13.7686071,15.192 13.7686071,15.192 C12.6050357,14.5995 11.2261071,15.4502143 11.2261071,16.7637857 C11.2261071,16.7637857 10.7139643,18.0955714 10.7139643,29.9455714 C10.7139643,41.7945 11.2261071,43.2462857 11.2261071,43.2462857 C11.2261071,44.5598571 12.6050357,45.4116429 13.7686071,44.8180714 C13.7686071,44.8180714 16.4396786,44.4034286 27.1893214,38.9948571 C37.9411071,33.5852143 39.7389643,31.5762857 39.7389643,31.5762857 C41.0171786,30.9248571 41.0171786,29.0852143 39.7389643,28.4327143\" id=\"Fill-1\"></path>\n\t</symbol>\n    <symbol id=\"txp_air_play\" viewBox=\"0 0 1024 1024\">\n        <path d=\"M547.413333 573.866667a42.666667 42.666667 0 0 0-70.826666 0l-170.666667 256a42.666667 42.666667 0 0 0 0 42.666666A42.666667 42.666667 0 0 0 341.333333 896h341.333334a42.666667 42.666667 0 0 0 37.546666-22.613333 42.666667 42.666667 0 0 0-2.133333-42.666667zM421.12 810.666667L512 674.133333l90.88 136.533334zM810.666667 128H213.333333a128 128 0 0 0-128 128v384a128 128 0 0 0 128 128h36.266667a42.666667 42.666667 0 1 0 0-85.333333H213.333333a42.666667 42.666667 0 0 1-42.666666-42.666667V256a42.666667 42.666667 0 0 1 42.666666-42.666667h597.333334a42.666667 42.666667 0 0 1 42.666666 42.666667v384a42.666667 42.666667 0 0 1-42.666666 42.666667h-36.266667a42.666667 42.666667 0 0 0 0 85.333333H810.666667a128 128 0 0 0 128-128V256a128 128 0 0 0-128-128z\"/>\n    </symbol>\n</svg>\n";
/** dom模板字符串，根节点class名区分了移动端和pc */
var getDomText = function (isMobile) { /* html */ return "\n<div class=\"" + gradientClassName.slice(1) + "\"></div>\n<div class=\"" + getRootClassName(isMobile).slice(1) + "\">\n    <div class=\"" + THUMBPLAYER_PREFIX + " " + ctrlBarClassName + "\">\n        <div class=\"txp_left_controls\">\n            <div class=\"txp_none txp_btn txp_btn_play\" data-status=\"play\" aria-label=\"\u64AD\u653E/\u6682\u505C\">\n                <svg class=\"txp_icon txp_icon_play\" viewBox=\"" + pcViewBox + "\">\n                    <use class=\"txp_svg_symbol txp_svg_play\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#txp_svg_play\"></use>\n                    <use class=\"txp_svg_symbol txp_svg_pause\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#txp_svg_pause\"></use>\n                    <use class=\"txp_svg_symbol txp_svg_stop\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#txp_svg_stop\"></use>\n                    <use class=\"txp_svg_symbol txp_svg_replay\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#txp_svg_replay\"></use>\n                </svg>\n                <div class=\"txp_tooltip\">\u64AD\u653E</div>\n            </div>\n            <div class=\"txp_none txp_btn txp_btn_next txp_disabled\" aria-label=\"\u4E0B\u4E00\u4E2A\">\n                <svg class=\"txp_icon txp_icon_next\" viewBox=\"" + pcViewBox + "\">\n                    <use class=\"txp_svg_symbol txp_svg_next\" xlink:href=\"#txp_svg_next\"></use>\n                </svg>\n                <div class=\"txp_tooltip\">\u4E0B\u4E00\u4E2A</div>\n            </div>\n            <div class=\"txp_btn txp_btn_loop txp_none\" data-status=\"false\" aria-label=\"\u5FAA\u73AF\u64AD\u653E\">   \n                <svg data-role=\"txp-ui-control-loop-play-btn\" class=\"txp_icon txp_icon_loop\" viewBox=\"" + pcViewBox + "\">\n                    <use class=\"txp_svg_symbol txp_svg_loop\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#txp_svg_loop\"></use>\n                    <use class=\"txp_svg_symbol txp_svg_loop_off\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#txp_svg_loop_off\"></use>\n                </svg>\n                <div class=\"txp_tooltip\">\u6253\u5F00\u5FAA\u73AF\u64AD\u653E</div> \n            </div>\n\n\n            <div class=\"txp_none txp_time_display\">\n                <div class=\"txp_time_current\">00:00</div>\n                <div class=\"txp_time_separator\">/</div>\n                <div class=\"txp_time_duration\">00:00</div>\n            </div>\n        </div>\n\n        <div class=\"txp_none txp_progress_bar_container\">\n            <div class=\"txp_progress_list\">\n                <div class=\"txp_progress_load\" style=\"width: 0;\"></div>\n                <div class=\"txp_progress_play\" style=\"width: 0;\">\n                </div>\n                <div class=\"txp_btn_scrubber\" style=\"left: 0\">\n                    <div class=\"txp_scrubber_indicator\"></div>\n                </div>\n            </div>\n            <div class=\"txp_tooltip txp_none\"></div>\n            <!-- \u8FDB\u5EA6\u6761\u6807\u8BB0\u6253\u70B9 -->\n            <div class=\"txp_hotpoint\"></div> \n        </div>\n\n        <div class=\"txp_center_controls\"></div>\n\n        <div class=\"txp_right_controls\">\n            <div class=\"txp_btn txp_btn_definition txp_none\" aria-label=\"\u6E05\u6670\u5EA6\">\n                <div class=\"txp_label\">\u6E05\u6670\u5EA6</div>\n                <div class=\"txp_popup txp_popup_definition txp_none\">\n                    <div class=\"txp_popup_content\"></div>\n                </div>\n            </div>\n\n            <div class=\"txp_btn txp_btn_playrate txp_none\" aria-label=\"\u500D\u901F\">\n                <div class=\"txp_label\">\u500D\u901F</div>\n                <div class=\"txp_popup txp_popup_playrate txp_none\">\n                    <div class=\"txp_popup_content\"></div>\n                </div>\n            </div>\n\n            <div class=\"txp_btn txp_btn_language txp_none\" aria-label=\"\u8BED\u8A00\">\n                <div class=\"txp_label\">\u8BED\u8A00</div>\n                <div class=\"txp_popup txp_popup_language txp_none\">\n                    <div class=\"txp_popup_content\"></div>\n                </div>\n            </div>\n\n            <div class=\"txp_btn txp_btn_audio_track txp_none\" aria-label=\"\u591A\u97F3\u8F68\">\n                <div class=\"txp_label\">\u591A\u97F3\u8F68</div>\n                <div class=\"txp_popup txp_popup_audio_track txp_none\">\n                    <div class=\"txp_popup_content\"></div>\n                </div>\n            </div>\n            \n            <div class=\"txp_btn txp_btn_airplay txp_none\" aria-label=\"AirPlay\">\n                <svg class=\"txp_icon txp_icon_airplay\" viewBox=\"0 0 1024 1024\">\n                    <use class=\"txp_svg_symbol\" xlink:href=\"#txp_air_play\"></use>\n                </svg>\n                <div class=\"txp_tooltip\">AirPlay</div> \n            </div>\n\n            <div class=\"txp_btn_group\">\n                <div class=\"txp_btn txp_btn_volume txp_none\" data-status=\"normal\" aria-label=\"\u97F3\u91CF\">     \n                    <svg class=\"txp_icon txp_icon_volume\" viewBox=\"" + pcViewBox + "\">         \n                        <use class=\"txp_svg_symbol txp_svg_volume\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#txp_svg_volume\"></use> \n                        <use class=\"txp_svg_symbol txp_svg_volume_mute\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#txp_svg_volume_mute\"></use>     \n                    </svg>\n                    <div class=\"txp_popup txp_popup_volume txp_none\">\n                        <div class=\"txp_popup_content\">             \n                            <div class=\"txp_volume_text\">100</div>     \n                            <div class=\"txp_volume_range\">                 \n                                <div class=\"txp_volume_range_current\" style=\"height: 100%;\">                     \n                                    <div class=\"txp_volume_handle\"></div>                 \n                                </div>             \n                            </div>\n                        </div>\n                    </div>\n                </div>  \n                <div class=\"txp_popup txp_popup_mute_tips txp_none\">\n                    <div class=\"txp_popup_content\">\n                        <div class=\"txp_text\">\n                            \u9759\u97F3\u64AD\u653E\u4E2D\uFF0C\u70B9\u51FB\n                            <a class=\"txp_text_btn txp_btn_unmuted\">\u6062\u590D\u97F3\u91CF</a>\n                        </div>\n                        <svg class=\"txp_tips_close_btn\" viewBox=\"0 0 24 24\">\n                            <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#txp_close_btn\"></use> \n                        </svg>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"txp_btn txp_btn_pip txp_none\" data-status=\"false\" aria-label=\"\u753B\u4E2D\u753B\">   \n                <svg class=\"txp_icon txp_icon_pip\" viewBox=\"" + pcViewBox + "\">     \n                    <use class=\"txp_svg_symbol txp_svg_pip\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#txp_svg_pip\"></use>   \n                </svg>  \n                <div class=\"txp_tooltip\">\u753B\u4E2D\u753B</div> \n            </div>\n\n            <div class=\"txp_btn txp_btn_fake txp_none\" data-status=\"false\" aria-label=\"\u7F51\u9875\u5168\u5C4F\">   \n                <svg class=\"txp_icon txp_icon_fake\" viewBox=\"" + pcViewBox + "\">     \n                    <use class=\"txp_svg_symbol txp_svg_fake\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#txp_svg_fake\"></use>   \n                    <use class=\"txp_svg_symbol txp_svg_fake_true\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#txp_svg_fake\"></use>  \n                </svg>  \n                <div class=\"txp_tooltip\">\u7F51\u9875\u5168\u5C4F</div> \n            </div>\n\n            <div class=\"txp_btn txp_btn_fullscreen txp_none\" data-status=\"false\" aria-label=\"\u7CFB\u7EDF\u5168\u5C4F\">\n                <svg class=\"txp_icon txp_icon_fullscreen\" viewBox=\"" + pcViewBox + "\">     \n                    <use class=\"txp_svg_symbol txp_svg_fullscreen\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#txp_svg_fullscreen\"></use>     \n                    <use class=\"txp_svg_symbol txp_svg_fullscreen_true\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#txp_svg_fullscreen_true\"></use>   \n                </svg>\n                <div class=\"txp_tooltip\">\u5168\u5C4F</div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"" + shadowClassName.slice(1) + "\"></div>\n"; };
var h5CtrlRightDomText = "\n<button class=\"txp_btn txp_btn_playrate txp_none\" aria-label=\"\u500D\u901F\">\n    <div class=\"txp_label\">\u500D\u901F</div>\n</button>\n<button class=\"txp_btn txp_btn_definition txp_none\" data-status=\"false\" aria-label=\"\u6E05\u6670\u5EA6\">\n    <div class=\"txp_label\">\u6E05\u6670\u5EA6</div>\n</button>\n<button class=\"txp_btn txp_btn_airplay txp_none\" data-status=\"false\" aria-label=\"AirPlay\">\n    <svg class=\"txp_icon txp_icon_airplay\" viewBox=\"0 0 1024 1024\">\n        <use class=\"txp_svg_symbol\" xlink:href=\"#txp_air_play\"></use>\n    </svg>\n</button>\n<button class=\"txp_btn txp_btn_fullscreen txp_none\" data-status=\"false\" aria-label=\"\u5168\u5C4F\">\n    <svg class=\"txp_icon txp_icon_fullscreen\" viewBox=\"0 0 24 24\">\n        <use class=\"txp_svg_fullscreen\" xlink:href=\"#txp_svg_fullscreen\"></use>     \n        <use class=\"txp_svg_fullscreen_true\" xlink:href=\"#txp_svg_fullscreen_true\"></use>   \n    </svg>\n</button>\n<button class=\"txp_btn txp_btn_fullscreen txp_none txp_btn_fake\" data-status=\"false\" aria-label=\"\u4F2A\u5168\u5C4F\">\n    <svg class=\"txp_icon txp_icon_fullscreen\" viewBox=\"0 0 24 24\">\n        <use class=\"txp_svg_fullscreen\" xlink:href=\"#txp_svg_fullscreen\"></use>     \n        <use class=\"txp_svg_fullscreen_true\" xlink:href=\"#txp_svg_fullscreen_true\"></use>   \n    </svg>\n</button>\n";
var h5OverlayText = "<div class=\"plugin_ctrl_mod_overlay_wrapper\">\n<div class=\"mod_overlay definition txp_none\">\n    <div class=\"mod_speed_select\">\n        <div class=\"title\">\u753B\u8D28</div>\n        <ul class=\"select_list\"></ul>\n    </div>\n</div>\n<div class=\"mod_overlay language txp_none\">\n    <div class=\"mod_speed_select\">\n        <div class=\"title\">\u8BED\u8A00</div>\n        <ul class=\"select_list\"></ul>\n    </div>\n</div>\n<div class=\"mod_overlay playrate txp_none\">\n    <div class=\"mod_speed_select\">\n        <div class=\"title\">\u64AD\u653E\u901F\u5EA6</div>\n        <ul class=\"select_list\"></ul>\n    </div>\n</div>\n</div>\n";

var DEFAULT_AUTO_HIDE_DELAY = 3000;
/** 控制栏显隐 & 点击video暂停 */
var CtrlShow = /** @class */ (function (_super) {
    __extends(CtrlShow, _super);
    function CtrlShow(player, config, ctrlbar) {
        var _a;
        var _this = _super.call(this, player, getRootClassName(config.isMobile), config) || this;
        _this.ctrlbar = ctrlbar;
        /** 鼠标在控制栏上时，不隐藏 */
        _this.isMouseHoverControl = false;
        /** 鼠标是否在控制栏按下 */
        _this.isMouseDown = false;
        /** shadow层点击操作是否被禁用 */
        _this.shadowClickDisabled = false;
        _this.onShadowClick = function (evt) {
            if (evt.target !== _this.shadow)
                return;
            _this.clearClickTimer();
            if (_this.shadowClickDisabled)
                return;
            var actionDelay = 300;
            _this.clickTimer = window.setTimeout(function () {
                var player = _this.player;
                if (player.state === VIDEO_STATE$1.PLAYING) {
                    player.pause(H5_PAUSE_TYPE.USER_CLICK);
                }
                else {
                    onBtnClickPlay(player, _this.ctrlbar);
                }
            }, actionDelay);
        };
        _this.clearClickTimer = function () {
            if (!_this.clickTimer)
                return;
            clearTimeout(_this.clickTimer);
            _this.clickTimer = null;
        };
        _this.clearHideTimer = function () {
            if (!_this.hideTid)
                return;
            clearTimeout(_this.hideTid);
            _this.hideTid = null;
        };
        _this.clearTouchTimer = function () {
            if (!_this.touchTid)
                return;
            clearTimeout(_this.touchTid);
            _this.touchTid = null;
        };
        _this.hideDelay = config.autoHideDelay || DEFAULT_AUTO_HIDE_DELAY;
        _this.show = _this.show.bind(_this);
        _this.hide = _this.hide.bind(_this);
        _this.onFullscreenChange = _this.onFullscreenChange.bind(_this);
        _this.eventMap = (_a = {},
            _a[PLAY_EVENT$1.STATE_CHANGE] = _this.onPlayerStateChange.bind(_this),
            _a[PLAY_EVENT$1.VIDEONODE_START_PLAY] = _this.onStartPlay.bind(_this),
            _a);
        _this.setEvts();
        _this.control = player.container.querySelector(ctrlBarSelector);
        _this.shadow = player.container.querySelector(shadowClassName);
        _this.gradientBottom = player.container.querySelector(gradientClassName);
        ctrlbar.on(CTRL_EVENTS.FULLSCREEN_CHANGE, _this.onFullscreenChange);
        ctrlbar.on(CTRL_EVENTS.FAKE_FULLSCREEN_CHANGE, _this.onFullscreenChange);
        var _b = config.showCtrlShadow, showCtrlShadow = _b === void 0 ? true : _b;
        if (!showCtrlShadow) {
            _this.shadow.remove();
            _this.shadow = null;
        }
        _this.addEventListener();
        // 移动端点击切换控制栏显隐
        if (_this.isMobile) {
            _this.toggleControlOnClick();
        }
        return _this;
    }
    Object.defineProperty(CtrlShow.prototype, "isShow", {
        get: function () {
            return !this.el.classList.contains(Component.hideClassName);
        },
        enumerable: false,
        configurable: true
    });
    CtrlShow.prototype.show = function () {
        this.autoHide();
        if (this.isShow)
            return;
        this.showEl();
        this.showEl(this.gradientBottom);
        this.ctrlbar.emit(CTRL_EVENTS.SHOW);
    };
    /**
     * 隐藏控制栏
     * @param force {Boolean} 是否强制隐藏
     */
    CtrlShow.prototype.hide = function (force) {
        if (!this.isShow)
            return;
        // 鼠标在控制栏上时不隐藏 暂停时不隐藏
        if (!force && (this.isMouseHoverControl || this.player.state === VIDEO_STATE$1.PAUSE))
            return;
        this.hideEl();
        this.hideEl(this.gradientBottom);
        this.ctrlbar.emit(CTRL_EVENTS.HIDE);
    };
    /** @deprecated 不符合规范命名驼峰，建议使用 autoHide */
    CtrlShow.prototype.autohide = function () {
        this.autoHide();
    };
    CtrlShow.prototype.autoHide = function () {
        this.clearHideTimer();
        // 如果自动隐藏延时被控制为无穷大，则不自动隐藏
        if (this.hideDelay === Infinity)
            return;
        this.hideTid = window.setTimeout(this.hide, this.hideDelay);
    };
    CtrlShow.prototype.destroy = function () {
        this.clearHideTimer();
        this.clearClickTimer();
        this.clearTouchTimer();
        _super.prototype.destroy.call(this);
    };
    /** @deprecated 建议直接使用 shadowClickDisabled 设置 */
    CtrlShow.prototype.toggleShadowClickDisabled = function (disabled) {
        this.shadowClickDisabled = disabled;
    };
    CtrlShow.prototype.addEventListener = function () {
        var _this = this;
        var _a = this, ctrlbar = _a.ctrlbar, player = _a.player, shadow = _a.shadow;
        var container = player.container;
        if (!this.isMobile) {
            this.control.addEventListener('mouseenter', function () { return _this.isMouseHoverControl = true; });
            this.control.addEventListener('mouseleave', function () { return _this.isMouseHoverControl = false; });
            ctrlbar.on(CTRL_EVENTS.MOUSE_DOWN, function () { return _this.isMouseDown = true; });
            ctrlbar.on(CTRL_EVENTS.MOUSE_UP, function () { return _this.isMouseDown = false; });
            container.addEventListener('mouseenter', this.show);
            container.addEventListener('mousemove', this.show);
            container.addEventListener('mouseleave', function () {
                if (!_this.isMouseDown)
                    _this.hide();
            });
            // 点击视频播放/暂停
            if (!this.isLive && shadow) {
                shadow.addEventListener('click', this.onShadowClick);
                // 双击不暂停
                shadow.addEventListener('dblclick', this.clearClickTimer);
            }
        }
        else {
            ctrlbar.on(CTRL_EVENTS.TOGGLE_OVERLAY, function (evt) {
                var val = evt.data;
                _this.isMouseHoverControl = val;
                if (!val)
                    _this.autoHide();
            });
            ctrlbar.on(CTRL_EVENTS.MOUSE_DOWN, function () { return _this.isMouseHoverControl = true; });
            ctrlbar.on(CTRL_EVENTS.MOUSE_UP, function () {
                _this.autoHide();
                _this.isMouseHoverControl = false;
            });
        }
    };
    /** 点击浮层切换显隐 */
    CtrlShow.prototype.toggleControlOnClick = function () {
        var _this = this;
        var _a;
        // 使用click 避免点击穿透
        (_a = this.shadow) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
            if (_this.isShow)
                _this.hide();
            else
                _this.show();
        });
    };
    CtrlShow.prototype.onFullscreenChange = function () {
        this.isMouseHoverControl = false;
        this.hide();
    };
    CtrlShow.prototype.onPlayerStateChange = function (_a) {
        var data = _a.data;
        var state = data.new;
        if ([VIDEO_STATE$1.PAUSE, VIDEO_STATE$1.END, VIDEO_STATE$1.IDLE].indexOf(state) !== -1) {
            this.show();
        }
        else if (state === VIDEO_STATE$1.PLAYING) {
            this.autoHide();
        }
    };
    CtrlShow.prototype.onStartPlay = function () {
        this.autoHide();
    };
    /** 自动隐藏时间间隔 */
    CtrlShow.compName = 'CtrlShow';
    return CtrlShow;
}(Component));

/** 控制栏支持的热键列表， KeyboardEvent.key */
var HotKeyCode;
(function (HotKeyCode) {
    HotKeyCode["ArrowLeft"] = "ArrowLeft";
    HotKeyCode["ArrowRight"] = "ArrowRight";
    HotKeyCode["ArrowUp"] = "ArrowUp";
    HotKeyCode["ArrowDown"] = "ArrowDown";
    HotKeyCode["Space"] = " ";
    HotKeyCode["Escape"] = "Escape";
    HotKeyCode["LEFT_SQUARE_BRACKET"] = "[";
    HotKeyCode["LEFT_SQUARE_BRACKET_CN"] = "\u3010";
    HotKeyCode["RIGHT_SQUARE_BRACKET"] = "]";
    HotKeyCode["RIGHT_SQUARE_BRACKET_CN"] = "\u3011";
})(HotKeyCode || (HotKeyCode = {}));
/** 默认seek间隔，单位：秒 */
var defaultSeekGap = 5;
var defaultBackwardGap = 2;
var defaultActivePressTime = 0.5;
var defaultBackwardTimeout = 0.5 * 1000;
/** 直播模式下，仅允许这三种热键触发 */
var liveHotKeys = [HotKeyCode.ArrowUp, HotKeyCode.ArrowDown, HotKeyCode.Escape];
/** 音量调节间隔，总音量：1 */
var volumeGap = 0.05;
/** 键盘操作
 * 方向键上: 音量+
 * 方向键下: 音量-
 * 方向右键: 前进5s
 * 方向左键: 后退5s
 * Space 播放 or 暂停
 */
var HotKeys = /** @class */ (function () {
    function HotKeys(player, config, comps) {
        var _this = this;
        var _a;
        this.player = player;
        this.config = config;
        this.comps = comps;
        /** 是否禁用键盘操作 */
        this.isDisabled = false;
        this.spyKeyUpOnBody = function (evt) {
            if (!_this.isEvtKeyInConfig(evt))
                return;
            _this.spyKeyUp(evt);
        };
        this.spyKeyDownOnBody = function (evt) {
            if (!_this.isEvtKeyInConfig(evt))
                return;
            _this.spyKeyDown(evt);
        };
        /**
         * 连续快退，每隔一段时间往前 seek
         */
        this.fastBackwardHandler = function () {
            var player = _this.player;
            var duration = player.duration;
            _this.backwardPlaytime = player.playtime;
            var doBackward = function () {
                _this.backwardPlaytime = Math.max(0, _this.backwardPlaytime - defaultBackwardGap);
                // 假显更新下进度条
                _this.comps.progress.updateProgress(_this.backwardPlaytime / duration);
                player.seek(_this.backwardPlaytime);
                showTips(player, "\u5FEB\u9000\u81F3 " + commonTool.formatPlayTime(_this.backwardPlaytime));
            };
            _this.backwardTimer = setInterval(doBackward, defaultBackwardTimeout);
            doBackward();
        };
        /**
         * 从 PlayRate 浮层中获取快进列表，并使用下一个更高的倍速来播
         * 如当前是 1x，则使用 1.25x 播放
         */
        this.fastForwardHandler = function () {
            var _a = _this.config.pressFastForwardRate, pressFastForwardRate = _a === void 0 ? 3 : _a;
            var playRateComp = _this.comps.playRate;
            var selected = (playRateComp || {}).selected;
            // 如果快进倍速比当前播放倍速还要低，则使用当前倍速播放
            if (!selected || pressFastForwardRate <= selected)
                return;
            var fastForwardSpeed = {
                label: pressFastForwardRate + "X",
                value: pressFastForwardRate,
            };
            // 如果是暂停状态，顺便开始播放
            _this.player.play();
            // 先替换掉倍速播放浮层的倍速列表，松开后再重设回原值
            _this.lastPlaybackRate = playRateComp.selected;
            _this.player.playbackRate = pressFastForwardRate;
            showTips(_this.player, "\u6B63\u5728 <em>" + fastForwardSpeed.value + "</em> \u500D\u64AD\u653E\u4E2D");
            // 这里务必使用 setTimeout，使设置假显的操作晚于控制栏中 hookVideoRateChange 中的逻辑
            setTimeout(function () {
                playRateComp.setCurrent(fastForwardSpeed);
            }, 0);
        };
        this.spyKeyUp = this.spyKeyUp.bind(this);
        this.spyKeyDown = this.spyKeyDown.bind(this);
        var container = player.container;
        // 设置tabIndex后才能监听到key事件
        if (!uaTool.mobile) {
            container.tabIndex = -1;
        }
        // keydown会按住多次触发 keyup只触发一次
        container.addEventListener('keyup', this.spyKeyUp);
        container.addEventListener('keydown', this.spyKeyDown);
        if ((_a = this.config.keysListenedOnBody) === null || _a === void 0 ? void 0 : _a.length) {
            document.body.addEventListener('keyup', this.spyKeyUpOnBody);
            document.body.addEventListener('keydown', this.spyKeyDownOnBody);
        }
    }
    HotKeys.prototype.destroy = function () {
        var _a;
        if (!this.player)
            return;
        var container = this.player.container;
        this.cancelPressState(true);
        container.removeEventListener('keyup', this.spyKeyUp);
        container.removeEventListener('keydown', this.spyKeyDown);
        if ((_a = this.config.keysListenedOnBody) === null || _a === void 0 ? void 0 : _a.length) {
            document.body.removeEventListener('keyup', this.spyKeyUpOnBody);
            document.body.removeEventListener('keydown', this.spyKeyDownOnBody);
        }
        this.player = null;
    };
    HotKeys.prototype.isEvtKeyInConfig = function (evt) {
        return this.config.keysListenedOnBody.includes(evt.key) && evt.target === document.body;
    };
    HotKeys.prototype.prevent = function (evt) {
        var _a, _b;
        (_a = evt.preventDefault) === null || _a === void 0 ? void 0 : _a.call(evt);
        (_b = evt.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(evt);
    };
    HotKeys.prototype.spyKeyUp = function (evt) {
        var _a;
        var isShift = evt.shiftKey;
        if (isShift || this.isDisabled)
            return;
        var key = evt.key;
        var player = this.player;
        var state = player.state;
        var _b = this.config.seekGap, seekGap = _b === void 0 ? defaultSeekGap : _b;
        if (this.pressKey) {
            if (key === this.pressKey) {
                this.cancelPressState();
            }
            return;
        }
        // 如果直播模式下，按下了点播模式下才支持的热键，则什么也不做
        if (this.isLive() && !liveHotKeys.includes(key))
            return;
        switch (key) {
            case HotKeyCode.ArrowLeft:
                player.setStateKv("ctrlbar:hotkey:" + key, { type: LOG_TYPE.USER_ACTION });
                player.seek(player.playtime - seekGap);
                this.prevent(evt);
                this.showSeekLeftTips();
                break;
            case HotKeyCode.ArrowRight:
                player.setStateKv("ctrlbar:hotkey:" + key, { type: LOG_TYPE.USER_ACTION });
                player.seek(player.playtime + seekGap);
                this.prevent(evt);
                this.showSeekRightTips();
                break;
            case HotKeyCode.Space:
                player.setStateKv('ctrlbar:hotkey:space', { type: LOG_TYPE.USER_ACTION });
                if (state === VIDEO_STATE$1.PLAYING || state === VIDEO_STATE$1.BUFFERING) {
                    player.pause(H5_PAUSE_TYPE.USER_CLICK);
                }
                else {
                    player.play();
                }
                this.prevent(evt);
                break;
            case HotKeyCode.Escape:
                if ((_a = this.comps.fakeFullscreen) === null || _a === void 0 ? void 0 : _a.isFullScreen) {
                    this.comps.fakeFullscreen.requestFullScreen('exit');
                    this.prevent(evt);
                }
                break;
            case HotKeyCode.LEFT_SQUARE_BRACKET:
            case HotKeyCode.LEFT_SQUARE_BRACKET_CN:
                this.setNextPlayBackRate(true);
                this.prevent(evt);
                break;
            case HotKeyCode.RIGHT_SQUARE_BRACKET:
            case HotKeyCode.RIGHT_SQUARE_BRACKET_CN:
                this.setNextPlayBackRate(false);
                this.prevent(evt);
                break;
        }
    };
    /**
     * 选择下一个倍速选项
     * @param reverse 倍速方向，true 则选择一个更高的倍速值，否则选择更低的值
     */
    HotKeys.prototype.setNextPlayBackRate = function (reverse) {
        if (reverse === void 0) { reverse = false; }
        var playRateComp = this.comps.playRate;
        var popupOptions = playRateComp.popupOptions, selected = playRateComp.selected;
        var currentIndex = popupOptions.findIndex(function (item) { return item.value === selected; });
        // 1. 如果找不到对应倍速值，则什么也不做
        if (currentIndex === -1)
            return;
        // 2. 如果没有下一个倍速选项了，则什么也不做（比如已经是最慢的倍速了，还要再慢）
        if ((reverse && currentIndex === 0) || (!reverse && currentIndex === popupOptions.length - 1))
            return;
        // 调整播放器播放速率到对应倍速
        var nextIndex = reverse ? currentIndex - 1 : currentIndex + 1;
        var nextRate = Number(popupOptions[nextIndex].value);
        this.player.playbackRate = nextRate;
        showTips(this.player, "\u6B63\u5728 <em>" + nextRate + "</em> \u500D\u901F\u64AD\u653E\u4E2D");
    };
    /**
     * 进入长按模式
     */
    HotKeys.prototype.enterPressMode = function (isForward) {
        var _this = this;
        if (this.pressKey)
            return;
        var _a = this.config, _b = _a.pressFastBackwardGap, pressFastBackwardGap = _b === void 0 ? defaultActivePressTime : _b, _c = _a.pressFastForwardGap, pressFastForwardGap = _c === void 0 ? defaultActivePressTime : _c;
        var timeout = isForward ? pressFastForwardGap : pressFastBackwardGap;
        var handler = isForward ? this.fastForwardHandler : this.fastBackwardHandler;
        if (!timeout)
            return;
        clearTimeout(this.pressTimer);
        this.pressTimer = setTimeout(function () {
            var state = _this.player.state;
            // 仅在暂停 / 播放中才可以使用长按快捷键
            if (![VIDEO_STATE$1.PAUSE, VIDEO_STATE$1.PLAYING].includes(state))
                return;
            handler();
        }, timeout * 1000);
    };
    /** 取消长按状态 */
    HotKeys.prototype.cancelPressState = function (isDestroyed) {
        if (isDestroyed === void 0) { isDestroyed = false; }
        var playRate = this.comps.playRate;
        if (playRate && this.lastPlaybackRate) {
            playRate.selected = this.lastPlaybackRate;
            if (!isDestroyed) {
                // 如果player的Dataset插件先被destroy，下面这一行就会报错！
                // 因为设置playbackRate会调用Dataset的writeState
                this.player.playbackRate = this.lastPlaybackRate;
            }
        }
        // 取消时，立即隐藏文案
        hideTips(this.player);
        this.lastPlaybackRate = NaN;
        this.pressKey = null;
        this.backwardPlaytime = NaN;
        this.pressKey = null;
        clearTimeout(this.backwardTimer);
        clearTimeout(this.pressTimer);
    };
    HotKeys.prototype.spyKeyDown = function (evt) {
        var isShift = evt.shiftKey;
        if (isShift || this.isDisabled || this.pressKey) {
            this.prevent(evt);
            return;
        }
        // 按住不动的话keydown会持续触发
        var key = evt.key, repeat = evt.repeat;
        var player = this.player;
        // 如果直播模式下，按下了点播模式下才支持的热键，则什么也不做
        if (this.isLive() && !liveHotKeys.includes(key))
            return;
        switch (key) {
            case HotKeyCode.ArrowUp:
                player.volume = this.volumeToFixedNumber(player.volume + volumeGap);
                this.prevent(evt);
                this.showVolumeTips();
                break;
            case HotKeyCode.ArrowDown:
                player.volume = this.volumeToFixedNumber(player.volume - volumeGap);
                this.prevent(evt);
                this.showVolumeTips();
                break;
            // keydown时prevent才能禁用浏览器默认行为
            case HotKeyCode.Space:
                this.prevent(evt);
                break;
            case HotKeyCode.ArrowLeft:
            case HotKeyCode.ArrowRight:
                this.prevent(evt);
                if (repeat) {
                    this.enterPressMode(key === HotKeyCode.ArrowRight);
                    this.pressKey = key;
                }
                break;
        }
    };
    HotKeys.prototype.isLive = function () {
        return this.config.mode === PLAY_MODE.LIVE;
    };
    HotKeys.prototype.volumeToFixedNumber = function (vol) {
        var volume = Math.max(Math.min(vol, 1), 0);
        volume = Number((volume).toFixed(2));
        lsTool.setData(LOCAL_KEY.VOLUME, volume);
        return volume;
    };
    HotKeys.prototype.showSeekLeftTips = function () {
        // 播放结束后不出seek提示
        if (this.player.state === VIDEO_STATE$1.IDLE)
            return;
        var _a = this.config.seekGap, seekGap = _a === void 0 ? defaultSeekGap : _a;
        var seekLeftTime = Math.max(0, this.player.playtime - seekGap);
        showTips(this.player, "\u5FEB\u9000\u81F3 " + commonTool.formatPlayTime(seekLeftTime));
    };
    HotKeys.prototype.showSeekRightTips = function () {
        if (this.player.state === VIDEO_STATE$1.IDLE)
            return;
        var _a = this.player, playtime = _a.playtime, duration = _a.duration;
        var _b = this.config.seekGap, seekGap = _b === void 0 ? defaultSeekGap : _b;
        var seekRightTime = Math.min(playtime + seekGap, duration);
        showTips(this.player, "\u5FEB\u8FDB\u81F3 " + commonTool.formatPlayTime(seekRightTime));
    };
    HotKeys.prototype.showVolumeTips = function () {
        var _a;
        // 音量浮层出现时不出提示，避免相互遮挡
        if (!((_a = this.comps.volume) === null || _a === void 0 ? void 0 : _a.popup.classList.contains(Component.hideClassName)))
            return;
        showTips(this.player, "\u5F53\u524D\u97F3\u91CF: <em>" + (this.player.volume * 100).toFixed(0) + "</em>");
    };
    HotKeys.compName = 'HotKeys';
    return HotKeys;
}());

/** 所有控制栏子组件 */
var componentMap = {
    PlayBtn: PlayBtn,
    NextBtn: NextBtn,
    TimeArea: TimeArea,
    Progress: Progress,
    Fullscreen: Fullscreen,
    FakeFullscreen: FakeFullscreen,
    Volume: Volume,
    CtrlShow: CtrlShow,
    HotPoint: HotPoint,
    Loop: Loop,
    PictureInPicture: PictureInPicture,
    LiveProgress: LiveProgress,
    CenterBtn: CenterBtn,
    DefinitionPopup: DefinitionPopup,
    PlayratePopup: PlayratePopup,
    LanguagePopup: LanguagePopup,
    AudioTrackPopup: AudioTrackPopup,
    MuteTips: MuteTips,
};
var CtrlbarPlugin = /** @class */ (function (_super) {
    __extends(CtrlbarPlugin, _super);
    // extra用于注入msg，需要透传给父类
    function CtrlbarPlugin(player, config, extra) {
        var _a, _b, _c;
        var _d, _e, _f;
        var _this = _super.call(this, player, config, extra) || this;
        /** 控制栏子组件，当现有接口不满足需求时可以临时用它实现需求 */
        _this.instances = {};
        /** 播放器当前是否处于cgi请求中，是的话点击按钮时需要调用 triggerAutoPlay */
        _this.isInRequest = false;
        _this.hasCustomPlayBackRate = false;
        _this.config = __assign(__assign({}, player.config.ctrlConfig), config);
        var isMobile = uaTool.mobile;
        (_a = (_d = _this.config).mode) !== null && _a !== void 0 ? _a : (_d.mode = _this.player.config.type);
        // 默认从ua判断是否使用移动端的DOM和样式
        (_b = (_e = _this.config).isMobile) !== null && _b !== void 0 ? _b : (_e.isMobile = isMobile);
        // 移动端默认在开播前展示中央播放按钮
        (_c = (_f = _this.config).showCenterPlayBtn) !== null && _c !== void 0 ? _c : (_f.showCenterPlayBtn = isMobile);
        _this.setMaxListeners(20);
        _this.insertDom();
        _this.createSubComponents(extra);
        _this.setupResizeEvent();
        _this.setPluginEvts(true);
        adaptMobileAdPlugin(_this, player);
        // 如果是移动端情况下，默认只展示一个中央播放按钮，canplay 后才去展示控制栏
        if (_this.config.isMobile) {
            _this.hide(true);
        }
        if (_this.config.uiDuration) {
            _this.duration = _this.config.uiDuration;
        }
        return _this;
    }
    Object.defineProperty(CtrlbarPlugin.prototype, "duration", {
        /** 外显总时长 */
        get: function () {
            var _a;
            return (_a = this.uiDuration) !== null && _a !== void 0 ? _a : this.player.duration;
        },
        /** 外显总时长，可用于设置限播时长 */
        set: function (val) {
            if (isNaN(val) && val !== undefined)
                return;
            this.uiDuration = val;
            if (this.instances[TimeArea.compName]) {
                this.instances[TimeArea.compName].timeDur.innerText = commonTool.formatPlayTime(val);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CtrlbarPlugin.prototype, "audio", {
        // 多音轨、清晰度、多语言、倍速 按钮以及浮层设置
        get: function () {
            var _a;
            return (_a = this.instances[AudioTrackPopup.compName]) === null || _a === void 0 ? void 0 : _a.selected;
        },
        set: function (val) {
            if (!this.instances[AudioTrackPopup.compName])
                return;
            this.instances[AudioTrackPopup.compName].selected = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CtrlbarPlugin.prototype, "audioOpts", {
        get: function () {
            var _a;
            return (_a = this.instances[AudioTrackPopup.compName]) === null || _a === void 0 ? void 0 : _a.popupOptions;
        },
        set: function (val) {
            if (!this.instances[AudioTrackPopup.compName])
                return;
            this.instances[AudioTrackPopup.compName].popupOptions = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CtrlbarPlugin.prototype, "level", {
        get: function () {
            var _a;
            return (_a = this.instances[DefinitionPopup.compName]) === null || _a === void 0 ? void 0 : _a.selected;
        },
        set: function (val) {
            if (!this.instances[DefinitionPopup.compName])
                return;
            this.instances[DefinitionPopup.compName].selected = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CtrlbarPlugin.prototype, "levelOpts", {
        get: function () {
            var _a;
            return (_a = this.instances[DefinitionPopup.compName]) === null || _a === void 0 ? void 0 : _a.popupOptions;
        },
        set: function (val) {
            if (!this.instances[DefinitionPopup.compName])
                return;
            this.instances[DefinitionPopup.compName].popupOptions = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CtrlbarPlugin.prototype, "lang", {
        get: function () {
            var _a;
            return (_a = this.instances[LanguagePopup.compName]) === null || _a === void 0 ? void 0 : _a.selected;
        },
        set: function (val) {
            if (!this.instances[LanguagePopup.compName])
                return;
            this.instances[LanguagePopup.compName].selected = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CtrlbarPlugin.prototype, "langOpts", {
        get: function () {
            var _a;
            return (_a = this.instances[LanguagePopup.compName]) === null || _a === void 0 ? void 0 : _a.popupOptions;
        },
        set: function (val) {
            if (!this.instances[LanguagePopup.compName])
                return;
            this.instances[LanguagePopup.compName].popupOptions = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CtrlbarPlugin.prototype, "playrate", {
        get: function () {
            var _a;
            return (_a = this.instances[PlayratePopup.compName]) === null || _a === void 0 ? void 0 : _a.selected;
        },
        set: function (val) {
            if (!this.instances[PlayratePopup.compName])
                return;
            this.instances[PlayratePopup.compName].selected = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CtrlbarPlugin.prototype, "playrateOpts", {
        get: function () {
            var _a;
            return (_a = this.instances[PlayratePopup.compName]) === null || _a === void 0 ? void 0 : _a.popupOptions;
        },
        set: function (val) {
            if (!this.instances[PlayratePopup.compName])
                return;
            this.instances[PlayratePopup.compName].popupOptions = val;
        },
        enumerable: false,
        configurable: true
    });
    /** 获取控制栏热键禁用情况 */
    CtrlbarPlugin.prototype.getIsHotKeysDisabled = function () {
        return this.hotKeys.isDisabled;
    };
    CtrlbarPlugin.prototype.prependElementToLevels = function (el) {
        var _a, _b, _c;
        (_c = (_b = (_a = this.instances) === null || _a === void 0 ? void 0 : _a[DefinitionPopup.compName]) === null || _b === void 0 ? void 0 : _b.popup) === null || _c === void 0 ? void 0 : _c.firstElementChild.insertAdjacentElement('afterbegin', el);
    };
    /** @param force 是否强制展示，可在强制隐藏后使用 */
    CtrlbarPlugin.prototype.show = function (force) {
        if (force === void 0) { force = false; }
        this.el.classList.remove(Component.hideClassName);
        this.instances.CtrlShow.gradientBottom.classList.remove(Component.hideClassName);
        if (force) {
            this.el.style.display = '';
            this.instances.CtrlShow.gradientBottom.style.display = '';
        }
        this.emit(CTRL_EVENTS.SHOW);
    };
    /** @param force 是否强制隐藏，强制隐藏后无法唤起控制栏 */
    CtrlbarPlugin.prototype.hide = function (force) {
        if (force === void 0) { force = false; }
        this.el.classList.add(Component.hideClassName);
        this.instances.CtrlShow.gradientBottom.classList.add(Component.hideClassName);
        if (force) {
            this.el.style.display = 'none';
            this.instances.CtrlShow.gradientBottom.style.display = 'none';
        }
        this.emit(CTRL_EVENTS.HIDE);
    };
    CtrlbarPlugin.prototype.setHotKeysDisable = function (disable) {
        if (disable === void 0) { disable = true; }
        if (!this.hotKeys)
            return;
        this.hotKeys.isDisabled = !!disable;
    };
    /** 设置控制栏组件启用/禁用 `txp_disabled` */
    CtrlbarPlugin.prototype.setCompDisable = function (name, disable) {
        var _this = this;
        if (disable === void 0) { disable = true; }
        var compNameArray = Array.isArray(name) ? name : [name];
        compNameArray.forEach(function (name) {
            var _a, _b;
            if (name === 'CtrlShow') {
                _this.instances.CtrlShow.toggleShadowClickDisabled(disable);
                return;
            }
            (_b = (_a = _this.instances[name]) === null || _a === void 0 ? void 0 : _a.el) === null || _b === void 0 ? void 0 : _b.classList.toggle(Component.disabledClassName, disable);
        });
    };
    /** 设置控制栏组件展示/隐藏 `txp_none` */
    CtrlbarPlugin.prototype.setCompVisable = function (name, visible) {
        var _this = this;
        if (visible === void 0) { visible = true; }
        var compNameArray = Array.isArray(name) ? name : [name];
        compNameArray.forEach(function (name) {
            var _a, _b;
            (_b = (_a = _this.instances[name]) === null || _a === void 0 ? void 0 : _a.el) === null || _b === void 0 ? void 0 : _b.classList.toggle(Component.hideClassName, !visible);
        });
    };
    /** 删除控制栏上的组件dom */
    CtrlbarPlugin.prototype.removeComponent = function (comp) {
        var _a, _b;
        (_b = (_a = this.instances[comp]) === null || _a === void 0 ? void 0 : _a.el) === null || _b === void 0 ? void 0 : _b.remove();
    };
    /** 销毁所有组件 */
    CtrlbarPlugin.prototype.destroy = function () {
        var _a, _b;
        this.setPluginEvts(false);
        this.callAllComponents('destroy');
        if ((_a = this.el) === null || _a === void 0 ? void 0 : _a.parentNode)
            this.el.remove();
        this.el = null;
        (_b = this.hotKeys) === null || _b === void 0 ? void 0 : _b.destroy();
        _super.prototype.destroy.call(this);
    };
    CtrlbarPlugin.prototype.hookVideoCanplay = function () {
        // 移动端下当 canplay 时，重新展示控制栏
        if (this.config.isMobile) {
            this.show(true);
        }
    };
    CtrlbarPlugin.prototype.hookAdReqInfoStart = function () {
        this.isInRequest = true;
    };
    CtrlbarPlugin.prototype.hookAdReqInfoEnd = function () {
        this.isInRequest = false;
    };
    CtrlbarPlugin.prototype.hookVideoReqInfoStart = function () {
        this.isInRequest = true;
    };
    CtrlbarPlugin.prototype.hookVideoReqInfoEnd = function () {
        this.isInRequest = false;
    };
    CtrlbarPlugin.prototype.hookVideoRateChange = function (param) {
        var _a;
        var rate = param.rate;
        // 1. 设置的倍速值不在控制栏提供的下拉选项中
        if (!((_a = this.playrateOpts) === null || _a === void 0 ? void 0 : _a.find(function (v) { return Number(v.value) === rate; }))) {
            var curPlaybackOpts = __spreadArray([], (this.playrateOpts || []), true);
            // 如果是被热键触发的（如长按方向右快进），则什么也不做
            if (this.hotKeys.pressKey)
                return;
            // 如果设置过外显，先把上次设置的外显选项去掉，重新设置下
            if (this.hasCustomPlayBackRate) {
                curPlaybackOpts = this.deleteCustomPlaybackRate(curPlaybackOpts);
            }
            // 外显为 “自定义” 倍速文案
            this.playrateOpts = __spreadArray([this.getCustomPlaybackRate(rate)], curPlaybackOpts, true);
            this.hasCustomPlayBackRate = true;
            this.playrate = rate;
            return;
        }
        // 2. 否则，设置的倍速值是在选项中，先把自定义的倍速文案移除
        if (this.hasCustomPlayBackRate) {
            this.hasCustomPlayBackRate = false;
            this.playrateOpts = this.deleteCustomPlaybackRate(this.playrateOpts);
        }
        // 再设置外显倍速值
        this.playrate = rate;
    };
    // 首次开播后解锁蒙层
    CtrlbarPlugin.prototype.hookVideoPlaying = function (param) {
        var _a;
        if (param.isFirst) {
            (_a = this.instances.CtrlShow.shadow) === null || _a === void 0 ? void 0 : _a.classList.remove(Component.hideClassName);
        }
    };
    CtrlbarPlugin.prototype.hookPlaySessionEnd = function (e) {
        this.callAllComponents('hookPlaySessionEnd', e);
    };
    CtrlbarPlugin.prototype.onFlowNodeStart = function (e) {
        this.callAllComponents('hookFlowNodeStart', e);
    };
    /**
     * 调用所有组件的同类方法
     * @param funcName 方法名
     */
    CtrlbarPlugin.prototype.callAllComponents = function (funcName) {
        var _this = this;
        var funcArgs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            funcArgs[_i - 1] = arguments[_i];
        }
        // 因为 popup 可能会被挂在 instances 变量上两次（popupName / compName）
        // 因此这里做一个筛选，防止 API 在 popup 上被调用两次
        var compMap = {};
        Object.keys(this.instances).forEach(function (key) {
            try {
                var instance = _this.instances[key];
                if (compMap[instance.compName])
                    return;
                compMap[instance.compName] = true;
                if (typeof instance[funcName] === 'function') {
                    instance[funcName].apply(instance, funcArgs);
                }
            }
            catch (err) {
                _this.error("ctrlbar " + funcName + " err: ", err);
            }
        });
    };
    CtrlbarPlugin.prototype.setPluginEvts = function (value) {
        var _this = this;
        if (!this.pluginMsgEvtMap) {
            this.pluginMsgEvtMap = {
                // 枚举为H5_EXT_EVENT.FLOW_NODE_START，播放器没发布暂无枚举
                FLOW_NODE_START: this.onFlowNodeStart.bind(this),
            };
        }
        var method = value ? this.msg.on : this.msg.off;
        Object.keys(this.pluginMsgEvtMap).forEach(function (evt) {
            method.call(_this.msg, evt, _this.pluginMsgEvtMap[evt]);
        });
    };
    /**
     * 根据倍速值，获取需要假显的倍速选项配置
     * @param rate 倍速值
     * @returns 倍速选项配置
     */
    CtrlbarPlugin.prototype.getCustomPlaybackRate = function (rate) {
        return {
            value: rate,
            label: "\u81EA\u5B9A\u4E49\uFF08" + rate + "x\uFF09",
            btnLabel: rate + "x",
            payload: { customOpt: true },
        };
    };
    /**
     * 去掉自定义的 playbackRate 选项
     * @param items 倍速选项列表
     * @returns 删除后的倍速选项列表，新数组
     */
    CtrlbarPlugin.prototype.deleteCustomPlaybackRate = function (items) {
        return items.filter(function (item) { var _a; return ((_a = item.payload) === null || _a === void 0 ? void 0 : _a.customOpt) !== true; });
    };
    /** 插入dom */
    CtrlbarPlugin.prototype.insertDom = function () {
        var container = this.player.container;
        var isMobile = this.config.isMobile;
        // 设置播放容器全屏样式
        container.classList.add(containerClassName);
        // 插入dom和style以及svg雪碧图
        container.insertAdjacentHTML('beforeend', getDomText(isMobile));
        var cssString = isMobile ? css_248z : css_248z$1;
        domTool.insertStyle(cssString, CtrlbarPlugin.styleDataTag);
        var rootClassName = getRootClassName(isMobile);
        this.el = container.querySelector(rootClassName);
        var svg = document.querySelector(svgSpriteSelector);
        if (!svg) {
            document.body.insertAdjacentHTML('afterbegin', isMobile ? h5SvgSprite : svgSprite);
        }
        // h5播放器dom和pc有些差异，要额外调整一下
        if (isMobile) {
            // dom结构
            this.el.innerHTML = this.el.querySelector(ctrlBarSelector).innerHTML;
            // 右侧控制栏
            container.querySelector(rootClassName + " .txp_right_controls").innerHTML = h5CtrlRightDomText;
            // h5选择列表浮层
            container.insertAdjacentHTML('beforeend', h5OverlayText);
        }
    };
    /** 创建子组件 */
    CtrlbarPlugin.prototype.createSubComponents = function (extra) {
        this.initComps(extra);
        if (!this.config.disableHotKey) {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            var _a = this.instances, Volume_1 = _a.Volume, FakeFullscreen_1 = _a.FakeFullscreen, PlayratePopup_1 = _a.PlayratePopup, Progress_1 = _a.Progress;
            this.hotKeys = new HotKeys(this.player, this.config, {
                volume: Volume_1,
                fakeFullscreen: FakeFullscreen_1,
                playRate: PlayratePopup_1,
                progress: Progress_1,
            });
        }
    };
    /** 选择并初始化组件
     * 所有组件的dom初始都是隐藏的，在组件初始化时展示（浮层除外，要等设置之后才展示）
     */
    CtrlbarPlugin.prototype.initComps = function (extra) {
        var _this = this;
        var config = this.config;
        var isMobile = config.isMobile, customComps = config.comps, removeComps = config.removeComps;
        var isLive = this.config.mode === 'live';
        var defaultComps = !isLive ? [
            PlayBtn,
            TimeArea,
            Progress,
            Fullscreen,
            HotPoint,
            Loop,
            NextBtn,
            FakeFullscreen,
            Volume,
            MuteTips,
            PictureInPicture,
            CenterBtn,
            AirPlayBtn,
            CtrlShow,
            DefinitionPopup,
            LanguagePopup,
            PlayratePopup,
            AudioTrackPopup,
        ] : [
            PlayBtn,
            Fullscreen,
            FakeFullscreen,
            LiveProgress,
            Volume,
            CenterBtn,
            AirPlayBtn,
            CtrlShow,
            DefinitionPopup,
        ];
        var readyCompClasses = [];
        if (customComps === null || customComps === void 0 ? void 0 : customComps.length) {
            // 创建自定义组件
            readyCompClasses = customComps.map(function (name) { return componentMap[name]; });
            if (readyCompClasses.indexOf(CtrlShow) === -1) {
                // 看老的逻辑，CtrlShow无论如何得初始化，即使是自定义Comps列表
                readyCompClasses.push(CtrlShow);
            }
        }
        else {
            // 创建基础comps组件
            readyCompClasses = readyCompClasses.concat(defaultComps);
            readyCompClasses = readyCompClasses.filter(function (Comp) {
                // 排除开用户想移除的插件
                var isNeedRemove = removeComps ? removeComps.indexOf(Comp.compName) !== -1 : false;
                // 检查每个插件是否可以开启
                var isEnabled = Comp.isEnabled(config);
                return !isNeedRemove && isEnabled;
            });
        }
        this.log("readyCompClasses=" + readyCompClasses.map(function (Comp) { return Comp.compName; }));
        readyCompClasses.forEach(function (Comp) {
            var comp = new Comp(_this.player, config, _this, extra);
            _this.instances[Comp.compName] = comp;
            // 如果是浮层的话，额外做一个兼容，把之前的名称也挂上
            if (comp instanceof Popup) {
                _this.instances[comp.popupName] = comp;
            }
        });
        // 直播样式修改
        if (isLive && isMobile)
            this.el.style.justifyContent = 'space-between';
    };
    /** 监听全屏变化事件，广播resize */
    CtrlbarPlugin.prototype.setupResizeEvent = function () {
        var _this = this;
        var onCtrlResize = function (param) {
            var isEnter = param.data;
            _this.player.container.classList.toggle(largeSizeClassName, isEnter);
            _this.emit(CTRL_EVENTS.RESIZE, { size: isEnter ? CTRL_SIZE.LARGE : CTRL_SIZE.NORMAL });
        };
        this.on(CTRL_EVENTS.FULLSCREEN_CHANGE, function (param) {
            var _a;
            var isEnter = param.data;
            // 退出全屏时如果处于伪全屏，则不广播resize事件
            if (!isEnter && ((_a = _this.instances.FakeFullscreen) === null || _a === void 0 ? void 0 : _a.isFullScreen))
                return;
            onCtrlResize(param);
        });
        this.on(CTRL_EVENTS.FAKE_FULLSCREEN_CHANGE, function (param) {
            var _a;
            var isEnter = param.data;
            // 进入伪全屏后给 body 设置 overflow: hidden
            document.body.classList.toggle(bodyOverflowClassName, isEnter);
            // 退出伪全屏时如果处于系统全屏，则不广播resize事件。
            if (!isEnter && ((_a = _this.instances.Fullscreen) === null || _a === void 0 ? void 0 : _a.isFullScreen))
                return;
            onCtrlResize(param);
        });
        if (uaTool.mobile) {
            // 进入伪全屏后禁止滑动
            this.player.container.addEventListener('touchmove', function (evt) {
                var _a;
                if ((_a = _this.instances.FakeFullscreen) === null || _a === void 0 ? void 0 : _a.isFullScreen) {
                    evt.preventDefault();
                }
            });
        }
    };
    CtrlbarPlugin.pluginName = CtrlbarPluginName;
    /** style标签的data-tag属性 */
    CtrlbarPlugin.styleDataTag = 'thumb-ctrlbar-style';
    return CtrlbarPlugin;
}(Plugin));

H5Player.registerPlugin(CtrlbarPlugin.pluginName, CtrlbarPlugin);

export { CTRL_EVENTS, CTRL_SIZE, CtrlbarPlugin, HOTPOINT_TIP_TYPE, PlayBtnStatus };
